(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9603],{

/***/ 51704:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(52153);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 52153:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 54073:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(29259),
    now = __webpack_require__(61100),
    toNumber = __webpack_require__(7642);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ 16951:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isNumber = __webpack_require__(80537);

/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */
function isNaN(value) {
  // An `NaN` primitive is the only value that is not equal to itself.
  // Perform the `toStringTag` check first to avoid errors with some
  // ActiveX objects in IE.
  return isNumber(value) && value != +value;
}

module.exports = isNaN;


/***/ }),

/***/ 80537:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(53366),
    isObjectLike = __webpack_require__(15125);

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && baseGetTag(value) == numberTag);
}

module.exports = isNumber;


/***/ }),

/***/ 61100:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(37772);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ 7642:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(51704),
    isObject = __webpack_require__(29259),
    isSymbol = __webpack_require__(4795);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 68389:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search",
      function () {
        return __webpack_require__(38805);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 34766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44376);


var FavoriteStar = function(param) {
    var _size = param.size, size = _size === void 0 ? 16 : _size, _color = param.color, color = _color === void 0 ? _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* ["default"].color.gray600 */ .Z.color.gray600 : _color, _fullColor = param.fullColor, fullColor = _fullColor === void 0 ? _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* ["default"].color.gray600 */ .Z.color.gray600 : _fullColor, _empty = param.empty, empty = _empty === void 0 ? false : _empty;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#clip0_2330_43927)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: empty ? "M7.91106 0.314532C7.74268 0.32419 7.58355 0.366481 7.43068 0.442187C7.20803 0.552452 7.04363 0.695505 6.9091 0.896036C6.86333 0.964254 6.84128 1.00828 5.86564 2.97924C5.42307 3.87332 5.05767 4.60802 5.05365 4.6119C5.04964 4.61578 4.16507 4.74903 3.08795 4.90802C2.01083 5.06701 1.09929 5.20267 1.06231 5.20951C0.936279 5.23282 0.844906 5.26371 0.726346 5.3231C0.598595 5.38709 0.494653 5.46221 0.384727 5.56999C0.0911394 5.85785 -0.0507422 6.2975 0.0189666 6.70334C0.0626146 6.95746 0.160624 7.16594 0.323939 7.35207C0.358704 7.39169 1.01643 8.03061 1.78555 8.7719C2.55467 9.51318 3.19769 10.1332 3.21449 10.1497L3.24503 10.1797L2.90631 12.1635C2.72002 13.2545 2.56459 14.1717 2.56089 14.2016C2.5373 14.3928 2.55228 14.5633 2.60868 14.7456C2.67085 14.9467 2.77197 15.1205 2.91182 15.2666C3.1785 15.5453 3.53678 15.692 3.91675 15.6782C4.11792 15.6709 4.28084 15.6292 4.46075 15.5392C4.50123 15.5189 5.3141 15.0902 6.26713 14.5865L7.99991 13.6708L9.73273 14.5867C10.6858 15.0905 11.5054 15.5222 11.5541 15.5461C11.9315 15.7311 12.3778 15.7235 12.7477 15.5259C13.2324 15.267 13.5058 14.7433 13.439 14.2016C13.4353 14.1717 13.2799 13.2646 13.0936 12.1858L12.7549 10.2243L12.9646 10.0155C13.08 9.90068 13.7287 9.2567 14.4063 8.58446C15.0953 7.90093 15.6567 7.339 15.6799 7.30955C15.869 7.07017 15.9677 6.78789 15.9679 6.48603C15.968 6.23634 15.8915 5.98249 15.752 5.77067C15.5764 5.5038 15.2954 5.30113 14.9951 5.22468C14.9168 5.20473 15.006 5.21825 12.8255 4.8958C11.7959 4.74354 10.9502 4.61578 10.9462 4.6119C10.9422 4.60802 10.5754 3.87044 10.131 2.97284C9.1534 0.997879 9.13658 0.964299 9.09079 0.896036C8.95538 0.69418 8.78953 0.550347 8.56635 0.441195C8.41248 0.365937 8.2555 0.323665 8.10342 0.316529C8.06235 0.314596 8.02155 0.312254 8.01275 0.311319C8.00395 0.310385 7.95819 0.311831 7.91106 0.314532ZM7.39216 3.06404C6.20894 5.45339 6.2525 5.36649 6.1965 5.44964C6.11188 5.57526 6.0323 5.65907 5.90768 5.75377C5.75749 5.8679 5.56506 5.95418 5.38795 5.98679C5.35847 5.99222 4.4777 6.12351 3.43068 6.27855C2.38367 6.43358 1.52606 6.56139 1.52487 6.56257C1.5237 6.56375 2.1269 7.14747 2.86533 7.85973C4.32652 9.26912 4.31968 9.26245 4.37228 9.32854C4.56471 9.57031 4.67095 9.8905 4.65665 10.1856C4.65444 10.2314 4.64865 10.2962 4.64379 10.3296C4.63894 10.3631 4.48907 11.244 4.31076 12.2873C4.13244 13.3306 3.9874 14.1878 3.98844 14.1922C3.98961 14.1971 4.63524 13.8591 5.64795 13.3236C6.55963 12.8414 7.34587 12.4271 7.39515 12.403C7.5947 12.3052 7.77859 12.2624 7.99995 12.2624C8.2213 12.2624 8.40334 12.3048 8.60475 12.4031C8.65403 12.4272 9.44027 12.8414 10.3519 13.3235C11.2954 13.8225 12.0103 14.197 12.0114 14.1927C12.0123 14.1886 11.8664 13.3357 11.687 12.2974C11.5077 11.2591 11.3579 10.3879 11.3543 10.3614C11.3063 10.0123 11.4062 9.65112 11.6277 9.37334C11.6774 9.31095 11.6864 9.30197 13.1487 7.85212C13.8633 7.14368 14.4487 6.56243 14.4495 6.56045C14.4504 6.55846 13.7045 6.44634 12.7919 6.31129C10.4506 5.96478 10.5983 5.98742 10.5079 5.96141C10.3641 5.92 10.2417 5.86078 10.1183 5.77289C9.99076 5.68198 9.89579 5.58512 9.80574 5.45405C9.75464 5.37967 9.72755 5.32562 8.60132 3.05124C8.27232 2.38685 8.0017 1.84325 7.99993 1.84324C7.99816 1.84324 7.72467 2.39259 7.39216 3.06404Z" : "M7.9999 0.316406C7.77312 0.316406 7.55107 0.381284 7.35998 0.503381C7.17131 0.623918 7.02058 0.795253 6.92506 0.997602L5.11071 4.66056C5.10714 4.66776 5.10372 4.67503 5.10047 4.68238C5.09966 4.6842 5.09838 4.68578 5.09676 4.68696C5.09515 4.68814 5.09327 4.68888 5.09128 4.6891C5.08432 4.68986 5.07737 4.69077 5.07044 4.69179L1.07549 5.28364C0.85469 5.30511 0.64413 5.38797 0.46777 5.52305C0.285287 5.66284 0.147251 5.85253 0.070382 6.06916C-0.00648674 6.28578 -0.0188903 6.52006 0.0346744 6.7436C0.0880316 6.96626 0.204567 7.16877 0.370243 7.32677L3.29456 10.1483L3.30122 10.1546C3.30539 10.1585 3.30854 10.1634 3.31034 10.1688C3.31215 10.1742 3.31257 10.18 3.31156 10.1856L3.31092 10.1894L2.61408 14.2675C2.57579 14.4886 2.60003 14.7169 2.68439 14.9247C2.76886 15.1329 2.91007 15.3131 3.09193 15.445C3.2738 15.5768 3.48903 15.655 3.71312 15.6705C3.93676 15.6861 4.16028 15.6386 4.35834 15.5337L4.35954 15.533L7.95895 13.6307C7.97185 13.6251 7.9858 13.6222 7.99992 13.6222C8.01403 13.6222 8.02798 13.6251 8.04089 13.6307L11.6402 15.533C11.8384 15.6383 12.0629 15.6862 12.2866 15.6705C12.5108 15.655 12.726 15.5768 12.9079 15.445C13.0897 15.3131 13.231 15.1329 13.3154 14.9247C13.3998 14.7169 13.4241 14.4897 13.386 14.2688L13.3857 14.2675L12.6889 10.1894L12.6882 10.1856C12.6872 10.18 12.6877 10.1742 12.6895 10.1688C12.6912 10.1634 12.6944 10.1585 12.6985 10.1546L12.7053 10.1483L15.6296 7.32673C15.7952 7.16873 15.9118 6.96625 15.9652 6.7436C16.0186 6.52006 16.0063 6.28578 15.9294 6.06916C15.8526 5.85253 15.7145 5.66284 15.532 5.52305C15.3557 5.38797 15.1452 5.30511 14.9244 5.28364L10.9294 4.69179C10.9224 4.69077 10.9155 4.68986 10.9085 4.6891C10.9065 4.68888 10.9046 4.68814 10.903 4.68696C10.9014 4.68578 10.9001 4.6842 10.8993 4.68238C10.8961 4.67503 10.8927 4.66776 10.8891 4.66056L9.07473 0.997586C8.97921 0.795244 8.82848 0.623915 8.63983 0.503381C8.44872 0.381284 8.22667 0.316406 7.9999 0.316406Z",
                    fill: empty ? color : fullColor
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_2330_43927",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FavoriteStar);


/***/ }),

/***/ 94781:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44376);



var IconLocationPinMono = function(param) {
    var _size = param.size, size = _size === void 0 ? 14 : _size, _fill = param.fill, fill = _fill === void 0 ? _styles_theme__WEBPACK_IMPORTED_MODULE_2__/* ["default"].color.blue500 */ .Z.color.blue500 : _fill;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 14 14",
        fill: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.00042 7.43283C6.79 7.43687 6.58088 7.39892 6.3853 7.32118C6.18972 7.24345 6.0116 7.1275 5.86136 6.98012C5.71112 6.83274 5.59178 6.65688 5.5103 6.46282C5.42883 6.26877 5.38687 6.06042 5.38687 5.84996C5.38687 5.6395 5.42883 5.43115 5.5103 5.2371C5.59178 5.04304 5.71112 4.86718 5.86136 4.7198C6.0116 4.57241 6.18972 4.45647 6.3853 4.37873C6.58088 4.301 6.79 4.26304 7.00042 4.26708C7.41497 4.27504 7.80984 4.44531 8.1002 4.74129C8.39055 5.03727 8.5532 5.43534 8.5532 5.84996C8.5532 6.26458 8.39055 6.66265 8.1002 6.95863C7.80984 7.25461 7.41497 7.42488 7.00042 7.43283ZM5.76142 0.604918C3.27059 1.16083 1.52409 3.50525 1.62209 6.05558C1.69909 8.05875 2.92817 9.85075 6.58509 13.3665C6.81609 13.5882 7.18592 13.5893 7.41751 13.3671C11.1998 9.73117 12.3852 7.93917 12.3852 5.84967C12.3852 2.47217 9.27426 -0.179082 5.76142 0.605501",
            fill: fill
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IconLocationPinMono);


/***/ }),

/***/ 75528:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);

var Phone = function(param) {
    var _fill = param.fill, fill = _fill === void 0 ? "#FD7E14" : _fill, _size = param.size, size = _size === void 0 ? 12 : _size;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 12 12",
        fill: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
            id: "call",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                    id: "mask0_1975_37498",
                    maskUnits: "userSpaceOnUse",
                    x: "0",
                    y: "0",
                    width: "12",
                    height: "12",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        id: "Bounding box",
                        width: "12",
                        height: "12",
                        fill: "#D9D9D9"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                    mask: "url(#mask0_1975_37498)",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        id: "call_2",
                        d: "M10.3542 11C9.19676 11 8.05324 10.7477 6.92361 10.2431C5.79398 9.73843 4.7662 9.02315 3.84028 8.09722C2.91435 7.1713 2.19907 6.14352 1.69444 5.01389C1.18981 3.88426 0.9375 2.74074 0.9375 1.58333C0.9375 1.41667 0.993056 1.27778 1.10417 1.16667C1.21528 1.05556 1.35417 1 1.52083 1H3.77083C3.90046 1 4.0162 1.04398 4.11806 1.13194C4.21991 1.21991 4.28009 1.32407 4.29861 1.44444L4.65972 3.38889C4.67824 3.53704 4.67361 3.66204 4.64583 3.76389C4.61806 3.86574 4.56713 3.9537 4.49306 4.02778L3.14583 5.38889C3.33102 5.73148 3.55093 6.0625 3.80556 6.38194C4.06019 6.70139 4.34028 7.00926 4.64583 7.30556C4.93287 7.59259 5.2338 7.8588 5.54861 8.10417C5.86343 8.34954 6.19676 8.57407 6.54861 8.77778L7.85417 7.47222C7.9375 7.38889 8.0463 7.32639 8.18056 7.28472C8.31482 7.24306 8.44676 7.23148 8.57639 7.25L10.4931 7.63889C10.6227 7.67593 10.7292 7.74306 10.8125 7.84028C10.8958 7.9375 10.9375 8.0463 10.9375 8.16667V10.4167C10.9375 10.5833 10.8819 10.7222 10.7708 10.8333C10.6597 10.9444 10.5208 11 10.3542 11Z",
                        fill: fill
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Phone);


/***/ }),

/***/ 70691:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44376);


var Delete = function(param) {
    var _size = param.size, size = _size === void 0 ? 16 : _size, _color = param.color, color = _color === void 0 ? _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* ["default"].color.gray600 */ .Z.color.gray600 : _color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        fill: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M8 8.93333L6.06666 10.8667C5.94444 10.9889 5.78889 11.05 5.6 11.05C5.41111 11.05 5.25555 10.9889 5.13333 10.8667C5.01111 10.7444 4.95 10.5889 4.95 10.4C4.95 10.2111 5.01111 10.0555 5.13333 9.93333L7.06666 7.99999L5.13333 6.08333C5.01111 5.9611 4.95 5.80555 4.95 5.61666C4.95 5.42777 5.01111 5.27222 5.13333 5.14999C5.25555 5.02777 5.41111 4.96666 5.6 4.96666C5.78889 4.96666 5.94444 5.02777 6.06666 5.14999L8 7.08333L9.91666 5.14999C10.0389 5.02777 10.1944 4.96666 10.3833 4.96666C10.5722 4.96666 10.7278 5.02777 10.85 5.14999C10.9833 5.28333 11.05 5.44166 11.05 5.62499C11.05 5.80833 10.9833 5.9611 10.85 6.08333L8.91666 7.99999L10.85 9.93333C10.9722 10.0555 11.0333 10.2111 11.0333 10.4C11.0333 10.5889 10.9722 10.7444 10.85 10.8667C10.7167 11 10.5583 11.0667 10.375 11.0667C10.1917 11.0667 10.0389 11 9.91666 10.8667L8 8.93333Z",
            fill: color
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Delete);


/***/ }),

/***/ 10211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);

var Star = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#clip0_662_5056)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M6.99991 0.276855C6.80148 0.276855 6.60719 0.333623 6.43998 0.440458C6.2749 0.545929 6.14301 0.695847 6.05943 0.872902L4.47187 4.07799C4.46875 4.08429 4.46576 4.09065 4.46291 4.09708C4.4622 4.09867 4.46108 4.10006 4.45967 4.10109C4.45826 4.10212 4.45661 4.10277 4.45487 4.10296C4.44878 4.10363 4.4427 4.10442 4.43664 4.10532L0.941057 4.62318C0.747853 4.64197 0.563613 4.71447 0.409298 4.83267C0.249626 4.95498 0.128844 5.12096 0.0615843 5.31051C-0.0056759 5.50006 -0.016529 5.70505 0.0303401 5.90065C0.0770277 6.09548 0.178996 6.27267 0.323962 6.41092L2.88274 8.87974L2.88857 8.88527C2.89222 8.88869 2.89497 8.89296 2.89655 8.89771C2.89813 8.90245 2.8985 8.90752 2.89762 8.91244L2.89706 8.91571L2.28732 12.4841C2.25382 12.6775 2.27503 12.8773 2.34884 13.0591C2.42275 13.2413 2.54631 13.399 2.70544 13.5144C2.86458 13.6297 3.0529 13.6981 3.24898 13.7117C3.44467 13.7253 3.64025 13.6838 3.81355 13.592L3.8146 13.5914L6.96408 11.9269C6.97537 11.922 6.98758 11.9194 6.99993 11.9194C7.01228 11.9194 7.02448 11.922 7.03578 11.9269L10.1852 13.5914C10.3586 13.6835 10.555 13.7254 10.7508 13.7117C10.9469 13.6981 11.1352 13.6297 11.2944 13.5144C11.4535 13.399 11.5771 13.2413 11.651 13.0591C11.7248 12.8773 11.7461 12.6785 11.7127 12.4852L11.7125 12.4841L11.1028 8.9157L11.1022 8.91244C11.1013 8.90752 11.1017 8.90245 11.1033 8.89771C11.1048 8.89297 11.1076 8.88869 11.1112 8.88527L11.1171 8.87974L13.6759 6.41089C13.8208 6.27264 13.9228 6.09547 13.9695 5.90065C14.0163 5.70505 14.0055 5.50006 13.9382 5.31051C13.871 5.12096 13.7502 4.95498 13.5905 4.83267C13.4362 4.71447 13.252 4.64197 13.0588 4.62318L9.56319 4.10532C9.55713 4.10442 9.55105 4.10363 9.54496 4.10296C9.54322 4.10277 9.54156 4.10212 9.54015 4.10109C9.53874 4.10006 9.53763 4.09867 9.53692 4.09708C9.53407 4.09065 9.53108 4.08429 9.52796 4.07799L7.94039 0.872888C7.85681 0.695839 7.72492 0.545925 7.55985 0.440458C7.39263 0.333623 7.19834 0.276855 6.99991 0.276855Z",
                    fill: "#FCC419"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_662_5056",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "14",
                        height: "14",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Star);


/***/ }),

/***/ 9558:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75190);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89961);
/* harmony import */ var _utils_logger__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78287);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var ClickEventLogger = function(param) {
    var children = param.children, eventName = param.eventName, pageName = param.pageName, payload = param.payload;
    var onClickEventLog = function() {
        (0,_utils_logger__WEBPACK_IMPORTED_MODULE_3__/* .mobileLogger */ .Pp)({
            logger: {
                eventName: eventName,
                pageName: pageName,
                payload: payload
            }
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        role: "button",
        onClick: onClickEventLog,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ClickEventLogger);
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-162aaa7b-0"
})(_templateObject());


/***/ }),

/***/ 18163:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_InfiniteScroll; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(75190);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
;// CONCATENATED MODULE: ./src/components/common/InfiniteScroll/styles.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  //overflow-y: scroll;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var InfiniteScrollContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-d3f94304-0"
})(_templateObject());

// EXTERNAL MODULE: ./src/components/molecules/Loader/index.tsx + 1 modules
var Loader = __webpack_require__(6505);
// EXTERNAL MODULE: ./src/hooks/useIntersectionObserver.tsx
var useIntersectionObserver = __webpack_require__(13041);
;// CONCATENATED MODULE: ./src/components/common/InfiniteScroll/index.tsx





var InfiniteScroll = function(param) {
    var _threshold = param.threshold, threshold = _threshold === void 0 ? 0 : _threshold, rootMargin = param.rootMargin, children = param.children, _loader = param.loader, loader = _loader === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {}) : _loader, isLoading = param.isLoading, hasNextPage = param.hasNextPage, fetchNextPage = param.fetchNextPage;
    var ref = (0,react.useState)(), loaderElement = ref[0], setLoaderElement = ref[1];
    var entry = (0,useIntersectionObserver/* default */.Z)({
        target: loaderElement,
        threshold: threshold,
        rootMargin: rootMargin
    });
    (0,react.useEffect)(function() {
        if ((entry === null || entry === void 0 ? void 0 : entry.isIntersecting) && hasNextPage && !isLoading) {
            fetchNextPage();
        }
    }, [
        entry,
        hasNextPage,
        isLoading,
        fetchNextPage
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfiniteScrollContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: children
            }),
            hasNextPage && !isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: function(ref) {
                    return setLoaderElement(ref);
                },
                children: loader
            })
        ]
    });
};
/* harmony default export */ var common_InfiniteScroll = (InfiniteScroll);


/***/ }),

/***/ 75275:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75190);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89961);
/* harmony import */ var _constants_zIndex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31591);
/* harmony import */ var _types_app__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9912);
/* harmony import */ var _types_header__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37072);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n\n  & > * {\n    &:first-child {\n    }\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: ",
        ";\n  z-index: 200;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-direction: column;\n  width: 100%;\n  top: 0;\n\n  ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          top: ",
        "px;\n        "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          top: 0px;\n        "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-direction: column;\n  width: 100%;\n  z-index: ",
        ";\n  position: sticky;\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  z-index: ",
        ";\n  position: sticky;\n  bottom: 0;\n  padding: 32px 20px 20px;\n  background-color: ",
        ";\n  background: linear-gradient(\n    180deg,\n    rgba(255, 255, 255, 0) 0%,\n    rgba(255, 255, 255, 1) 30%,\n    rgba(255, 255, 255, 1) 100%\n  );\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}






var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-3f906778-0"
})(_templateObject());
var TemplateHeader = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].header.withConfig */ .ZP.header.withConfig({
    componentId: "sc-3f906778-1"
})(_templateObject1(), function(param) {
    var position = param.position;
    return position ? position : "sticky";
}, function(param) {
    var theme = param.theme, useSafeArea = param.useSafeArea;
    return "\n      background-color: ".concat(theme.color.white, ";\n      border: 0px solid ").concat(useSafeArea ? "red" : "green", ";\n  ");
}, function(param) {
    var theme = param.theme, useSafeArea = param.useSafeArea, height = param.height;
    var _client = theme.client, clientType = _client.clientType, isAndroid = _client.isAndroid;
    var headerHeight = height !== null && height !== void 0 ? height : 60;
    switch(clientType){
        case _types_app__WEBPACK_IMPORTED_MODULE_3__/* .ClientType.MOBILE_WEBVIEW */ .B.MOBILE_WEBVIEW:
            if (isAndroid) {
                return "\n            height: ".concat(headerHeight, "px;\n          ");
            }
            return "\n          height: ".concat(useSafeArea ? headerHeight : 100, "px;\n        ");
        case _types_app__WEBPACK_IMPORTED_MODULE_3__/* .ClientType.WEB */ .B.WEB:
            return "\n          height: ".concat(headerHeight, "px;\n        ");
        case _types_app__WEBPACK_IMPORTED_MODULE_3__/* .ClientType.MOBILE_WEB */ .B.MOBILE_WEB:
            return "\n          height: ".concat(headerHeight, "px;\n          top: 60px;\n        ");
        default:
            return "\n            height: ".concat(0, "px;\n          ");
    }
});
var StickyTemplateHeader = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].header.withConfig */ .ZP.header.withConfig({
    componentId: "sc-3f906778-2"
})(_templateObject4(), _constants_zIndex__WEBPACK_IMPORTED_MODULE_2__/* .zIndex.AppHeader */ .W.AppHeader, function(param) {
    var type = param.type, theme = param.theme;
    switch(type){
        case _types_header__WEBPACK_IMPORTED_MODULE_4__/* .HeaderType.WithMobileHeader */ .n.WithMobileHeader:
            {
                return (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject2(), [
                    _types_app__WEBPACK_IMPORTED_MODULE_3__/* .ClientType.WEB */ .B.WEB,
                    _types_app__WEBPACK_IMPORTED_MODULE_3__/* .ClientType.MOBILE_WEBVIEW */ .B.MOBILE_WEBVIEW
                ].includes(theme.client.clientType) ? 0 : 60);
            }
        default:
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject3());
    }
});
var Content = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-3f906778-3"
})(_templateObject5());
var StickyBottom = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-3f906778-4"
})(_templateObject6(), _constants_zIndex__WEBPACK_IMPORTED_MODULE_2__/* .zIndex.BottomSticky */ .W.BottomSticky, function(param) {
    var theme = param.theme;
    return theme.color.white;
});
// eslint-disable-next-line @typescript-eslint/no-empty-function
var TemplateLayout = function() {};
var Header = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TemplateHeader, {
        useSafeArea: props.useSafeArea,
        position: props.position,
        height: props.height,
        children: props.children
    });
};
var StickyHeader = function(param) {
    var children = param.children, type = param.type, style = param.style;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StickyTemplateHeader, {
        type: type,
        style: style,
        children: children
    });
};
TemplateLayout.Wrapper = Wrapper;
/**
 * @deprecated 확장성을 위해 이관예정
 */ TemplateLayout.Header = Header;
TemplateLayout.StickyHeader = StickyHeader;
TemplateLayout.Content = Content;
TemplateLayout.StickyBottom = StickyBottom;
/* harmony default export */ __webpack_exports__["Z"] = (TemplateLayout);


/***/ }),

/***/ 14675:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75190);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89961);
/* harmony import */ var _components_atom_Skeleton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13971);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 24px;\n  width: 100%;\n  height: 120px;\n  margin-bottom: 16px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var HospitalSkeletonList = function(param) {
    var _size = param.size, size = _size === void 0 ? 8 : _size;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SkeletonWrapper, {
        children: Array.from({
            length: size
        }).map(function(_, i) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(HospitalSkeleton, {}, "skeleton_hospital_".concat(i));
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HospitalSkeletonList);
var HospitalSkeleton = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Card, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                style: {
                    width: 55,
                    height: 18,
                    marginBottom: 2
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                style: {
                    width: 200,
                    height: 24,
                    marginBottom: 6
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                style: {
                    width: 300,
                    height: 22
                }
            })
        ]
    });
};
var Card = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].li.withConfig */ .ZP.li.withConfig({
    componentId: "sc-ddc2cfe4-0"
})(_templateObject());
var SkeletonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    componentId: "sc-ddc2cfe4-1"
})(_templateObject1());


/***/ }),

/***/ 96871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75190);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89961);
/* harmony import */ var _components_atom_Skeleton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13971);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 24px;\n  display: flex;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: calc(100% - 96px);\n  margin-right: 20px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var MagazineItemSkeleton = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Left, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Row, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_Skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                style: {
                                    width: 60,
                                    height: 18,
                                    marginRight: 8
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_Skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                style: {
                                    width: 66,
                                    height: 18
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_Skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        style: {
                            height: 48,
                            marginTop: 8,
                            marginBottom: 4
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_Skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        style: {
                            height: 18,
                            marginBottom: 2
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_Skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        style: {
                            width: "70%",
                            height: 18
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Right, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_Skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        style: {
                            width: 96,
                            height: 72,
                            marginBottom: 4
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_Skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        style: {
                            width: 96,
                            height: 28
                        }
                    })
                ]
            })
        ]
    });
};
var MagazineSkeleton = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        children: Array.from({
            length: 8
        }).map(function(_, i) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(MagazineItemSkeleton, {}, "skeleton_".concat(i));
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MagazineSkeleton);
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fdc826d3-0"
})(_templateObject());
var Left = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fdc826d3-1"
})(_templateObject1());
var Row = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fdc826d3-2"
})(_templateObject2());
var Right = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fdc826d3-3"
})(_templateObject3());


/***/ }),

/***/ 57823:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62230);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85244);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98240);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75190);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89961);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  padding: 8px 0 6px;\n  z-index: 1;\n  white-space: nowrap;\n\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 4px 8px;\n  border-radius: 8px;\n\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var DNSlideTabItem = function(_param) {
    var label = _param.label, isActive = _param.isActive, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "label",
        "isActive"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTabItem, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
        className: isActive ? "DNSlideTabItem_selected" : "DNSlideTabItem",
        isActive: isActive,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Label, {
            isActive: isActive,
            children: label
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (DNSlideTabItem);
var StyledTabItem = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-b58e3c80-0"
})(_templateObject(), function(param) {
    var theme = param.theme, isActive = param.isActive;
    return "\n    border-bottom: 2px solid ".concat(isActive ? "".concat(theme.color.gray800) : "transparent", "\n  ");
});
var Label = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-b58e3c80-1"
})(_templateObject1(), function(param) {
    var theme = param.theme, isActive = param.isActive;
    return "\n    ".concat(isActive ? theme.typography.UI15SB : theme.typography.UI15M, ";\n    color: ").concat(isActive ? theme.color.gray800 : theme.color.gray400, ";\n\n    &: active {\n      background: ").concat(theme.color.gray50, ";\n    }\n  ");
});


/***/ }),

/***/ 67788:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75190);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89961);
/* harmony import */ var _designComponents_organisms_DNSlideTab_DNSlideTabItem__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57823);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  overflow-x: auto;\n  padding: 0 24px;\n  gap: 12px;\n\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 1px;\n  width: 100%;\n  position: absolute;\n  bottom: 0;\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var DNSlideTab = function(param) {
    var value = param.value, _group = param.group, group = _group === void 0 ? false : _group, children = param.children;
    var scrollRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!value) return;
        if (!scrollRef.current) return;
        var children = Array.from(scrollRef.current.children);
        children.forEach(function(child) {
            if (child.classList.contains("DNSlideTabItem_selected")) {
                var ref = child.getBoundingClientRect(), left = ref.left, width = ref.width;
                var innerWidth = window.innerWidth;
                if (left + width / 2 !== innerWidth / 2) {
                    var ref1, ref2;
                    (ref1 = scrollRef.current) === null || ref1 === void 0 ? void 0 : ref1.scrollTo({
                        top: 0,
                        left: ((ref2 = scrollRef.current) === null || ref2 === void 0 ? void 0 : ref2.scrollLeft) + (left - innerWidth / 2 + width / 2),
                        behavior: "smooth"
                    });
                }
            }
        });
    }, [
        value
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
                ref: scrollRef,
                group: group,
                children: children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BorderBottom, {})
        ]
    });
};
DNSlideTab.Item = _designComponents_organisms_DNSlideTab_DNSlideTabItem__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z;
/* harmony default export */ __webpack_exports__["Z"] = (DNSlideTab);
var Container = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ae884c-0"
})(_templateObject());
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ae884c-1"
})(_templateObject1(), function(param) {
    var group = param.group;
    return "\n    ".concat(group ? "\n          button {\n            flex: 1;\n            span {\n              width: 100%;\n            }\n          }" : "", ";\n  ");
});
var BorderBottom = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ae884c-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return "\n    border-bottom: 1px solid ".concat(theme.color.gray100, ";\n  ");
});


/***/ }),

/***/ 77688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _services_hospital_SearchHospitalService__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23144);
/* harmony import */ var _faceToFace_gql_impl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38245);


var useGetUserAddressByLocation = function(latitude, longitude) {
    var ref = (0,_faceToFace_gql_impl__WEBPACK_IMPORTED_MODULE_0__/* .useGetAddressByLocationQuery */ .hh)({
        longitude: longitude,
        latitude: latitude
    }, {
        enabled: !latitude || !longitude,
        select: _services_hospital_SearchHospitalService__WEBPACK_IMPORTED_MODULE_1__/* .SearchHospitalService.parseHospitalAddressByLocation */ .h.parseHospitalAddressByLocation
    }), data = ref.data, refetch = ref.refetch;
    return {
        data: data,
        refetch: refetch
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetUserAddressByLocation);


/***/ }),

/***/ 51591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ry": function() { return /* binding */ REPORT_TYPE; },
/* harmony export */   "bA": function() { return /* binding */ ROLE_TYPE; }
/* harmony export */ });
/* unused harmony export modalType */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(22710);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(81541);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(22970);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85945);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _components_atom_icon_Report_QnaReport__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24903);
/* harmony import */ var _components_atom_icon_Report_UserBlock__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76815);
/* harmony import */ var _components_atom_icon_Report_UserReport__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68764);
/* harmony import */ var _components_atom_icon_Report_UserUnBlock__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66875);
/* harmony import */ var _types_modal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(74701);
/* harmony import */ var _qna_mobile_qna_gql_impl__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4365);
/* harmony import */ var _useModal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(98266);
/* harmony import */ var _useToast__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(17722);















var REPORT_TYPE = {
    QUESTION: "question",
    ANSWER: "answer",
    BOARD_POST: "board_post",
    BOARD_POST_COMMENT: "board_post_comment"
};
var ROLE_TYPE = {
    USER: "user",
    DOCTOR: "doctor",
    AI: "AI"
};
var modalType = {
    setUserBlock: {
        title: function(target) {
            return "".concat(target, "를 차단할까요?");
        },
        body: function(isUser) {
            return isUser ? "차단한 사용자의 글이 더 이상 보이지 않아요." : "차단한 의료진의 답변을 볼 수 없어요.";
        },
        grantText: "차단",
        toastMessage: function(target) {
            return "".concat(target, "를 차단했어요.");
        }
    },
    resetUserBlock: {
        title: function(target, contentType) {
            return "".concat(target, "의 ").concat(contentType, "을 다시 볼까요?");
        },
        body: function(isUser) {
            return isUser ? "차단을 해제하면 사용자의 글을 볼 수 있어요." : "차단을 해제하면 답변을 볼 수 있어요.";
        },
        grantText: "차단 해제",
        toastMessage: "차단을 해제했어요."
    }
};
var useReportModal = function() {
    var queryClient = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_11__/* .useQueryClient */ .NL)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), showReportModal = ref[0], setShowReportModal = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), reportData = ref1[0], setReportData = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), reportItems = ref2[0], setReportItems = ref2[1];
    var ref3 = (0,_useModal__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(), showModal = ref3.showModal, closeModal = ref3.closeModal;
    var showToast = (0,_useToast__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)().showToast;
    var isUser = (reportData === null || reportData === void 0 ? void 0 : reportData.role) === ROLE_TYPE.USER;
    var isQuestion = (reportData === null || reportData === void 0 ? void 0 : reportData.targetType) === REPORT_TYPE.QUESTION;
    var isBlocked = reportData === null || reportData === void 0 ? void 0 : reportData.isBlocked;
    var targetRoleName = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return isUser ? "사용자" : "의료진";
    }, [
        isUser
    ]);
    var contentType = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return isUser ? "글" : "답변";
    }, [
        isUser
    ]);
    var ref4 = (0,_qna_mobile_qna_gql_impl__WEBPACK_IMPORTED_MODULE_8__/* .useSetBlockingAccountMutation */ .vB)({
        onError: function() {
            showToast({
                message: "요청에 실패했습니다."
            });
            onCloseReportModal();
        }
    }), blockMutate = ref4.mutate;
    var onCloseReportModal = function() {
        setShowReportModal(false);
        setReportData(undefined);
        setReportItems([]);
    };
    var onShowReportModal = function(data) {
        setReportData(data);
    };
    var onReportUser = function() {
        next_router__WEBPACK_IMPORTED_MODULE_1___default().push("/content/report?targetId=".concat(reportData === null || reportData === void 0 ? void 0 : reportData.targetId, "&type=").concat(reportData === null || reportData === void 0 ? void 0 : reportData.targetType, "&report_type=user"));
    };
    var onReportQna = function() {
        next_router__WEBPACK_IMPORTED_MODULE_1___default().push("/content/report?targetId=".concat(reportData === null || reportData === void 0 ? void 0 : reportData.targetId, "&type=").concat(reportData === null || reportData === void 0 ? void 0 : reportData.targetType, "&report_type=").concat(reportData === null || reportData === void 0 ? void 0 : reportData.targetType));
    };
    var onBlockMutate = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(function(_isBlocked) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!reportData) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            blockMutate({
                                blockingAccountMutationRequest: {
                                    blockTargetRoleType: reportData === null || reportData === void 0 ? void 0 : reportData.role,
                                    blockTargetId: reportData === null || reportData === void 0 ? void 0 : reportData.roleId
                                }
                            }, {
                                onSuccess: function() {
                                    queryClient.invalidateQueries();
                                    showToast({
                                        message: _isBlocked ? modalType.resetUserBlock.toastMessage : modalType.setUserBlock.toastMessage(targetRoleName)
                                    });
                                    closeModal();
                                    onCloseReportModal();
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function onBlockMutate(_isBlocked) {
            return _ref.apply(this, arguments);
        };
    }();
    var onBlockUser = function() {
        onCloseReportModal();
        showModal({
            type: _types_modal__WEBPACK_IMPORTED_MODULE_7__/* .MODAL_TYPE.ALERT */ .f.ALERT,
            props: {
                title: isBlocked ? modalType.resetUserBlock.title(targetRoleName, contentType) : modalType.setUserBlock.title(targetRoleName),
                message: isBlocked ? modalType.resetUserBlock.body(isUser) : modalType.setUserBlock.body(isUser),
                buttons: [
                    {
                        label: "취소",
                        onClick: function() {
                            return closeModal();
                        }
                    },
                    {
                        type: isBlocked ? _types_modal__WEBPACK_IMPORTED_MODULE_7__/* .MODAL_BUTTON_TYPE.BOLD */ .J.BOLD : _types_modal__WEBPACK_IMPORTED_MODULE_7__/* .MODAL_BUTTON_TYPE.DANGER */ .J.DANGER,
                        label: isBlocked ? "차단 해제" : "차단",
                        onClick: function() {
                            return onBlockMutate(isBlocked);
                        }
                    }, 
                ]
            }
        });
    };
    var generateSelectList = function() {
        var selectItems = [];
        if ((reportData === null || reportData === void 0 ? void 0 : reportData.role) !== ROLE_TYPE.AI) {
            selectItems = [
                {
                    Icon: function() {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atom_icon_Report_UserReport__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {});
                    },
                    text: isUser ? "사용자 신고" : "의료진 신고",
                    onClick: onReportUser
                },
                {
                    Icon: function() {
                        return isBlocked ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atom_icon_Report_UserUnBlock__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atom_icon_Report_UserBlock__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {});
                    },
                    text: isBlocked ? "차단 해제하기" : isUser ? "사용자 차단" : "의료진 차단",
                    onClick: onBlockUser
                }, 
            ];
        }
        if (!isBlocked) selectItems = [
            {
                Icon: function() {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atom_icon_Report_QnaReport__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {});
                },
                text: isQuestion ? "게시글 신고" : "답변 신고",
                onClick: onReportQna
            }, 
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(selectItems));
        setReportItems(selectItems);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (reportItems === null || reportItems === void 0 ? void 0 : reportItems.length) {
            return setShowReportModal(true);
        }
        setShowReportModal(false);
    }, [
        reportItems
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (reportData) {
            generateSelectList();
        }
    }, [
        reportData
    ]);
    return {
        showReportModal: showReportModal,
        onShowReportModal: onShowReportModal,
        onCloseReportModal: onCloseReportModal,
        reportData: reportData,
        reportItems: reportItems
    };
};
/* harmony default export */ __webpack_exports__["ZP"] = (useReportModal);


/***/ }),

/***/ 38805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages_search; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(55351);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ./src/components/layouts/DefaultLayout.tsx
var DefaultLayout = __webpack_require__(83651);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(75190);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/components/atom/BreadCrumbs.tsx
var BreadCrumbs = __webpack_require__(27441);
// EXTERNAL MODULE: ./src/components/layouts/TemplateLayout.tsx
var TemplateLayout = __webpack_require__(75275);
;// CONCATENATED MODULE: ./src/components/atom/icon/AiBannerIcon.tsx

var AiBannerIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "312",
        height: "100",
        viewBox: "0 0 312 100",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_11113_12188)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        clipPath: "url(#clip1_11113_12188)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M104 81.5858V77H97L102.293 82.2929C102.923 82.9229 104 82.4767 104 81.5858Z",
                                fill: "#E67700"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                x: "36",
                                y: "49",
                                width: "88",
                                height: "28",
                                rx: "8",
                                fill: "#E67700"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M53.1699 57.9297V61.5273H50.1465V62.7461H54.3887V63.6484H44.8145V62.7461H49.0449V61.5273H46.0332V57.9297H53.1699ZM47.123 58.8086V60.6367H52.0684V58.8086H47.123ZM53.2168 64.6445V67.9961H52.0918V65.5234H45.8809V64.6445H53.2168ZM63.8809 57.4961V68.0195H62.7676V57.4961H63.8809ZM58.2676 58.2812C59.8262 58.2812 60.9746 59.7109 60.9746 61.9609C60.9746 64.2227 59.8262 65.6523 58.2676 65.6523C56.6855 65.6523 55.5488 64.2227 55.5488 61.9609C55.5488 59.7109 56.6855 58.2812 58.2676 58.2812ZM58.2676 59.2773C57.2949 59.2773 56.627 60.3086 56.627 61.9609C56.627 63.625 57.2949 64.6562 58.2676 64.6562C59.2285 64.6562 59.8965 63.625 59.8965 61.9609C59.8965 60.3086 59.2285 59.2773 58.2676 59.2773ZM76.8535 57.4727V61.5508H78.2949V62.4883H76.8535V67.9961H75.7402V57.4727H76.8535ZM71.4629 58.5742V59.4883H69.8809V64.3633C70.3848 64.3457 70.9414 64.293 71.5566 64.1641L71.6504 65.0898C70.7012 65.2773 69.9512 65.3008 69.248 65.3008H68.7676V58.5742H71.4629ZM74.8496 58.5742V59.4883H73.1387V64.3633C73.9062 64.3574 74.4863 64.3047 75.1309 64.1406L75.2246 65.0664C74.3809 65.2773 73.6895 65.3008 72.5645 65.3008H72.0488V58.5742H74.8496ZM87.1074 57.4961V59.9219H88.6309V60.8359H87.1074V63.1797H85.9824V57.4961H87.1074ZM84.2246 58.1172C84.2246 60.7891 82.4082 62.5703 79.2676 63.3086L78.8574 62.4062C81.4004 61.8262 82.8242 60.5664 83.0059 59.0078H79.3496V58.1172H84.2246ZM81.4707 63.6367V64.8672H85.9941V63.6367H87.1074V67.8672H80.3574V63.6367H81.4707ZM81.4707 66.9531H85.9941V65.7461H81.4707V66.9531ZM99.0371 61.6211V62.5352H97.4082V67.9844H96.2949V57.4961H97.4082V61.6211H99.0371ZM90.7285 58.5156V64.4219C92.1934 64.4219 93.7227 64.2988 95.3926 63.9531L95.5215 64.8906C93.7285 65.2539 92.0645 65.3477 90.4941 65.3477H89.627V58.5156H90.7285ZM109.209 65.7578V66.6836H99.5996V65.7578H101.896V63.0156C101.035 62.541 100.514 61.7852 100.514 60.8477C100.514 59.1953 102.131 58.1055 104.381 58.1055C106.643 58.1055 108.26 59.1953 108.26 60.8477C108.26 61.7734 107.756 62.5176 106.912 62.9922V65.7578H109.209ZM104.381 58.9961C102.729 58.9961 101.592 59.7109 101.592 60.8477C101.592 61.9727 102.729 62.7109 104.381 62.7109C106.021 62.7109 107.182 61.9727 107.182 60.8477C107.182 59.7109 106.021 58.9961 104.381 58.9961ZM102.998 65.7578H105.787V63.4141C105.359 63.5254 104.885 63.5781 104.381 63.5781C103.889 63.5781 103.42 63.5254 102.998 63.4258V65.7578ZM111.693 64.4805C111.705 62.9453 112.162 62.4766 112.936 61.9961C113.428 61.6914 113.803 61.2695 113.803 60.6484C113.803 59.9102 113.24 59.4531 112.537 59.4531C111.904 59.4531 111.295 59.8398 111.236 60.707H109.971C110.018 59.2188 111.143 58.3984 112.537 58.3984C114.061 58.3984 115.08 59.3125 115.08 60.6484C115.08 61.5859 114.635 62.2188 113.885 62.6758C113.182 63.0977 112.912 63.5312 112.889 64.4805V64.5508H111.693V64.4805ZM112.338 67.082C111.881 67.082 111.494 66.707 111.506 66.25C111.494 65.793 111.881 65.418 112.338 65.418C112.783 65.418 113.17 65.793 113.17 66.25C113.17 66.707 112.783 67.082 112.338 67.082Z",
                                fill: "white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        x: "112",
                        y: "88",
                        width: "88",
                        height: "22",
                        rx: "11",
                        fill: "#FF8D00"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        x: "122",
                        y: "88",
                        width: "68",
                        height: "35",
                        rx: "12",
                        fill: "#FAB005"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        x: "119",
                        y: "22",
                        width: "74",
                        height: "56",
                        rx: "20",
                        fill: "#FAB005"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        x: "155",
                        y: "7",
                        width: "2",
                        height: "8",
                        fill: "#E67700"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "156",
                        cy: "4",
                        r: "4",
                        fill: "#F03E3E"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M152 15C152 13.3431 153.343 12 155 12H157C158.657 12 160 13.3431 160 15V16H152V15Z",
                        fill: "#E67700"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M149 19C149 16.7909 150.791 15 153 15H159C161.209 15 163 16.7909 163 19V22H149V19Z",
                        fill: "#FF8D00"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        x: "130",
                        y: "34",
                        width: "52",
                        height: "32",
                        rx: "12",
                        fill: "#F7F9FA"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        x: "139",
                        y: "44",
                        width: "7",
                        height: "13",
                        rx: "3.5",
                        fill: "#3D4551"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        x: "166",
                        y: "44",
                        width: "7",
                        height: "13",
                        rx: "3.5",
                        fill: "#3D4551"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        x: "145",
                        y: "78",
                        width: "22",
                        height: "10",
                        fill: "#E67700"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M151 49C151.552 49 152 49.4477 152 50C152 52.2091 153.791 54 156 54C158.209 54 160 52.2091 160 50C160 49.4477 160.448 49 161 49C161.552 49 162 49.4477 162 50C162 53.3137 159.314 56 156 56C152.686 56 150 53.3137 150 50C150 49.4477 150.448 49 151 49Z",
                        fill: "#E67700"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        clipPath: "url(#clip2_11113_12188)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M201 40.5858V36H208L202.707 41.2929C202.077 41.9229 201 41.4767 201 40.5858Z",
                                fill: "#3D4551"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                x: "169",
                                y: "8",
                                width: "113",
                                height: "28",
                                rx: "8",
                                fill: "#3D4551"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M186.506 23.2344V26.9961H185.393V24.1133H179.393V23.2344H186.506ZM186.506 16.4961V22.6836H185.393V21.2422H182.803C182.316 21.8164 181.549 22.1621 180.658 22.1562C179.076 22.168 177.904 21.1133 177.904 19.6133C177.904 18.1367 179.076 17.0703 180.658 17.082C181.549 17.0762 182.311 17.4219 182.803 17.9961H185.393V16.4961H186.506ZM180.658 18.0195C179.674 18.0195 178.971 18.6758 178.971 19.6133C178.971 20.5742 179.674 21.2188 180.658 21.2188C181.607 21.2188 182.322 20.5742 182.322 19.6133C182.322 18.6758 181.607 18.0195 180.658 18.0195ZM183.295 20.3281H185.393V18.9102H183.295C183.354 19.1328 183.389 19.3672 183.389 19.6133C183.389 19.8652 183.354 20.1055 183.295 20.3281ZM197.721 22.7305V23.6094H195.307V26.9961H194.182V23.6094H191.65V26.9961H190.537V23.6094H188.111V22.7305H197.721ZM196.584 16.8711V19.6836H190.396V20.8438H196.807V21.7461H189.283V18.8516H195.447V17.7852H189.248V16.8711H196.584ZM202.221 18.0664C202.221 19.543 203.17 20.8555 204.764 21.3711L204.154 22.2383C203 21.8223 202.15 21.0137 201.693 19.9648C201.236 21.166 200.322 22.0977 199.057 22.5547L198.459 21.6641C200.135 21.0898 201.107 19.6953 201.119 18.1133V17.082H202.221V18.0664ZM207.248 16.4961V22.6953H206.135V19.543H203.92V18.6289H206.135V16.4961H207.248ZM203.732 22.9883C205.936 22.9883 207.283 23.7148 207.283 24.9922C207.283 26.2578 205.936 26.9844 203.732 26.9727C201.529 26.9844 200.17 26.2578 200.182 24.9922C200.17 23.7148 201.529 22.9883 203.732 22.9883ZM203.732 23.8555C202.197 23.8555 201.283 24.2656 201.283 24.9922C201.283 25.6953 202.197 26.0938 203.732 26.0938C205.268 26.0938 206.182 25.6953 206.182 24.9922C206.182 24.2656 205.268 23.8555 203.732 23.8555ZM215.615 18.0078C215.604 19.4609 216.6 20.7852 218.217 21.3242L217.654 22.2031C216.441 21.7754 215.527 20.9199 215.053 19.8242C214.584 21.002 213.664 21.9336 212.416 22.3789L211.854 21.5117C213.494 20.9258 214.479 19.5078 214.479 18.0078V17H215.615V18.0078ZM220.502 23.3047V26.9961H219.389V24.207H213.389V23.3047H220.502ZM220.502 16.4961V22.8008H219.389V16.4961H220.502ZM230.674 21.3359V22.2266H227.498V24.793H231.775V25.707H222.166V24.793H226.396V22.2266H223.361V17.3047H230.58V18.207H224.475V21.3359H230.674ZM235.443 17.082C236.316 17.082 237.066 17.4043 237.553 17.9492H240.178V16.4961H241.291V22.4961H240.178V21.2188H237.553C237.061 21.7578 236.316 22.0859 235.443 22.0859C233.861 22.0859 232.689 21.043 232.689 19.5898C232.689 18.1133 233.861 17.082 235.443 17.082ZM235.443 18.0195C234.459 18.0195 233.756 18.6641 233.756 19.5898C233.756 20.5156 234.459 21.1484 235.443 21.1484C236.404 21.1484 237.107 20.5156 237.107 19.5898C237.107 18.6641 236.404 18.0195 235.443 18.0195ZM241.291 23.0117V26.8672H234.365V23.0117H241.291ZM235.467 23.9023V25.9648H240.201V23.9023H235.467ZM238.068 18.8633C238.133 19.0918 238.174 19.332 238.174 19.5898C238.174 19.8359 238.139 20.0703 238.08 20.293H240.178V18.8633H238.068ZM251.604 16.4961V27.0195H250.49V16.4961H251.604ZM245.99 17.2812C247.549 17.2812 248.697 18.7109 248.697 20.9609C248.697 23.2227 247.549 24.6523 245.99 24.6523C244.408 24.6523 243.271 23.2227 243.271 20.9609C243.271 18.7109 244.408 17.2812 245.99 17.2812ZM245.99 18.2773C245.018 18.2773 244.35 19.3086 244.35 20.9609C244.35 22.625 245.018 23.6562 245.99 23.6562C246.951 23.6562 247.619 22.625 247.619 20.9609C247.619 19.3086 246.951 18.2773 245.99 18.2773ZM262.314 16.4961V26.9961H261.248V16.4961H262.314ZM260.182 16.6953V26.4805H259.115V21.418H257.932C257.838 23.4688 256.959 24.7461 255.658 24.7344C254.287 24.7461 253.396 23.3047 253.396 21.0312C253.396 18.7578 254.287 17.3281 255.658 17.3398C256.936 17.3281 257.803 18.541 257.932 20.5156H259.115V16.6953H260.182ZM255.658 18.3828C254.896 18.3828 254.428 19.3555 254.428 21.0312C254.428 22.707 254.896 23.6797 255.658 23.6797C256.432 23.6797 256.912 22.707 256.912 21.0312C256.912 19.3555 256.432 18.3828 255.658 18.3828ZM273.26 24.7578V25.6836H263.65V24.7578H265.947V22.0156C265.086 21.541 264.564 20.7852 264.564 19.8477C264.564 18.1953 266.182 17.1055 268.432 17.1055C270.693 17.1055 272.311 18.1953 272.311 19.8477C272.311 20.7734 271.807 21.5176 270.963 21.9922V24.7578H273.26ZM268.432 17.9961C266.779 17.9961 265.643 18.7109 265.643 19.8477C265.643 20.9727 266.779 21.7109 268.432 21.7109C270.072 21.7109 271.232 20.9727 271.232 19.8477C271.232 18.7109 270.072 17.9961 268.432 17.9961ZM267.049 24.7578H269.838V22.4141C269.41 22.5254 268.936 22.5781 268.432 22.5781C267.939 22.5781 267.471 22.5254 267.049 22.4258V24.7578Z",
                                fill: "white"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip0_11113_12188",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            width: "312",
                            height: "100",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip1_11113_12188",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            width: "88",
                            height: "35",
                            fill: "white",
                            transform: "translate(36 49)"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip2_11113_12188",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            width: "113",
                            height: "35",
                            fill: "white",
                            transform: "translate(169 8)"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var icon_AiBannerIcon = (AiBannerIcon);

// EXTERNAL MODULE: ./src/components/molecules/BottomSheet/index.tsx + 5 modules
var BottomSheet = __webpack_require__(39535);
// EXTERNAL MODULE: ./src/hooks/useCustomRouter.tsx
var useCustomRouter = __webpack_require__(77196);
// EXTERNAL MODULE: ./src/hooks/useToast.tsx
var useToast = __webpack_require__(17722);
// EXTERNAL MODULE: ./src/utils/logger/index.ts
var logger = __webpack_require__(78287);
;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/HomeDiseaseSymptomSearch/components/AiNoticeBanner/index.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0px 24px;\n  margin: 24px 0 20px;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  background: ",
        ";\n  padding: 0px 16px 0px 24px;\n  height: 96px;\n  border-radius: 18px;\n  display: flex;\n  text-align: left;\n  border: none;\n  justify-content: space-between;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: url('images/aiBannerImage.png');\n  background-size: cover;\n  width: 96px;\n  height: 96px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin: 40px 24px 24px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 20px;\n  margin-bottom: 8px;\n  ",
        ";\n  color: ",
        ";\n  text-align: center;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  ",
        ";\n  color: ",
        ";\n  text-align: center;\n  & > em {\n    color: ",
        ";\n    font-style: normal;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  ",
        ";\n  background: ",
        ";\n  color: ",
        ";\n  border-radius: 12px;\n  width: 100%;\n  height: 60px;\n  margin-top: 40px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}








var AiNoticeBanner = function() {
    var pageName = (0,useCustomRouter/* default */.Z)().pageName;
    var showToast = (0,useToast/* default */.Z)().showToast;
    var ref = (0,react.useState)(false), isOpened = ref[0], setIsOpened = ref[1];
    var handleAiBannerClick = function() {
        (0,logger/* coreLogger */.cl)({
            eventName: "click_banner_ai_open",
            pageName: pageName
        });
        setIsOpened(true);
    };
    var handleBottomButtonClick = function() {
        (0,logger/* coreLogger */.cl)({
            eventName: "click_notice_ai_open_in_popup",
            pageName: pageName
        });
        setIsOpened(false);
        showToast({
            message: "AI 문진 서비스가 오픈하면 알려드릴게요."
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BannerContainer, {
                onClick: handleAiBannerClick,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BannerContentsContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerTitle, {
                                children: "지금 이 증상, 뭐지?"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerSubTitle, {
                                children: "클릭만으로 질병을 찾아드려요"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AiBannerImageContainer, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomSheet/* default */.ZP, {
                isOpened: isOpened,
                onClickOverlay: function() {
                    return setIsOpened(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BottomSheetContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_AiBannerIcon, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(BottomSheetContentsTitle, {
                            children: [
                                "증상을 클릭하면 질병을 찾아주는",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "AI 문진 서비스가 곧 오픈해요"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(BottomSheetContentsSubTitle, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                    children: "1,800개의 데이터"
                                }),
                                "로 세밀하게 분석해 드려요"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomSheetButton, {
                            onClick: handleBottomButtonClick,
                            children: "오픈 알림 받기"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var components_AiNoticeBanner = (AiNoticeBanner);
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d1614d57-0"
})(_templateObject());
var BannerContainer = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-d1614d57-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.color.gray30;
});
var BannerContentsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d1614d57-2"
})(_templateObject2());
var BannerTitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-d1614d57-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.typography.UI17B;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray700;
});
var BannerSubTitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-d1614d57-4"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.typography.UI15R;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray400;
});
var AiBannerImageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d1614d57-5"
})(_templateObject5());
var BottomSheetContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d1614d57-6"
})(_templateObject6());
var BottomSheetContentsTitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-d1614d57-7"
})(_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.typography.UI20SB;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray700;
});
var BottomSheetContentsSubTitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-d1614d57-8"
})(_templateObject8(), function(param) {
    var theme = param.theme;
    return theme.typography.UI15M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray400;
}, function(param) {
    var theme = param.theme;
    return theme.color.primary700;
});
var BottomSheetButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-d1614d57-9"
})(_templateObject9(), function(param) {
    var theme = param.theme;
    return theme.typography.UI18SB;
}, function(param) {
    var theme = param.theme;
    return theme.color.primary500;
}, function(param) {
    var theme = param.theme;
    return theme.color.white;
});

;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/HomeDiseaseSymptomSearch/components/SymptomResultSection/index.tsx

function SymptomResultSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    SymptomResultSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SymptomResultSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  justify-content: space-between;\n  padding: 24px 24px 12px;\n  align-items: center;\n  ",
        ";\n  color: ",
        ";\n"
    ]);
    SymptomResultSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SymptomResultSection_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 16px 0px;\n  margin-top: 16px;\n  align-self: stretch;\n  border-top: 1px solid ",
        ";\n"
    ]);
    SymptomResultSection_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SymptomResultSection_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  color: ",
        ";\n"
    ]);
    SymptomResultSection_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var SymptomResultSection = function(param) {
    var title = param.title, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SymptomResultSection_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle, {
                children: title
            }),
            children
        ]
    });
};
var Result = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};
var MoreButton = function(param) {
    var onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonWrapper, {
        onClick: onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonText, {
            children: "더 보기"
        })
    });
};
SymptomResultSection.Result = Result;
SymptomResultSection.MoreButton = MoreButton;
/* harmony default export */ var components_SymptomResultSection = (SymptomResultSection);
var SymptomResultSection_Wrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-5198c6aa-0"
})(SymptomResultSection_templateObject());
var SectionTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-5198c6aa-1"
})(SymptomResultSection_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.typography.UI13M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray600;
});
var ButtonWrapper = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-5198c6aa-2"
})(SymptomResultSection_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.color.gray50;
});
var ButtonText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5198c6aa-3"
})(SymptomResultSection_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.typography.UI17R;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray500;
});

// EXTERNAL MODULE: ./src/components/atom/icon/SmallDelete.tsx
var SmallDelete = __webpack_require__(70691);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(62230);
// EXTERNAL MODULE: ./src/components/molecules/Modal/SelectModal/ReportSelectModal/index.tsx
var ReportSelectModal = __webpack_require__(28879);
;// CONCATENATED MODULE: ./src/components/common/ClickEventLogWrapper.tsx

function ClickEventLogWrapper_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    ClickEventLogWrapper_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var ClickEventLoggerWrapper = function(param) {
    var children = param.children, onClickEventLog = param.onClickEventLog;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickEventLogWrapper_Wrapper, {
        role: "button",
        onClick: onClickEventLog,
        children: children
    });
};
/* harmony default export */ var ClickEventLogWrapper = (ClickEventLoggerWrapper);
var ClickEventLogWrapper_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-79f238c4-0"
})(ClickEventLogWrapper_templateObject());

// EXTERNAL MODULE: ./src/components/common/InfiniteScroll/index.tsx + 1 modules
var InfiniteScroll = __webpack_require__(18163);
// EXTERNAL MODULE: ./src/components/common/LinkTag/index.tsx
var LinkTag = __webpack_require__(23889);
// EXTERNAL MODULE: ./src/components/hospital/HospitalListItem/HospitalListItem.tsx
var HospitalListItem = __webpack_require__(5066);
// EXTERNAL MODULE: ./src/components/templates/f2f/common/HospitalList/HospitalSkeletonList/index.tsx
var HospitalSkeletonList = __webpack_require__(14675);
// EXTERNAL MODULE: ./src/components/atom/buttons/DefaultButton.tsx
var DefaultButton = __webpack_require__(47641);
;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/SearchResult/EmptySearchResult/index.tsx

function EmptySearchResult_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-grid;\n  width: 100%;\n  height: calc(100vh - 180px);\n  text-align: center;\n  align-items: center;\n"
    ]);
    EmptySearchResult_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EmptySearchResult_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    EmptySearchResult_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function EmptySearchResult_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n\n  margin-top: 20px;\n"
    ]);
    EmptySearchResult_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function EmptySearchResult_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n\n  margin: 8px 0 20px;\n  white-space: pre-wrap;\n"
    ]);
    EmptySearchResult_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function EmptySearchResult_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: center;\n  display: flex;\n"
    ]);
    EmptySearchResult_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function EmptySearchResult_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 9px 20px;\n  border-radius: 8px;\n\n  ",
        "\n"
    ]);
    EmptySearchResult_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var EmptySearchResult = function(param) {
    var handleClickRequestButton = param.handleClickRequestButton;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmptySearchResult_Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyResultTitle, {
                    children: "검색 결과가 없어요"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyResultOffer, {
                    children: "다른 탭의 정보를 찾아보세요.\n꼭 필요한 정보가 있다면 알려주세요."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSection, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                        onClick: handleClickRequestButton,
                        children: "정보 요청하기"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var SearchResult_EmptySearchResult = (EmptySearchResult);
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d0bd9dfd-0"
})(EmptySearchResult_templateObject());
var EmptySearchResult_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d0bd9dfd-1"
})(EmptySearchResult_templateObject1());
var EmptyResultTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d0bd9dfd-2"
})(EmptySearchResult_templateObject2(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI20SB, ";\n    color: ").concat(theme.color.gray600, ";\n  ");
});
var EmptyResultOffer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d0bd9dfd-3"
})(EmptySearchResult_templateObject3(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI15R, "\n    color: ").concat(theme.color.gray400, ";\n  ");
});
var ButtonSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d0bd9dfd-4"
})(EmptySearchResult_templateObject4());
var Button = (0,styled_components_browser_esm/* default */.ZP)(DefaultButton/* DefaultButtonStyled */.qY).withConfig({
    componentId: "sc-d0bd9dfd-5"
})(EmptySearchResult_templateObject5(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI15M, ";\n    color: ").concat(theme.color.primary700, ";\n    background: ").concat(theme.color.primary100, ";\n  ");
});

// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
// EXTERNAL MODULE: ./src/types/hospital.ts
var types_hospital = __webpack_require__(24396);
// EXTERNAL MODULE: ./src/components/atom/icon/IconLocationPinMono.tsx
var IconLocationPinMono = __webpack_require__(94781);
// EXTERNAL MODULE: ./src/styles/theme.ts
var styles_theme = __webpack_require__(44376);
;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/ResultSection/index.tsx

function ResultSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 16px solid ",
        ";\n"
    ]);
    ResultSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ResultSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  padding: 24px 24px 12px;\n  align-items: center;\n  ",
        ";\n  color: ",
        ";\n"
    ]);
    ResultSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ResultSection_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 16px 0px;\n  align-self: stretch;\n  border-top: 1px solid ",
        ";\n"
    ]);
    ResultSection_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ResultSection_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  color: ",
        ";\n"
    ]);
    ResultSection_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ResultSection_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    ResultSection_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ResultSection_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 16px;\n  border-radius: 8px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  margin-top: ",
        ";\n  justify-content: space-between;\n  background-color: ",
        ";\n"
    ]);
    ResultSection_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ResultSection_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  color: ",
        ";\n  display: flex;\n  align-items: center;\n\n  & > svg {\n    margin-right: 6px;\n  }\n"
    ]);
    ResultSection_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ResultSection_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  color: ",
        ";\n  text-decoration: underline;\n  cursor: pointer;\n"
    ]);
    ResultSection_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}




var ResultSection = function(param) {
    var title = param.title, children = param.children, hasResultData = param.hasResultData;
    if (!hasResultData) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ResultSection_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultSection_SectionTitle, {
                children: title
            }),
            children
        ]
    });
};
var ResultSection_Result = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};
var ResultSection_MoreButton = function(param) {
    var onClick = param.onClick, style = param.style;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultSection_ButtonWrapper, {
        onClick: onClick,
        style: style,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultSection_ButtonText, {
            children: "더보기"
        })
    });
};
var ResultWrapper = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultSectionWrapper, {
        children: children
    });
};
var ResultAddress = function(param) {
    var address = param.address, getCurrentLocation = param.getCurrentLocation, _marginTop = param.marginTop, marginTop = _marginTop === void 0 ? 12 : _marginTop;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AddressWrapper, {
        marginTop: marginTop,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Address, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconLocationPinMono/* default */.Z, {
                        size: 16,
                        fill: styles_theme/* default.color.gray700 */.Z.color.gray700
                    }),
                    address
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                role: "button",
                onClick: getCurrentLocation,
                children: "현재 위치로 설정"
            })
        ]
    });
};
ResultSection.Result = ResultSection_Result;
ResultSection.MoreButton = ResultSection_MoreButton;
ResultSection.ResultWrapper = ResultWrapper;
ResultSection.ResultAddress = ResultAddress;
/* harmony default export */ var components_ResultSection = (ResultSection);
var ResultSection_Wrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-7a61ef3a-0"
})(ResultSection_templateObject(), function(param) {
    var theme = param.theme;
    return theme.color.gray30;
});
var ResultSection_SectionTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-7a61ef3a-1"
})(ResultSection_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.typography.UI13M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray500;
});
var ResultSection_ButtonWrapper = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-7a61ef3a-2"
})(ResultSection_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.color.gray50;
});
var ResultSection_ButtonText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7a61ef3a-3"
})(ResultSection_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.typography.UI17M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray500;
});
var ResultSectionWrapper = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-7a61ef3a-4"
})(ResultSection_templateObject4());
var AddressWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7a61ef3a-5"
})(ResultSection_templateObject5(), function(param) {
    var marginTop = param.marginTop;
    return "".concat(marginTop, "px");
}, function(param) {
    var theme = param.theme;
    return theme.color.gray30;
});
var Address = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7a61ef3a-6"
})(ResultSection_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.typography.UI14M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray700;
});
var Subtitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-7a61ef3a-7"
})(ResultSection_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.typography.UI14R;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray300;
});

;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/SearchResult/Hospital/index.tsx

function Hospital_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  > *:not(:last-child) > div {\n    border-bottom-style: solid;\n    border-bottom-width: 1px;\n    border-bottom-color: ",
        ";\n  }\n"
    ]);
    Hospital_templateObject = function _templateObject() {
        return data;
    };
    return data;
}












var HospitalSearchResult = function(param) {
    var hospitalViewModel = param.hospitalViewModel, address = param.address, getCurrentLocation = param.getCurrentLocation, geolocationPermissionLoading = param.geolocationPermissionLoading;
    var ref, ref1, ref2;
    if (hospitalViewModel.isHospitalLoading || geolocationPermissionLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(HospitalSkeletonList/* default */.Z, {});
    }
    if (!((ref = hospitalViewModel.hospitalData) === null || ref === void 0 ? void 0 : ref.pages.length)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResult_EmptySearchResult, {
            handleClickRequestButton: hospitalViewModel.handleClickRequestButton
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ResultSection.ResultAddress, {
                address: address,
                getCurrentLocation: getCurrentLocation,
                marginTop: 0
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfiniteScroll/* default */.Z, {
                isLoading: hospitalViewModel.isHospitalLoading,
                hasNextPage: hospitalViewModel.hasHospitalNextPage,
                fetchNextPage: hospitalViewModel.fetchHospitalNextPage,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HospitalResultWrapper, {
                    children: (ref1 = hospitalViewModel.hospitalData) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.pages) === null || ref2 === void 0 ? void 0 : ref2.map(function(hospital) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTag/* default */.Z, {
                            onClickNavigateToScreen: function() {
                                return hospitalViewModel.onClickMoveNative(hospital.hospitalPublicId);
                            },
                            href: "".concat(common/* ROUTES.HOSPITAL.DETAIL.path */.Z6.HOSPITAL.DETAIL.path).concat(hospital.hospitalPublicId),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickEventLogWrapper, {
                                onClickEventLog: function() {
                                    return hospitalViewModel.onClickLogHospital(hospital.hospitalPublicId);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HospitalListItem/* default */.Z, {
                                    name: hospital.hospitalName,
                                    distance: hospital.hospitalDistance,
                                    rating: hospital.reviewScore,
                                    reviewTotalCount: hospital.reviewTotalCount,
                                    badges: hospital.hospitalBadges,
                                    imageUrl: hospital.hospitalRepresentativeImageUrl,
                                    address: hospital.hospitalAddress,
                                    status: hospital.hospitalOperationStatus,
                                    isBookable: hospital.isBookable,
                                    representativeDepartmentName: hospital.hospitalRepresentativeDepartmentName,
                                    hospitalPid: hospital.hospitalPublicId,
                                    doctorDetailPageHref: "".concat(common/* ROUTES.HOSPITAL.DETAIL.path */.Z6.HOSPITAL.DETAIL.path).concat(hospital.hospitalPublicId),
                                    onClickMoveToDoctorDetail: function() {
                                        hospitalViewModel.onClickMoveNative(hospital.hospitalPublicId);
                                    },
                                    hasNonF2fDoctors: !!hospital.doctors.find(function(doctor) {
                                        return doctor.contractType === types_hospital/* ContractType.All */.RJ.All;
                                    })
                                }, "event-".concat(hospital.hospitalPublicId))
                            })
                        }, "hospital_".concat(hospital.hospitalPublicId));
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Hospital = (HospitalSearchResult);
var HospitalResultWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-78736ef-0"
})(Hospital_templateObject(), function(param) {
    var theme = param.theme;
    return theme.color.gray40;
});

// EXTERNAL MODULE: ./src/constants/zIndex.ts
var zIndex = __webpack_require__(31591);
// EXTERNAL MODULE: ./src/designComponents/organisms/DNSlideTab/index.tsx
var DNSlideTab = __webpack_require__(67788);
// EXTERNAL MODULE: ./src/hooks/useModal.tsx
var useModal = __webpack_require__(98266);
// EXTERNAL MODULE: ./src/hooks/usePostReportModal.tsx + 3 modules
var usePostReportModal = __webpack_require__(53043);
// EXTERNAL MODULE: ./src/hooks/useReportModal.tsx
var useReportModal = __webpack_require__(51591);
;// CONCATENATED MODULE: ./src/types/search.ts
var AuthorType;
(function(AuthorType) {
    AuthorType["Ai"] = "AI";
    AuthorType["Doctor"] = "DOCTOR";
    AuthorType["Nurse"] = "NURSE";
})(AuthorType || (AuthorType = {}));
var QuestionAnsweredStatus;
(function(QuestionAnsweredStatus) {
    QuestionAnsweredStatus["Answered"] = "ANSWERED";
    QuestionAnsweredStatus["Answering"] = "ANSWERING";
    QuestionAnsweredStatus["Checking"] = "CHECKING";
})(QuestionAnsweredStatus || (QuestionAnsweredStatus = {}));
var ProfessionalFieldType;
(function(ProfessionalFieldType) {
    ProfessionalFieldType["Department"] = "DEPARTMENT";
})(ProfessionalFieldType || (ProfessionalFieldType = {}));
var QuestionAccessibleType;
(function(QuestionAccessibleType) {
    QuestionAccessibleType["All"] = "ALL";
    QuestionAccessibleType["DoctorsAndMe"] = "DOCTORS_AND_ME";
    QuestionAccessibleType["Me"] = "ME";
})(QuestionAccessibleType || (QuestionAccessibleType = {}));
var AnswererType;
(function(AnswererType) {
    AnswererType["Ai"] = "AI";
    AnswererType["Doctor"] = "DOCTOR";
    AnswererType["Nurse"] = "NURSE";
})(AnswererType || (AnswererType = {}));
var AnswerLikeType;
(function(AnswerLikeType) {
    AnswerLikeType["Dislike"] = "DISLIKE";
    AnswerLikeType["Like"] = "LIKE";
})(AnswerLikeType || (AnswerLikeType = {}));
var IntegratedSearchTabType;
(function(IntegratedSearchTabType) {
    IntegratedSearchTabType["All"] = "ALL";
    IntegratedSearchTabType["Qna"] = "QNA";
    IntegratedSearchTabType["Magazine"] = "MAGAZINE";
    IntegratedSearchTabType["Doctor"] = "DOCTOR";
    IntegratedSearchTabType["Hospital"] = "HOSPITAL";
})(IntegratedSearchTabType || (IntegratedSearchTabType = {}));
var RequestButtonType;
(function(RequestButtonType) {
    RequestButtonType["BOTTOM"] = "bottom";
    RequestButtonType["FLOATING"] = "floating";
})(RequestButtonType || (RequestButtonType = {}));

// EXTERNAL MODULE: ./src/components/atom/icon/Star.tsx
var Star = __webpack_require__(10211);
// EXTERNAL MODULE: ./src/types/bff/gql-schema.ts
var gql_schema = __webpack_require__(72271);
;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/SearchResult/Doctor/Doctor.tsx

function Doctor_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 20px 24px;\n  align-items: center;\n  gap: 16px;\n  align-self: stretch;\n"
    ]);
    Doctor_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Doctor_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 72px;\n  height: 72px;\n  border-radius: 36px;\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    Doctor_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Doctor_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  background-position: center;\n  background-size: cover;\n"
    ]);
    Doctor_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Doctor_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  background: #5992ff66;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  ",
        ";\n"
    ]);
    Doctor_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Doctor_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  background: rgba(1, 1, 1, 0.5);\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  ",
        ";\n"
    ]);
    Doctor_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Doctor_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  flex: 1 0 0;\n"
    ]);
    Doctor_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Doctor_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n  align-self: stretch;\n"
    ]);
    Doctor_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Doctor_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  align-self: stretch;\n"
    ]);
    Doctor_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function Doctor_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  ",
        "\n"
    ]);
    Doctor_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function Doctor_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    Doctor_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  align-self: stretch;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  gap: 6px;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: 20px;\n  padding: 0px 4px;\n  justify-content: center;\n  align-items: center;\n  gap: 16px;\n  border-radius: 4px;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: row;\n  align-items: center;\n  display: flex;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 1px;\n  height: 10px;\n  background-color: ",
        ";\n  margin: 0 6px;\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}




var DoctorBookingStatusTime = function(param) {
    var doctor = param.doctor;
    var _bookingInfo = doctor.bookingInfo, bookingAvailability = _bookingInfo.bookingAvailability, todaySchedule = _bookingInfo.todaySchedule, tomorrowSchedule = _bookingInfo.tomorrowSchedule, isBookable = _bookingInfo.isBookable;
    if (!isBookable) {
        return null;
    }
    switch(bookingAvailability){
        case gql_schema/* BookingAvailability.TodayBookable */.hl.TodayBookable:
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BookingInfoWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TodayBookable, {
                        children: "오늘 예약"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorSchedule, {
                        children: todaySchedule
                    })
                ]
            });
        case gql_schema/* BookingAvailability.TomorrowBookable */.hl.TomorrowBookable:
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BookingInfoWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TomorrowBookable, {
                        children: "내일 예약"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorSchedule, {
                        children: tomorrowSchedule
                    })
                ]
            });
        case gql_schema/* BookingAvailability.NotBookable */.hl.NotBookable:
        default:
            return null;
    }
};
var formatReviewCount = function(count) {
    if (count >= 2000) return "2000+";
    if (count >= 1500) return "1500+";
    if (count >= 1000) return "1000+";
    if (count >= 500) return "500+";
    if (count >= 300) return "300+";
    if (count >= 200) return "200+";
    if (count >= 100) return "100+";
    if (count >= 50) return "50+";
    if (count >= 20) return "20+";
    if (count >= 10) return "10+";
    return String(count);
};
var Doctor = function(param) {
    var doctor = param.doctor, onClick = param.onClick;
    var ref, ref1;
    var isSpecialist = !!doctor.professionalDepartment;
    var isReadyForVideoRequest = doctor.readyForVideoCall;
    var hasTag = isSpecialist || isReadyForVideoRequest;
    var reviewAverage = (ref = Number(doctor === null || doctor === void 0 ? void 0 : doctor.reviewAverageRating)) === null || ref === void 0 ? void 0 : ref.toFixed(1);
    var hasProfileUrl = !!doctor.profileUrl;
    var isNotAvailable = doctor.bookingInfo.bookingAvailability === gql_schema/* BookingAvailability.NotBookable */.hl.NotBookable || !doctor.bookingInfo.isBookable;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Doctor_Wrapper, {
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(NameAndReview, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DoctorAndHospitalName, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorName, {
                                        children: doctor.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HospitalName, {
                                        children: doctor.hospitalV2.hospitalName
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StarAndReviewAndRating, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Star/* default */.Z, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReviewAndRating, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AverageRating, {
                                                children: reviewAverage
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReviewCount, {
                                                children: [
                                                    "(",
                                                    formatReviewCount(doctor.reviewCount),
                                                    ")"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorBookingStatusTime, {
                        doctor: doctor
                    }),
                    hasTag && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tags, {
                        children: [
                            isSpecialist && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProfessionalTag, {
                                children: [
                                    (ref1 = doctor.professionalDepartment) === null || ref1 === void 0 ? void 0 : ref1.name,
                                    "전문의"
                                ]
                            }),
                            isReadyForVideoRequest && /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoTag, {
                                children: "영상진료"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProfileImageWrapper, {
                children: [
                    hasProfileUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Doctor_ProfileImage, {
                        style: {
                            backgroundImage: 'url("'.concat(doctor.profileUrl, '")')
                        }
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultProfileImage, {
                        children: doctor.name
                    }),
                    isNotAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)(ClosedOverlap, {
                        children: "예약 마감"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Doctor_Doctor = (Doctor);
var Doctor_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ceadc88e-0"
})(Doctor_templateObject());
var ProfileImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ceadc88e-1"
})(Doctor_templateObject1());
var Doctor_ProfileImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ceadc88e-2"
})(Doctor_templateObject2());
var DefaultProfileImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ceadc88e-3"
})(Doctor_templateObject3(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI22SB, ";\n    color: ").concat(theme.color.white, ";\n  ");
});
var ClosedOverlap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ceadc88e-4"
})(Doctor_templateObject4(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI13SB, ";\n    color: ").concat(theme.color.white, ";\n  ");
});
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ceadc88e-5"
})(Doctor_templateObject5());
var NameAndReview = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ceadc88e-6"
})(Doctor_templateObject6());
var DoctorAndHospitalName = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ceadc88e-7"
})(Doctor_templateObject7());
var DoctorName = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ceadc88e-8"
})(Doctor_templateObject8(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI17SB, ";\n    color: ").concat(theme.color.gray600, ";\n  ");
});
var HospitalName = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ceadc88e-9"
})(Doctor_templateObject9(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI13R, ";\n    color: ").concat(theme.color.gray200, ";\n  ");
});
var StarAndReviewAndRating = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ceadc88e-10"
})(_templateObject10());
var ReviewAndRating = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ceadc88e-11"
})(_templateObject11());
var AverageRating = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ceadc88e-12"
})(_templateObject12(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI13M, ";\n    color: ").concat(theme.color.gray600, ";\n  ");
});
var ReviewCount = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ceadc88e-13"
})(_templateObject13(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI13M, ";\n    color: ").concat(theme.color.gray300, ";\n  ");
});
var Tags = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ceadc88e-14"
})(_templateObject14());
var Tag = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ceadc88e-15"
})(_templateObject15());
var VideoTag = (0,styled_components_browser_esm/* default */.ZP)(Tag).withConfig({
    componentId: "sc-ceadc88e-16"
})(_templateObject16(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.gray30, ";\n    ").concat(theme.typography.UI12M, ";\n    color: ").concat(theme.color.gray300, ";\n  ");
});
var ProfessionalTag = (0,styled_components_browser_esm/* default */.ZP)(Tag).withConfig({
    componentId: "sc-ceadc88e-17"
})(_templateObject17(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.blue100, ";\n    ").concat(theme.typography.UI12M, ";\n    color: ").concat(theme.color.blue600, ";\n  ");
});
var BookingInfoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ceadc88e-18"
})(_templateObject18());
var BookingStatus = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ceadc88e-19"
})(_templateObject19(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI13SB, ";\n  ");
});
var TodayBookable = (0,styled_components_browser_esm/* default */.ZP)(BookingStatus).withConfig({
    componentId: "sc-ceadc88e-20"
})(_templateObject20(), function(param) {
    var theme = param.theme;
    return theme.color.green700;
});
var TomorrowBookable = (0,styled_components_browser_esm/* default */.ZP)(BookingStatus).withConfig({
    componentId: "sc-ceadc88e-21"
})(_templateObject21(), function(param) {
    var theme = param.theme;
    return theme.color.primary600;
});
var Divider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ceadc88e-22"
})(_templateObject22(), function(param) {
    var theme = param.theme;
    return theme.color.gray100;
});
var DoctorSchedule = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ceadc88e-23"
})(_templateObject23(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI13R, ";\n    color: ").concat(theme.color.gray300, ";\n  ");
}); //
 // const PriceAndPoint = styled.div`
 //   display: flex;
 //   flex-direction: column;
 //   justify-content: flex-end;
 //   align-items: flex-start;
 //   align-self: stretch;
 // `;
 //
 // const PointRow = styled.div`
 //   display: flex;
 //   align-items: center;
 //   gap: 2px;
 // `;
 //
 // const PointDescription = styled.div`
 //   ${({ theme }) => `
 //     ${theme.typography.UI11R};
 //     color: ${theme.color.gray400};
 //   `}
 // `;
 //
 // const PointDiscountedPrice = styled.p`
 //   ${({ theme }) => `
 //     ${theme.typography.UI11R};
 //     color: ${theme.color.gray200};
 //   `}
 //   text-decoration: line-through;
 // `;
 //
 // const PriceRow = styled.div`
 //   display: flex;
 //   align-items: center;
 //   gap: 6px;
 // `;
 //
 // const PillPrice = styled.div`
 //   ${({ theme }) => `
 //     ${theme.typography.UI18SB};
 //     color: ${theme.color.gray700};
 //   `}
 // `;
 //
 // const PillNameAndUnit = styled.div`
 //   ${({ theme }) => `
 //     ${theme.typography.UI13M};
 //     color: ${theme.color.gray300};
 //   `}
 // `;

;// CONCATENATED MODULE: ./src/components/atom/icon/QuestionBox.tsx

var QuestionBox = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.5833 45.0348V38.375H23.9999L13.8265 46.5554C12.528 47.5995 10.5833 46.6877 10.5833 45.0348Z",
                fill: "#F1F3F6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "1",
                y: "1",
                width: "46",
                height: "37.375",
                rx: "6",
                fill: "#F1F3F6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M23.669 7.50884C22.6371 7.54995 21.6747 7.8002 20.7235 8.27478C18.6217 9.32333 17.1579 11.3339 16.827 13.6268C16.6838 14.6191 16.7373 15.2085 17.0136 15.6827C17.3123 16.1952 17.7835 16.5589 18.3395 16.7059C18.5038 16.7494 18.5665 16.7556 18.857 16.757C19.2407 16.7589 19.403 16.7318 19.6888 16.6181C20.2736 16.3856 20.7644 15.8447 20.9374 15.2424C20.9721 15.1213 20.9922 14.9863 21.0058 14.7813C21.0354 14.338 21.0612 14.1342 21.1127 13.9383C21.3946 12.8664 22.222 12.0608 23.3084 11.8004C24.6277 11.4841 26.0206 12.1126 26.6394 13.3033C26.8735 13.7536 26.9746 14.1661 26.9739 14.668C26.9729 15.464 26.6708 16.182 26.0993 16.7468C25.7176 17.1239 25.2771 17.3724 24.7384 17.5142C24.5358 17.5675 24.3543 17.5908 23.9704 17.6125C23.5951 17.6338 23.3565 17.6841 23.1218 17.7912C22.5695 18.0434 22.1134 18.5596 21.9505 19.1171C21.8753 19.3743 21.8609 19.6071 21.8609 20.5645C21.8609 21.7462 21.8828 21.926 22.0744 22.3142C22.2464 22.6626 22.5085 22.9568 22.8425 23.1765C23.0314 23.3007 23.2229 23.3839 23.4736 23.4506C23.6397 23.4948 23.6952 23.5 23.9995 23.5C24.3039 23.5 24.3594 23.4948 24.5255 23.4506C24.7762 23.3839 24.9677 23.3007 25.1566 23.1765C25.699 22.8198 26.0639 22.242 26.1121 21.6636L26.1244 21.5153L26.282 21.464C27.813 20.9656 29.1522 19.9477 30.06 18.5924C30.9244 17.3018 31.3466 15.706 31.2313 14.1648C31.1593 13.2015 30.9173 12.3214 30.4939 11.483C29.6288 9.77015 28.1541 8.49535 26.3132 7.8689C25.7444 7.67536 24.9849 7.53518 24.3981 7.51547C24.2377 7.51009 24.0802 7.50351 24.0482 7.50086C24.0161 7.49823 23.8455 7.50182 23.669 7.50884ZM23.4809 26.5108C22.5197 26.6199 21.7143 27.2604 21.3849 28.1778C21.2052 28.6782 21.205 29.3178 21.3846 29.8205C21.6705 30.6212 22.3214 31.2165 23.1367 31.423C24.1719 31.6852 25.2524 31.2641 25.8462 30.367C25.9537 30.2046 26.0447 30.0207 26.1166 29.8205C26.2938 29.327 26.2945 28.7217 26.1184 28.2093C25.8691 27.4839 25.2681 26.8837 24.5417 26.6347C24.229 26.5275 23.7876 26.476 23.4809 26.5108Z",
                fill: "#C6CACE"
            })
        ]
    });
};
/* harmony default export */ var icon_QuestionBox = (QuestionBox);

;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/SearchResult/Doctor/DoctorResultEmpty.tsx

function DoctorResultEmpty_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-grid;\n  width: 100%;\n  height: calc(100vh - 168px);\n  text-align: center;\n  align-items: flex-start;\n"
    ]);
    DoctorResultEmpty_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DoctorResultEmpty_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 80px 0 80px 0;\n"
    ]);
    DoctorResultEmpty_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DoctorResultEmpty_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n\n  margin-top: 24px;\n  white-space: pre-wrap;\n"
    ]);
    DoctorResultEmpty_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function DoctorResultEmpty_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n\n  margin: 16px 0 20px 0;\n  white-space: pre-wrap;\n"
    ]);
    DoctorResultEmpty_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function DoctorResultEmpty_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: center;\n  display: flex;\n"
    ]);
    DoctorResultEmpty_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function DoctorResultEmpty_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 200px;\n  height: 48px;\n  padding: 0px 20px;\n  border-radius: 8px;\n\n  ",
        "\n"
    ]);
    DoctorResultEmpty_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var DoctorResultEmpty = function(param) {
    var handleClickRequestButton = param.handleClickRequestButton;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorResultEmpty_Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DoctorResultEmpty_Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_QuestionBox, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorResultEmpty_EmptyResultTitle, {
                    children: "찾으시는 정보가\n없으신가요?"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorResultEmpty_EmptyResultOffer, {
                    children: "증상 / 과목을 선택하여\n진료 정보를 확인해보세요."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorResultEmpty_ButtonSection, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorResultEmpty_Button, {
                        onClick: handleClickRequestButton,
                        children: "증상/과목 전체 보기"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Doctor_DoctorResultEmpty = (DoctorResultEmpty);
var DoctorResultEmpty_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7da1a3b5-0"
})(DoctorResultEmpty_templateObject());
var DoctorResultEmpty_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7da1a3b5-1"
})(DoctorResultEmpty_templateObject1());
var DoctorResultEmpty_EmptyResultTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7da1a3b5-2"
})(DoctorResultEmpty_templateObject2(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI20SB, ";\n    color: ").concat(theme.color.gray600, ";\n  ");
});
var DoctorResultEmpty_EmptyResultOffer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7da1a3b5-3"
})(DoctorResultEmpty_templateObject3(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI15R, "\n    color: ").concat(theme.color.gray400, ";\n  ");
});
var DoctorResultEmpty_ButtonSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7da1a3b5-4"
})(DoctorResultEmpty_templateObject4());
var DoctorResultEmpty_Button = (0,styled_components_browser_esm/* default */.ZP)(DefaultButton/* DefaultButtonStyled */.qY).withConfig({
    componentId: "sc-7da1a3b5-5"
})(DoctorResultEmpty_templateObject5(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI16SB, ";\n    color: ").concat(theme.color.white, ";\n    background: ").concat(theme.color.primary600, ";\n  ");
});

// EXTERNAL MODULE: ./src/components/atom/Skeleton/index.tsx + 1 modules
var Skeleton = __webpack_require__(13971);
;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/SearchResult/Doctor/DoctorSkeleton.tsx

function DoctorSkeleton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px 24px;\n  display: flex;\n  width: 100%;\n"
    ]);
    DoctorSkeleton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DoctorSkeleton_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 16px;\n"
    ]);
    DoctorSkeleton_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DoctorSkeleton_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n"
    ]);
    DoctorSkeleton_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function DoctorSkeleton_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    DoctorSkeleton_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var DoctorItemSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DoctorSkeleton_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Left, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    style: {
                        width: 56,
                        height: 56,
                        borderRadius: 100
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Right, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        style: {
                            width: "25%",
                            height: 20,
                            marginBottom: 4
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        style: {
                            width: "50%",
                            height: 18,
                            marginBottom: 4
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                style: {
                                    width: "20%",
                                    height: 18,
                                    marginRight: 6
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                style: {
                                    width: "20%",
                                    height: 18
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var DoctorSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: Array.from({
            length: 8
        }).map(function(_, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorItemSkeleton, {}, "skeleton_".concat(i));
        })
    });
};
/* harmony default export */ var Doctor_DoctorSkeleton = (DoctorSkeleton);
var DoctorSkeleton_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-637c70ec-0"
})(DoctorSkeleton_templateObject());
var Left = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-637c70ec-1"
})(DoctorSkeleton_templateObject1());
var Row = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-637c70ec-2"
})(DoctorSkeleton_templateObject2());
var Right = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-637c70ec-3"
})(DoctorSkeleton_templateObject3());

;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/SearchResult/Doctor/index.tsx

function SearchResult_Doctor_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  > section > div > div:not(:last-child) {\n    border-bottom-width: 1px;\n    border-bottom-color: ",
        ";\n    border-bottom-style: solid;\n  }\n"
    ]);
    SearchResult_Doctor_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var DoctorSearchResult = function(param) {
    var viewModel = param.viewModel;
    var ref;
    if (viewModel.isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Doctor_DoctorSkeleton, {});
    }
    if (!viewModel.doctors.length) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Doctor_DoctorResultEmpty, {
            handleClickRequestButton: viewModel.moveToCategoryListScreen
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResult_Doctor_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfiniteScroll/* default */.Z, {
            isLoading: viewModel.isLoading,
            hasNextPage: viewModel.hasNextPage,
            fetchNextPage: viewModel.fetchNextPage,
            children: (ref = viewModel.doctors) === null || ref === void 0 ? void 0 : ref.map(function(doctor) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Doctor_Doctor, {
                    doctor: doctor,
                    onClick: function() {
                        return viewModel.onClickDoctor(doctor.publicId);
                    }
                }, doctor.id);
            })
        })
    });
};
/* harmony default export */ var SearchResult_Doctor = (DoctorSearchResult);
var SearchResult_Doctor_Wrapper = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-e3579ea1-0"
})(SearchResult_Doctor_templateObject(), function(param) {
    var theme = param.theme;
    return theme.color.gray40;
});

// EXTERNAL MODULE: ./src/components/common/ClickEventLogger.tsx
var ClickEventLogger = __webpack_require__(9558);
// EXTERNAL MODULE: ./src/components/atom/buttons/BoxButton.tsx
var BoxButton = __webpack_require__(36432);
// EXTERNAL MODULE: ./src/components/atom/icon/search/HelpQuestion.tsx
var HelpQuestion = __webpack_require__(74976);
;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/EmptyResult/index.tsx

function EmptyResult_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-grid;\n  width: 100%;\n  height: calc(100vh - 180px);\n  text-align: center;\n  align-items: center;\n"
    ]);
    EmptyResult_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EmptyResult_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    EmptyResult_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function EmptyResult_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  color: ",
        ";\n  margin-top: 20px;\n"
    ]);
    EmptyResult_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function EmptyResult_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  color: ",
        ";\n  margin: 8px 0 20px;\n"
    ]);
    EmptyResult_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function EmptyResult_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: center;\n  display: flex;\n"
    ]);
    EmptyResult_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var EmptyResult = function(param) {
    var handleClickRequestButton = param.handleClickRequestButton;
    var handleButtonClick = function() {
        handleClickRequestButton("middle");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyResult_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmptyResultWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpQuestion/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyResult_EmptyResultTitle, {
                    children: "지금 궁금한 내용은 뭐였나요?"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmptyResult_EmptyResultOffer, {
                    children: [
                        "필요한 정보를 알려주시면",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "검색 결과 개선에 큰 도움이 돼요"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyResult_ButtonSection, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxButton/* default */.ZP, {
                        size: BoxButton/* BOX_BUTTON_SIZE.LARGE */.TY.LARGE,
                        color: BoxButton/* BOX_BUTTON_COLOR.PRIMARY */.po.PRIMARY,
                        onClick: handleButtonClick,
                        children: "정보 요청하기"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_EmptyResult = (EmptyResult);
var EmptyResult_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e2f548e-0"
})(EmptyResult_templateObject());
var EmptyResultWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e2f548e-1"
})(EmptyResult_templateObject1());
var EmptyResult_EmptyResultTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e2f548e-2"
})(EmptyResult_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.typography.UI20SB;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray600;
});
var EmptyResult_EmptyResultOffer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e2f548e-3"
})(EmptyResult_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.typography.UI15R;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray400;
});
var EmptyResult_ButtonSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e2f548e-4"
})(EmptyResult_templateObject4());

;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/RequestInfoBox/index.tsx

function RequestInfoBox_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-grid;\n  width: 100%;\n  text-align: center;\n  align-items: center;\n  padding-top: 40px;\n  margin-bottom: 80px;\n"
    ]);
    RequestInfoBox_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RequestInfoBox_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  color: ",
        ";\n  margin-top: 20px;\n"
    ]);
    RequestInfoBox_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function RequestInfoBox_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  color: ",
        ";\n  margin: 8px 0 20px;\n"
    ]);
    RequestInfoBox_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function RequestInfoBox_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: center;\n  display: flex;\n"
    ]);
    RequestInfoBox_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var RequestInfoBox = function(param) {
    var handleClickRequestButton = param.handleClickRequestButton;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RequestInfoBox_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestInfoBox_EmptyResultTitle, {
                children: "찾으시는 정보가 없나요?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestInfoBox_EmptyResultOffer, {
                children: "정보를 알려주시면 빠르게 개선할게요"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestInfoBox_ButtonSection, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxButton/* default */.ZP, {
                    size: BoxButton/* BOX_BUTTON_SIZE.MEDIUM */.TY.MEDIUM,
                    color: BoxButton/* BOX_BUTTON_COLOR.SECONDARY */.po.SECONDARY,
                    onClick: handleClickRequestButton,
                    children: "정보 요청하기"
                })
            })
        ]
    });
};
/* harmony default export */ var components_RequestInfoBox = (RequestInfoBox);
var RequestInfoBox_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8550f17e-0"
})(RequestInfoBox_templateObject());
var RequestInfoBox_EmptyResultTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8550f17e-1"
})(RequestInfoBox_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.typography.UI20SB;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray600;
});
var RequestInfoBox_EmptyResultOffer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8550f17e-2"
})(RequestInfoBox_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.typography.UI15R;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray400;
});
var RequestInfoBox_ButtonSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8550f17e-3"
})(RequestInfoBox_templateObject3());

// EXTERNAL MODULE: ./src/components/atom/text/DefaultText.tsx
var DefaultText = __webpack_require__(40202);
// EXTERNAL MODULE: ./src/utils/format.ts
var format = __webpack_require__(4611);
;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/SearchMagazineItem/index.tsx

function SearchMagazineItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 24px;\n  display: flex;\n\n  &:active {\n    background: ",
        ";\n  }\n"
    ]);
    SearchMagazineItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SearchMagazineItem_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 20px;\n  width: calc(100% - 116px);\n"
    ]);
    SearchMagazineItem_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SearchMagazineItem_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 8px;\n  * {\n    &:nth-child(1) {\n      ",
        ";\n      color: ",
        ";\n    }\n    &:nth-child(3) {\n      ",
        ";\n      color: ",
        ";\n    }\n  }\n\n  svg {\n    margin: 0 8px;\n  }\n\n  time {\n    visibility: hidden;\n  }\n"
    ]);
    SearchMagazineItem_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SearchMagazineItem_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  ",
        ";\n  color: ",
        ";\n  margin-bottom: 4px;\n"
    ]);
    SearchMagazineItem_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SearchMagazineItem_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  ",
        ";\n  color: ",
        ";\n"
    ]);
    SearchMagazineItem_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SearchMagazineItem_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  position: relative;\n  border: 1px solid ",
        ";\n  border-radius: 8px;\n  overflow: hidden;\n  margin-top: 4px;\n"
    ]);
    SearchMagazineItem_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function SearchMagazineItem_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 94px;\n  height: 70px;\n  object-fit: cover;\n"
    ]);
    SearchMagazineItem_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function SearchMagazineItem_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  color: ",
        ";\n  background: ",
        ";\n  padding: 5px 0;\n  text-align: center;\n  border-radius: 4px;\n  margin-top: 4px;\n"
    ]);
    SearchMagazineItem_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function SearchMagazineItem_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    SearchMagazineItem_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}





var SearchMagazineItem = function(param) {
    var magazine = param.magazine, containerStyle = param.containerStyle, onClickMagazine = param.onClickMagazine;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchMagazineItem_Wrapper, {
        onClick: onClickMagazine,
        style: containerStyle,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchMagazineItem_Left, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Category, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: magazine.createdDate
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                                dateTime: (0,format/* absoluteTime */.wE)(magazine.createdAt)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        children: magazine.mobileTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                        children: magazine.mobileDescription
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchMagazineItem_Right, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Img, {
                            src: magazine.titleImageUrl
                        })
                    }),
                    magazine.author && /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorColumn, {
                        children: "의사 칼럼"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_SearchMagazineItem = (SearchMagazineItem);
var SearchMagazineItem_Wrapper = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    componentId: "sc-a3878618-0"
})(SearchMagazineItem_templateObject(), function(param) {
    var _$theme = param.theme;
    return _$theme.color.gray30;
});
var SearchMagazineItem_Left = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a3878618-1"
})(SearchMagazineItem_templateObject1());
var Category = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a3878618-2"
})(SearchMagazineItem_templateObject2(), styles_theme/* default.typography.UI12M */.Z.typography.UI12M, styles_theme/* default.color.primary500 */.Z.color.primary500, styles_theme/* default.typography.UI12M */.Z.typography.UI12M, styles_theme/* default.color.gray400 */.Z.color.gray400);
var Title = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-a3878618-3"
})(SearchMagazineItem_templateObject3(), DefaultText/* EllipsisTextStyle */.Ew, styles_theme/* default.typography.UI16SB */.Z.typography.UI16SB, styles_theme/* default.color.gray700 */.Z.color.gray700);
var Description = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-a3878618-4"
})(SearchMagazineItem_templateObject4(), DefaultText/* EllipsisTextStyle */.Ew, styles_theme/* default.typography.UI14R */.Z.typography.UI14R, styles_theme/* default.color.gray500 */.Z.color.gray500);
var ImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a3878618-5"
})(SearchMagazineItem_templateObject5(), styles_theme/* default.color.gray200 */.Z.color.gray200);
var Img = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-a3878618-6"
})(SearchMagazineItem_templateObject6());
var DoctorColumn = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a3878618-7"
})(SearchMagazineItem_templateObject7(), styles_theme/* default.typography.UI12M */.Z.typography.UI12M, styles_theme/* default.color.blue500 */.Z.color.blue500, styles_theme/* default.color.blue100 */.Z.color.blue100);
var SearchMagazineItem_Right = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a3878618-8"
})(SearchMagazineItem_templateObject8());

// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
// EXTERNAL MODULE: ./node_modules/recoil/es/index.js
var es = __webpack_require__(4480);
// EXTERNAL MODULE: ./src/components/atom/icon/ChatBubbleTextOval.tsx
var icon_ChatBubbleTextOval = __webpack_require__(46737);
// EXTERNAL MODULE: ./src/components/atom/icon/DotMenu.tsx
var icon_DotMenu = __webpack_require__(48537);
// EXTERNAL MODULE: ./src/components/atom/icon/FavoriteHeart.tsx
var icon_FavoriteHeart = __webpack_require__(17042);
// EXTERNAL MODULE: ./src/components/molecules/CommunityUserNickName.tsx + 1 modules
var molecules_CommunityUserNickName = __webpack_require__(36221);
// EXTERNAL MODULE: ./src/components/molecules/ProfileImage/index.tsx
var molecules_ProfileImage = __webpack_require__(66039);
// EXTERNAL MODULE: ./src/components/templates/mobile/communication/Common/MypageMobileTemplate/DeletedItemByReport.tsx
var MypageMobileTemplate_DeletedItemByReport = __webpack_require__(88143);
// EXTERNAL MODULE: ./src/components/templates/mobile/communication/Common/ReportTemplate/index.tsx
var ReportTemplate = __webpack_require__(53137);
// EXTERNAL MODULE: ./src/hooks/useAuthModal.tsx
var hooks_useAuthModal = __webpack_require__(71213);
// EXTERNAL MODULE: ./src/recoil/atoms/common/auth.ts
var auth = __webpack_require__(4415);
// EXTERNAL MODULE: ./src/types/community.ts
var community = __webpack_require__(45140);
// EXTERNAL MODULE: ./src/utils/image.ts
var utils_image = __webpack_require__(60288);
;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/SearchPostItem/index.tsx

function SearchPostItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n\n  ",
        ";\n"
    ]);
    SearchPostItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SearchPostItem_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 6px;\n  padding-bottom: 16px;\n"
    ]);
    SearchPostItem_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SearchPostItem_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 5px 10px;\n  border-radius: 4px;\n\n  ",
        "\n"
    ]);
    SearchPostItem_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SearchPostItem_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-bottom: 16px;\n"
    ]);
    SearchPostItem_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SearchPostItem_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    SearchPostItem_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SearchPostItem_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 1;\n  overflow: hidden;\n  margin-bottom: 8px;\n\n  ",
        ";\n"
    ]);
    SearchPostItem_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function SearchPostItem_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    SearchPostItem_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function SearchPostItem_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 72px;\n  height: 72px;\n  border-radius: 16px;\n  margin-left: 16px;\n  overflow: hidden;\n\n  ",
        "\n"
    ]);
    SearchPostItem_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function SearchPostItem_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    SearchPostItem_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function SearchPostItem_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    SearchPostItem_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function SearchPostItem_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 12px;\n"
    ]);
    SearchPostItem_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function SearchPostItem_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  display: flex;\n"
    ]);
    SearchPostItem_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function SearchPostItem_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    SearchPostItem_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function SearchPostItem_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    SearchPostItem_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function SearchPostItem_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  margin-right: 16px;\n\n  &:nth-last-child(2) {\n    margin-right: 12px;\n  }\n\n  svg {\n    margin-right: 8px;\n  }\n\n  ",
        ";\n"
    ]);
    SearchPostItem_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function SearchPostItem_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 6px;\n  border-radius: 6px;\n  ",
        ";\n"
    ]);
    SearchPostItem_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}






















var getTagColor = function(type) {
    switch(type){
        case community/* BOARD_POST_TAG_TYPE.POPULAR */.q.POPULAR:
            return "\n          background: ".concat(styles_theme/* default.color.primary200 */.Z.color.primary200, ";\n          color: ").concat(styles_theme/* default.color.primary700 */.Z.color.primary700, ";\n        ");
        case community/* BOARD_POST_TAG_TYPE.RECOMMENDED */.q.RECOMMENDED:
            return "\n          background: ".concat(styles_theme/* default.color.blue200 */.Z.color.blue200, ";\n          color: ").concat(styles_theme/* default.color.blue700 */.Z.color.blue700, ";\n        ");
        case community/* BOARD_POST_TAG_TYPE.DEFAULT */.q.DEFAULT:
        default:
            return "\n          background: ".concat(styles_theme/* default.color.gray50 */.Z.color.gray50, ";\n          color: ").concat(styles_theme/* default.color.gray500 */.Z.color.gray500, ";\n        ");
    }
};
var SearchPostItem = function(param) {
    var post = param.post, isMypage = param.isMypage, onShowReportModal = param.onShowReportModal, containerStyle = param.containerStyle, onClickPost = param.onClickPost;
    var ref;
    var token = useRecoilValue(tokenState);
    var setShowAuthModal = useAuthModal().setShowAuthModal;
    var profileImage = useMemo(function() {
        return post.communityUser.profileImageUrl;
    }, []);
    var isImageBlind = ((ref = post.boardPostAttachments[0]) === null || ref === void 0 ? void 0 : ref.blindType) === AttachmentBlindType.Blinded;
    var onClickDotMenu = function(e) {
        e.stopPropagation();
        e.preventDefault();
        if (!token) {
            setShowAuthModal(true);
            return;
        }
        onShowReportModal(e, {
            targetId: post.boardPostPid,
            targetType: REPORT_TYPE.BOARD_POST,
            isMine: post.isMine
        });
    };
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsx(Link, {
            href: "".concat(ROUTES.COMMUNITY.DETAIL.path, "/").concat(post.boardPostPid),
            children: /*#__PURE__*/ _jsx("a", {
                role: "presentation",
                onClick: function(e) {
                    return onClickPost(e);
                },
                children: /*#__PURE__*/ _jsxs(SearchPostItem_Container, {
                    style: containerStyle,
                    children: [
                        !!post.tags.length && /*#__PURE__*/ _jsx(SearchPostItem_Tags, {
                            children: post.tags.map(function(tag, key) {
                                return /*#__PURE__*/ _jsx(SearchPostItem_Tag, {
                                    type: tag.type,
                                    children: tag.label
                                }, key);
                            })
                        }),
                        /*#__PURE__*/ _jsxs(BodyWrapper, {
                            children: [
                                /*#__PURE__*/ _jsxs(Body, {
                                    children: [
                                        /*#__PURE__*/ _jsx(SearchPostItem_Title, {
                                            children: post.title
                                        }),
                                        /*#__PURE__*/ _jsx(SearchPostItem_Content, {
                                            children: post.content
                                        })
                                    ]
                                }),
                                !!post.boardPostAttachments.length && !isImageBlind && /*#__PURE__*/ _jsx(PostImage, {
                                    children: /*#__PURE__*/ _jsx(Image, {
                                        alt: "img",
                                        width: 72,
                                        height: 72,
                                        src: resizingImg({
                                            originUrl: redirectPostImage(post.boardPostAttachments[0].boardPostAttachmentId),
                                            width: 140,
                                            height: 140
                                        }),
                                        objectFit: "cover"
                                    })
                                })
                            ]
                        }),
                        isMypage && post.blinded && /*#__PURE__*/ _jsx(DeletedItemByReport, {
                            containerStyle: {
                                marginBottom: 16
                            }
                        }),
                        /*#__PURE__*/ _jsxs(Bottom, {
                            children: [
                                /*#__PURE__*/ _jsxs(ProfileInfo, {
                                    children: [
                                        !isMypage && /*#__PURE__*/ _jsx(SearchPostItem_ProfileImageWrapper, {
                                            children: /*#__PURE__*/ _jsx(ProfileImage, {
                                                width: 32,
                                                height: 32,
                                                src: profileImage
                                            })
                                        }),
                                        /*#__PURE__*/ _jsxs(Author, {
                                            children: [
                                                !isMypage && /*#__PURE__*/ _jsx(CommunityUserNickName, {
                                                    userId: post.communityUser.userId,
                                                    nickName: post.communityUser.nickname
                                                }),
                                                /*#__PURE__*/ _jsx(SearchPostItem_Date, {
                                                    children: post.formattedCreatedAt
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(AsideIconWrapper, {
                                    children: [
                                        /*#__PURE__*/ _jsxs(Icon, {
                                            children: [
                                                /*#__PURE__*/ _jsx(FavoriteHeart, {
                                                    color: theme.color.gray300,
                                                    isActive: post.isLikedByMe
                                                }),
                                                " ",
                                                post.likeCount
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs(Icon, {
                                            children: [
                                                /*#__PURE__*/ _jsx(ChatBubbleTextOval, {}),
                                                " ",
                                                post.boardCommentCount
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(ButtonIcon, {
                                            onClick: onClickDotMenu,
                                            children: /*#__PURE__*/ _jsx(DotMenu, {})
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var components_SearchPostItem = ((/* unused pure expression or super */ null && (SearchPostItem)));
var SearchPostItem_Container = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-71b466ad-0"
})(SearchPostItem_templateObject(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.white, ";\n    border-bottom: 8px solid ").concat(theme.color.gray30, ";\n  ");
});
var SearchPostItem_Tags = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-71b466ad-1"
})(SearchPostItem_templateObject1());
var SearchPostItem_Tag = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-71b466ad-2"
})(SearchPostItem_templateObject2(), function(param) {
    var theme = param.theme, type = param.type;
    return "\n    ".concat(theme.typography.UI12M, ";\n    ").concat(getTagColor(type), ";\n  ");
});
var BodyWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-71b466ad-3"
})(SearchPostItem_templateObject3());
var Body = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-71b466ad-4"
})(SearchPostItem_templateObject4());
var SearchPostItem_Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-71b466ad-5"
})(SearchPostItem_templateObject5(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI18SB, ";\n    color: ").concat(theme.color.gray700, ";\n  ");
});
var SearchPostItem_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-71b466ad-6"
})(SearchPostItem_templateObject6(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI14R, ";\n    ").concat(DefaultText/* EllipsisTextStyle */.Ew, ";\n    color: ").concat(theme.color.gray500, ";\n  ");
});
var PostImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-71b466ad-7"
})(SearchPostItem_templateObject7(), function(param) {
    var theme = param.theme;
    return "\n    border: 1px solid ".concat(theme.color.gray100, ";\n  ");
});
var Bottom = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-71b466ad-8"
})(SearchPostItem_templateObject8());
var ProfileInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-71b466ad-9"
})(SearchPostItem_templateObject9());
var SearchPostItem_ProfileImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-71b466ad-10"
})(SearchPostItem_templateObject10());
var Author = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-71b466ad-11"
})(SearchPostItem_templateObject11());
var SearchPostItem_Date = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-71b466ad-12"
})(SearchPostItem_templateObject12(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI12R, ";\n    color: ").concat(theme.color.gray300, ";\n  ");
});
var AsideIconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-71b466ad-13"
})(SearchPostItem_templateObject13());
var Icon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-71b466ad-14"
})(SearchPostItem_templateObject14(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI14M, ";\n    color: ").concat(theme.color.gray300, ";\n  ");
});
var ButtonIcon = (0,styled_components_browser_esm/* default */.ZP)(DefaultButton/* DefaultButtonStyled */.qY).withConfig({
    componentId: "sc-71b466ad-15"
})(SearchPostItem_templateObject15(), function(param) {
    var theme = param.theme;
    return "\n    &: active {\n      background: ".concat(theme.color.gray50, "\n    }\n  ");
});

// EXTERNAL MODULE: ./src/assets/lottie/loading-dot-ongoing.json
var loading_dot_ongoing = __webpack_require__(65196);
// EXTERNAL MODULE: ./src/assets/lottie/loading-dot-wait.json
var loading_dot_wait = __webpack_require__(28989);
// EXTERNAL MODULE: ./src/components/atom/CustomLottieIcon.tsx
var CustomLottieIcon = __webpack_require__(84655);
// EXTERNAL MODULE: ./src/components/atom/icon/DefaultDoctorProfile.tsx
var DefaultDoctorProfile = __webpack_require__(78764);
// EXTERNAL MODULE: ./src/components/molecules/LazyImage.tsx + 1 modules
var LazyImage = __webpack_require__(52883);
// EXTERNAL MODULE: ./src/components/molecules/QuestionList/QuestionItem/index.tsx + 1 modules
var QuestionItem = __webpack_require__(38427);
// EXTERNAL MODULE: ./src/components/molecules/QuestionList/QuestionItem/BlockQuestion/index.tsx + 1 modules
var BlockQuestion = __webpack_require__(95843);
;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/SearchQuestionItem/index.tsx
/* eslint-disable @typescript-eslint/no-explicit-any */ 
function SearchQuestionItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    SearchQuestionItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SearchQuestionItem_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n\n  ",
        ";\n\n  & > div {\n    margin-right: 8px;\n  }\n"
    ]);
    SearchQuestionItem_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SearchQuestionItem_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  position: relative;\n  margin-right: 8px;\n"
    ]);
    SearchQuestionItem_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SearchQuestionItem_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  img {\n    border: 2px solid white;\n  }\n\n  ",
        ";\n"
    ]);
    SearchQuestionItem_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}












var SearchQuestionItem = function(param) {
    var questionCard = param.questionCard, onClickQuestion = param.onClickQuestion, itemStyle = param.itemStyle;
    var _question = questionCard.question, questionPid = _question.questionPid, isBlockedByMe = _question.isBlockedByMe;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionWrapper, {
        onClick: function() {
            !isBlockedByMe && onClickQuestion(questionPid);
        },
        style: itemStyle,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: isBlockedByMe ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockQuestion/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionItem/* default */.Z, {
                isPaidQuestion: false,
                questionCard: questionCard,
                onClickQuestion: function() {
                    return onClickQuestion(questionPid);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionItem/* default.BottomLeft */.Z.BottomLeft, {
                    children: questionCard.answeredStatus === gql_schema/* QuestionAnsweredStatus.Answered */.G2.Answered ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuestionBottomAnswerStatus, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionDoctorImageWrapper, {
                                children: questionCard.answererProfileImageUrls.slice(0, 5).map(function(image, key) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionDoctorImage, {
                                        imageKey: key,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage/* default */.ZP, {
                                            width: 28,
                                            height: 28,
                                            objectFit: "cover",
                                            loader: /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultDoctorProfile/* default */.Z, {}),
                                            src: image,
                                            alt: "답변한 의사 프로필 이미지"
                                        })
                                    }, "answered-doctor-".concat(key));
                                })
                            }),
                            questionCard.answererCount,
                            "개의 답변"
                        ]
                    }) : questionCard.question.status !== gql_schema/* QuestionStatus.AwaitingBasicAnswer */.xV.AwaitingBasicAnswer ? // 답변 중 / 답변 확인 중
                    // 목록
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuestionBottomAnswerStatus, {
                        fontColor: questionCard.answeredStatus === gql_schema/* QuestionAnsweredStatus.Answering */.G2.Answering ? styles_theme/* default.color.primary500 */.Z.color.primary500 : styles_theme/* default.color.blue500 */.Z.color.blue500,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLottieIcon/* default */.Z, {
                                width: 24,
                                height: 24,
                                animationData: questionCard.answeredStatus === gql_schema/* QuestionAnsweredStatus.Answering */.G2.Answering ? loading_dot_ongoing : loading_dot_wait,
                                style: {
                                    marginRight: 8
                                }
                            }),
                            questionCard.answeredStatusText
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                })
            }, questionPid)
        })
    });
};
/* harmony default export */ var components_SearchQuestionItem = (SearchQuestionItem);
var QuestionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f2b9fe09-0"
})(SearchQuestionItem_templateObject(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.white, ";\n    ");
});
var QuestionBottomAnswerStatus = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f2b9fe09-1"
})(SearchQuestionItem_templateObject1(), function(param) {
    var theme = param.theme, fontColor = param.fontColor;
    return "\n    ".concat(theme.typography.UI14SB, ";\n    color: ").concat(fontColor !== null && fontColor !== void 0 ? fontColor : theme.color.gray700, ";\n  ");
});
var QuestionDoctorImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f2b9fe09-2"
})(SearchQuestionItem_templateObject2());
var QuestionDoctorImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f2b9fe09-3"
})(SearchQuestionItem_templateObject3(), function(param) {
    var imageKey = param.imageKey;
    return "\n    margin-left: -".concat(imageKey ? 8 : 0, "px;\n    z-index: ").concat(5 - imageKey, ";\n  ");
});

;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/index.ts








;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/SearchResult/Integrated/index.tsx

function Integrated_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  > div:not(:last-child) {\n    border-bottom-width: 1px;\n    border-bottom-color: ",
        ";\n    border-bottom-style: solid;\n  }\n"
    ]);
    Integrated_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Integrated_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  > *:not(:last-child) > div {\n    border-bottom-style: solid;\n    border-bottom-width: 1px;\n    border-bottom-color: ",
        ";\n  }\n"
    ]);
    Integrated_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}













var getSearchResultTemplateItemStyle = function(isLast) {
    return {
        margin: "24px 24px 0px",
        padding: "0px 0px 24px",
        borderBottom: isLast ? "none" : "1px solid ".concat(styles_theme/* default.color.gray40 */.Z.color.gray40)
    };
};
var IntegratedSearchResult = function(param) {
    var viewModel = param.viewModel, doctorViewModel = param.doctorViewModel;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var ref10 = (0,useReportModal/* default */.ZP)(), showReportModal = ref10.showReportModal, onCloseReportModal = ref10.onCloseReportModal, reportItems = ref10.reportItems;
    if (!viewModel.isVisibleRecentKeyword && viewModel.hasNoData) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_EmptyResult, {
            handleClickRequestButton: viewModel.handleClickRequestButton
        });
    }
    var ref11, ref12, ref13;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_ResultSection, {
                title: "비대면 진료",
                hasResultData: !!viewModel.doctors.length,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ResultSection.Result, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorResultWrapper, {
                            children: (ref = viewModel.doctors) === null || ref === void 0 ? void 0 : ref.map(function(doctor) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Doctor_Doctor, {
                                    onClick: function() {
                                        return doctorViewModel.onClickDoctor(doctor.publicId);
                                    },
                                    doctor: doctor
                                }, "search-result-doctor-".concat(doctor.id));
                            })
                        })
                    }),
                    viewModel.hasMoreDoctors && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ResultSection.MoreButton, {
                        style: {
                            marginTop: 0
                        },
                        onClick: function() {
                            return viewModel.onChangeTabByMoreData(IntegratedSearchTabType.Doctor);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_ResultSection, {
                title: "방문 예약",
                hasResultData: (ref11 = !!((ref1 = viewModel.keywordSearchHospital) === null || ref1 === void 0 ? void 0 : ref1.elements.length)) !== null && ref11 !== void 0 ? ref11 : false,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ResultSection.ResultAddress, {
                        address: viewModel.getHeaderAddress(),
                        getCurrentLocation: viewModel.requestGeolocationPermission
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ResultSection.ResultWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Integrated_HospitalResultWrapper, {
                            children: (ref2 = viewModel.keywordSearchHospital) === null || ref2 === void 0 ? void 0 : ref2.elements.map(function(hospital) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTag/* default */.Z, {
                                    onClickNavigateToScreen: function() {
                                        return viewModel.goToAppHospital(hospital.hospitalPublicId);
                                    },
                                    href: "".concat(common/* ROUTES.HOSPITAL.DETAIL.path */.Z6.HOSPITAL.DETAIL.path).concat(hospital.hospitalPublicId),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickEventLogger/* default */.Z, {
                                        pageName: "user_web_search",
                                        eventName: "search_item_click",
                                        payload: {
                                            keyword: viewModel.keyword,
                                            hospital_id: hospital.hospitalPublicId,
                                            tab: IntegratedSearchTabType.All,
                                            result_section: IntegratedSearchTabType.Hospital
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HospitalListItem/* default */.Z, {
                                            name: hospital.hospitalName,
                                            distance: hospital.hospitalDistance,
                                            rating: hospital.reviewScore,
                                            reviewTotalCount: hospital.reviewTotalCount,
                                            badges: hospital.hospitalBadges,
                                            imageUrl: hospital.hospitalRepresentativeImageUrl,
                                            address: hospital.hospitalAddress,
                                            status: hospital.hospitalOperationStatus,
                                            isBookable: hospital.isBookable,
                                            representativeDepartmentName: hospital.hospitalRepresentativeDepartmentName,
                                            hospitalPid: hospital.hospitalPublicId,
                                            doctorDetailPageHref: "".concat(common/* ROUTES.HOSPITAL.DETAIL.path */.Z6.HOSPITAL.DETAIL.path).concat(hospital.hospitalPublicId),
                                            onClickMoveToDoctorDetail: function() {
                                                viewModel.goToAppHospital(hospital.hospitalPublicId);
                                            },
                                            hasNonF2fDoctors: !!hospital.doctors.find(function(doctor) {
                                                return doctor.contractType === types_hospital/* ContractType.All */.RJ.All;
                                            })
                                        })
                                    })
                                }, "search_hospital_".concat(hospital.hospitalPublicId));
                            })
                        })
                    }),
                    ((ref3 = viewModel.keywordSearchHospital) === null || ref3 === void 0 ? void 0 : ref3.hasMore) && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ResultSection.MoreButton, {
                        style: {
                            marginTop: 0
                        },
                        onClick: function() {
                            return viewModel.onChangeTabByMoreData(IntegratedSearchTabType.Hospital);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_ResultSection, {
                title: "실시간 의료상담",
                hasResultData: (ref12 = !!((ref4 = viewModel.keywordSearchQna) === null || ref4 === void 0 ? void 0 : ref4.elements.length)) !== null && ref12 !== void 0 ? ref12 : false,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ResultSection.Result, {
                        children: (ref5 = viewModel.keywordSearchQna) === null || ref5 === void 0 ? void 0 : ref5.elements.map(function(question) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SearchQuestionItem, {
                                questionCard: question,
                                onClickQuestion: viewModel.handleClickQuestion
                            }, question.question.questionPid);
                        })
                    }),
                    ((ref6 = viewModel.keywordSearchQna) === null || ref6 === void 0 ? void 0 : ref6.hasMore) && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ResultSection.MoreButton, {
                        onClick: function() {
                            return viewModel.onChangeTabByMoreData(IntegratedSearchTabType.Qna);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_ResultSection, {
                title: "건강 매거진",
                hasResultData: (ref13 = !!((ref7 = viewModel.keywordSearchMagazine) === null || ref7 === void 0 ? void 0 : ref7.elements.length)) !== null && ref13 !== void 0 ? ref13 : false,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ResultSection.Result, {
                        children: (ref8 = viewModel.keywordSearchMagazine) === null || ref8 === void 0 ? void 0 : ref8.elements.map(function(magazine, index) {
                            var ref;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(components_SearchMagazineItem, {
                                magazine: magazine,
                                onClickMagazine: function() {
                                    return viewModel.handleClickMagazine(magazine);
                                },
                                pageName: "mobile_web_search",
                                containerStyle: getSearchResultTemplateItemStyle(viewModel.keywordSearchMagazine ? index === ((ref = viewModel.keywordSearchMagazine) === null || ref === void 0 ? void 0 : ref.elements.length) - 1 : false)
                            }, magazine.magazinePid);
                        })
                    }),
                    ((ref9 = viewModel.keywordSearchMagazine) === null || ref9 === void 0 ? void 0 : ref9.hasMore) && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ResultSection.MoreButton, {
                        onClick: function() {
                            return viewModel.onChangeTabByMoreData(IntegratedSearchTabType.Magazine);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RequestInfoBox, {
                handleClickRequestButton: function() {
                    return viewModel.handleClickRequestButton(RequestButtonType.BOTTOM);
                }
            }),
            reportItems && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportSelectModal/* default */.Z, {
                isVisible: showReportModal,
                onClose: onCloseReportModal,
                selectList: reportItems
            })
        ]
    });
};
/* harmony default export */ var Integrated = (IntegratedSearchResult);
var DoctorResultWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7c683e9d-0"
})(Integrated_templateObject(), function(param) {
    var theme = param.theme;
    return theme.color.gray40;
});
var Integrated_HospitalResultWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7c683e9d-1"
})(Integrated_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.color.gray40;
});

// EXTERNAL MODULE: ./src/components/common/communication/magazine/ListMagazineLine.tsx + 2 modules
var ListMagazineLine = __webpack_require__(79476);
// EXTERNAL MODULE: ./src/components/templates/mobile/communication/Magazine/MagazineMobileTemplate/MagazineSkeleton/index.tsx
var MagazineSkeleton = __webpack_require__(96871);
;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/SearchResult/Magazine/index.tsx

function Magazine_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    Magazine_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Magazine_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-grid;\n  width: 100%;\n  height: ",
        ";\n  text-align: center;\n  align-items: center;\n"
    ]);
    Magazine_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Magazine_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  color: ",
        ";\n  margin-top: 20px;\n"
    ]);
    Magazine_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Magazine_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  color: ",
        ";\n  margin: 8px 0 16px;\n"
    ]);
    Magazine_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}










var MagazineSearchResult = function(param) {
    var viewModel = param.viewModel;
    var ref, ref1, ref2;
    if (viewModel.isMagazinesLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MagazineSkeleton/* default */.Z, {});
    }
    if (!((ref = viewModel.magazinesData) === null || ref === void 0 ? void 0 : ref.pages.length)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResult_EmptySearchResult, {
            handleClickRequestButton: viewModel.handleClickRequestButton
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Magazine_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfiniteScroll/* default */.Z, {
            isLoading: viewModel.isMagazinesLoading,
            hasNextPage: viewModel.hasMagazinesNextPage,
            fetchNextPage: viewModel.fetchMagazinesNextPage,
            children: (ref1 = viewModel.magazinesData) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.pages) === null || ref2 === void 0 ? void 0 : ref2.map(function(magazine) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTag/* default */.Z, {
                    onClickNavigateToScreen: function() {
                        return viewModel.onClickMoveNative(magazine.magazinePid);
                    },
                    href: "".concat(common/* ROUTES.MAGAZINE.DETAIL.path */.Z6.MAGAZINE.DETAIL.path, "/").concat(magazine.magazinePid),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickEventLogWrapper, {
                        onClickEventLog: function() {
                            return viewModel.onClickLogMagazine(magazine.magazinePid);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListMagazineLine/* default */.Z, {
                            magazine: {
                                title: magazine.title,
                                mobileTitle: magazine.title,
                                image: magazine.titleImageUrl,
                                date: magazine.createdDate,
                                magazinePid: magazine.magazinePid,
                                description: magazine.description,
                                mobileDescription: magazine.mobileDescription
                            }
                        })
                    })
                }, "Magazine_".concat(magazine.magazinePid));
            })
        })
    });
};
/* harmony default export */ var Magazine = (MagazineSearchResult);
var Magazine_Wrapper = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-52261876-0"
})(Magazine_templateObject());
var Magazine_EmptyResultWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-52261876-1"
})(Magazine_templateObject1(), function(param) {
    var theme = param.theme;
    return "calc(100vh - ".concat(theme.size.appHeader.height, ")");
});
var Magazine_EmptyResultTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-52261876-2"
})(Magazine_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.typography.UI20SB;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray700;
});
var Magazine_EmptyResultOffer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-52261876-3"
})(Magazine_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.typography.UI14M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray400;
});

// EXTERNAL MODULE: ./src/components/molecules/ScrollTopStickyButton/index.tsx + 1 modules
var ScrollTopStickyButton = __webpack_require__(79771);
;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/SearchResult/Qna/index.tsx

function Qna_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  ",
        ";\n  & > div {\n    margin-right: 8px;\n  }\n"
    ]);
    Qna_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Qna_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  position: relative;\n  margin-right: 8px;\n"
    ]);
    Qna_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Qna_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  img {\n    border: 2px solid white;\n  }\n  ",
        ";\n"
    ]);
    Qna_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}













var QnaSearchResult = function(param) {
    var viewModel = param.viewModel;
    var ref, ref1, ref2;
    if (!((ref = viewModel.searchedQnaData) === null || ref === void 0 ? void 0 : (ref1 = ref.pages) === null || ref1 === void 0 ? void 0 : ref1.length)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResult_EmptySearchResult, {
            handleClickRequestButton: viewModel.handleClickRequestButton
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfiniteScroll/* default */.Z, {
                rootMargin: "0px 0px 0px 100px",
                isLoading: viewModel.isSearchedQnaLoading,
                hasNextPage: viewModel.hasSearchedQnaNextPage,
                fetchNextPage: viewModel.fetchSearchedQnaNextPage,
                children: (ref2 = viewModel.searchedQnaData) === null || ref2 === void 0 ? void 0 : ref2.pages.map(function(question) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionItem/* default */.Z, {
                        isPaidQuestion: false,
                        questionCard: question,
                        onClickQuestion: viewModel.onClickQuestion,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionItem/* default.BottomLeft */.Z.BottomLeft, {
                            children: question.answeredStatus === gql_schema/* QuestionAnsweredStatus.Answered */.G2.Answered ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Qna_QuestionBottomAnswerStatus, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Qna_QuestionDoctorImageWrapper, {
                                        children: question.answererProfileImageUrls.slice(0, 5).map(function(image, key) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Qna_QuestionDoctorImage, {
                                                imageKey: key,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage/* default */.ZP, {
                                                    width: 28,
                                                    height: 28,
                                                    objectFit: "cover",
                                                    loader: /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultDoctorProfile/* default */.Z, {}),
                                                    src: image,
                                                    alt: "답변한 의사 프로필 이미지"
                                                })
                                            }, "answered-doctor-".concat(key));
                                        })
                                    }),
                                    question.answererCount,
                                    "개의 답변"
                                ]
                            }) : question.question.status !== gql_schema/* QuestionStatus.AwaitingBasicAnswer */.xV.AwaitingBasicAnswer ? // 답변 중 / 답변 확인 중
                            // 목록
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Qna_QuestionBottomAnswerStatus, {
                                fontColor: question.answeredStatus === gql_schema/* QuestionAnsweredStatus.Answering */.G2.Answering ? styles_theme/* default.color.primary500 */.Z.color.primary500 : styles_theme/* default.color.blue500 */.Z.color.blue500,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLottieIcon/* default */.Z, {
                                        width: 24,
                                        height: 24,
                                        animationData: question.answeredStatus === gql_schema/* QuestionAnsweredStatus.Answering */.G2.Answering ? loading_dot_ongoing : loading_dot_wait,
                                        style: {
                                            marginRight: 8
                                        }
                                    }),
                                    question.answeredStatusText
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                        })
                    }, question.question.questionPid);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollTopStickyButton/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var Qna = (QnaSearchResult);
var Qna_QuestionBottomAnswerStatus = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5e4170fd-0"
})(Qna_templateObject(), function(param) {
    var theme = param.theme, fontColor = param.fontColor;
    return "\n    ".concat(theme.typography.UI14SB, ";\n    color: ").concat(fontColor !== null && fontColor !== void 0 ? fontColor : theme.color.gray700, ";\n  ");
});
var Qna_QuestionDoctorImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5e4170fd-1"
})(Qna_templateObject1());
var Qna_QuestionDoctorImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5e4170fd-2"
})(Qna_templateObject2(), function(param) {
    var imageKey = param.imageKey;
    return "\n    margin-left: -".concat(imageKey ? 8 : 0, "px;\n    z-index: ").concat(5 - imageKey, ";\n  ");
});

;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/SearchResult/index.tsx


function SearchResult_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: ",
        ";\n  ",
        ";\n"
    ]);
    SearchResult_templateObject = function _templateObject() {
        return data;
    };
    return data;
}















var DIRECT_SEARCH_KEYWORD_TYPE = {
    RECENT: "recent"
};
var SearchResult = function(param) {
    var viewModel = param.viewModel, qnaViewModel = param.qnaViewModel, magazineViewModel = param.magazineViewModel, doctorViewModel = param.doctorViewModel, isMobileWeb = param.isMobileWeb, hospitalViewModel = param.hospitalViewModel;
    var showModal = (0,useModal/* default */.Z)().showModal;
    var ref = (0,useReportModal/* default */.ZP)(), showReportModal = ref.showReportModal, onCloseReportModal = ref.onCloseReportModal, reportItems = ref.reportItems;
    var ref1 = (0,usePostReportModal/* default */.ZP)(), showPostReportModal = ref1.showReportModal, onClosePostReportModal = ref1.onCloseReportModal, reportPostData = ref1.reportData, reportPostItems = ref1.reportItems;
    var renderComponent = function() {
        switch(viewModel.selectedTabValue){
            case IntegratedSearchTabType.All:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Integrated, {
                    viewModel: viewModel,
                    doctorViewModel: doctorViewModel
                });
            case IntegratedSearchTabType.Qna:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Qna, {
                    viewModel: qnaViewModel
                });
            case IntegratedSearchTabType.Magazine:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Magazine, {
                    viewModel: magazineViewModel
                });
            case IntegratedSearchTabType.Doctor:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResult_Doctor, {
                    viewModel: doctorViewModel
                });
            case IntegratedSearchTabType.Hospital:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Hospital, {
                    hospitalViewModel: hospitalViewModel,
                    address: viewModel.getHeaderAddress(),
                    getCurrentLocation: viewModel.requestGeolocationPermission,
                    geolocationPermissionLoading: viewModel.geolocationPermissionLoading
                });
        }
    };
    (0,react.useEffect)(function() {
        if (!viewModel.modal.isOpen) {
            return;
        }
        showModal((0,_object_spread/* default */.Z)({}, viewModel.modal.info));
    }, [
        viewModel.modal
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyWrapper, {
                isMobileWeb: isMobileWeb,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DNSlideTab/* default */.Z, {
                    value: viewModel.selectedTabValue,
                    children: viewModel.INTEGRATED_SEARCH_RESULT_TABS.map(function(tab) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DNSlideTab/* default.Item */.Z.Item, {
                            label: tab.label,
                            isActive: tab.value === viewModel.selectedTabValue,
                            onClick: function() {
                                return viewModel.onClickTabItem(tab);
                            }
                        }, tab.key);
                    })
                })
            }),
            renderComponent(),
            reportItems && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportSelectModal/* default */.Z, {
                isVisible: showReportModal,
                onClose: onCloseReportModal,
                selectList: reportItems
            }),
            reportPostItems && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportSelectModal/* default */.Z, {
                isVisible: showPostReportModal,
                onClose: onClosePostReportModal,
                selectList: reportPostItems,
                title: (reportPostData === null || reportPostData === void 0 ? void 0 : reportPostData.isMine) ? "게시글 관리" : "신고하기"
            })
        ]
    });
};
/* harmony default export */ var components_SearchResult = (SearchResult);
var StickyWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d4fa050d-0"
})(SearchResult_templateObject(), zIndex/* zIndex.TabSticky */.W.TabSticky, function(param) {
    var theme = param.theme, isMobileWeb = param.isMobileWeb;
    return "\n    position: sticky;\n    top: ".concat(isMobileWeb ? theme.size.mobileWebHeader.height + theme.size.headerSearchBar.height : theme.size.headerSearchBar.height, "px;\n    background: ").concat(theme.color.white, ";\n  ");
});

;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/RecentKeyword/index.tsx

function RecentKeyword_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: 16px;\n  border-bottom: 8px solid ",
        ";\n"
    ]);
    RecentKeyword_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RecentKeyword_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    RecentKeyword_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function RecentKeyword_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 24px;\n  align-items: center;\n  ",
        ";\n  color: ",
        ";\n"
    ]);
    RecentKeyword_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function RecentKeyword_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 24px;\n  align-items: center;\n  ",
        ";\n  color: ",
        ";\n"
    ]);
    RecentKeyword_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function RecentKeyword_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 0 24px 16px;\n  flex-wrap: wrap;\n  gap: 8px;\n\n  > * {\n    margin-right: 0;\n  }\n"
    ]);
    RecentKeyword_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function RecentKeyword_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  color: ",
        ";\n  display: inline-flex;\n  align-items: center;\n  justify-contents: center;\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 40px;\n  padding: 8px 15px;\n  height: 38px;\n\n  & > div {\n    font-weight: 500;\n    font-size: 15px;\n    color: ",
        ";\n  }\n\n  & > button {\n    border: none;\n    z-index: 2;\n    padding: 0;\n    margin-left: 4px;\n  }\n"
    ]);
    RecentKeyword_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}






var RecentKeyWord = function(param) {
    var recentKeywordViewData = param.recentKeywordViewData, onSearchDirectKeyword = param.onSearchDirectKeyword, onDeleteItemRecentKeyword = param.onDeleteItemRecentKeyword, onDeleteAllRecentKeyword = param.onDeleteAllRecentKeyword;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !!recentKeywordViewData.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)(RecentKeyword_Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(RecentKeywordTopList, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentKeywordTitle, {
                            children: "최근 검색어"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentKeywordAllRemove, {
                            onClick: onDeleteAllRecentKeyword,
                            children: "전체 삭제"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentKeywordItemList, {
                    children: recentKeywordViewData.map(function(keyword) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RecentKeywordItem, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    role: "presentation",
                                    onClick: function() {
                                        return onSearchDirectKeyword(keyword, DIRECT_SEARCH_KEYWORD_TYPE.RECENT);
                                    },
                                    children: keyword
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    onClick: function() {
                                        return onDeleteItemRecentKeyword(keyword);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallDelete/* default */.Z, {
                                        color: styles_theme/* default.color.gray600 */.Z.color.gray600,
                                        size: 16
                                    })
                                })
                            ]
                        }, keyword);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var RecentKeyword = (RecentKeyWord);
var RecentKeyword_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8ee3011f-0"
})(RecentKeyword_templateObject(), function(param) {
    var theme = param.theme;
    return theme.color.gray30;
});
var RecentKeywordTopList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8ee3011f-1"
})(RecentKeyword_templateObject1());
var RecentKeywordTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-8ee3011f-2"
})(RecentKeyword_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.typography.UI13M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray600;
});
var RecentKeywordAllRemove = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-8ee3011f-3"
})(RecentKeyword_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.typography.UI13M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray400;
});
var RecentKeywordItemList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8ee3011f-4"
})(RecentKeyword_templateObject4());
var RecentKeywordItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8ee3011f-5"
})(RecentKeyword_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.typography.UI13M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray600;
}, function(param) {
    var theme = param.theme;
    return theme.color.white;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray100;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray700;
});

;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/components/HomeDiseaseSymptomSearch/index.tsx

function HomeDiseaseSymptomSearch_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  padding: 0 24px 16px;\n  margin: 0;\n"
    ]);
    HomeDiseaseSymptomSearch_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HomeDiseaseSymptomSearch_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  width: 100%;\n  padding: 8px 0;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n"
    ]);
    HomeDiseaseSymptomSearch_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HomeDiseaseSymptomSearch_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  ",
        ";\n  display: flex;\n  text-align: left;\n  width: 20px;\n  height: 20px;\n  align-items: center;\n"
    ]);
    HomeDiseaseSymptomSearch_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function HomeDiseaseSymptomSearch_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  ",
        ";\n  display: inline-flex;\n  align-items: center;\n  height: 30px;\n  margin-left: 8px;\n  text-align: left;\n"
    ]);
    HomeDiseaseSymptomSearch_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






var HomeDiseaseSymptomSearch = function(props) {
    var entryType = props.entryType, popularSymptomList = props.popularSymptomList, handleSymptomKeywordClick = props.handleSymptomKeywordClick, handleSearchDirectKeyword = props.handleSearchDirectKeyword, handleDeleteItemRecentKeyword = props.handleDeleteItemRecentKeyword, handleDeleteAllRecentKeyword = props.handleDeleteAllRecentKeyword, recentKeywordViewData = props.recentKeywordViewData;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            entryType === "symptom" && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AiNoticeBanner, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    entryType !== "symptom" && recentKeywordViewData.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentKeyword, {
                        onSearchDirectKeyword: handleSearchDirectKeyword,
                        recentKeywordViewData: recentKeywordViewData,
                        onDeleteItemRecentKeyword: handleDeleteItemRecentKeyword,
                        onDeleteAllRecentKeyword: handleDeleteAllRecentKeyword
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SymptomResultSection, {
                        title: "인기 검색어",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SymptomResultSection.Result, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PopularSearchSymptomKeywordContainer, {
                                children: popularSymptomList.map(function(symptom, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PopularSearchSymptomKeyword, {
                                        onClick: function() {
                                            return handleSymptomKeywordClick(symptom.symptomName);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopularSearchSymptomKeywordIndex, {
                                                children: index + 1
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopularSearchSymptomKeywordContent, {
                                                children: symptom.symptomName
                                            })
                                        ]
                                    }, symptom.symptomPublicId);
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_HomeDiseaseSymptomSearch = (HomeDiseaseSymptomSearch);
var PopularSearchSymptomKeywordContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c9be98f6-0"
})(HomeDiseaseSymptomSearch_templateObject());
var PopularSearchSymptomKeyword = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-c9be98f6-1"
})(HomeDiseaseSymptomSearch_templateObject1());
var PopularSearchSymptomKeywordIndex = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-c9be98f6-2"
})(HomeDiseaseSymptomSearch_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.color.primary700;
}, function(param) {
    var theme = param.theme;
    return theme.typography.UI15SB;
});
var PopularSearchSymptomKeywordContent = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-c9be98f6-3"
})(HomeDiseaseSymptomSearch_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.color.gray700;
}, function(param) {
    var theme = param.theme;
    return theme.typography.UI17SB;
});

// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(92563);
// EXTERNAL MODULE: ./src/components/atom/MaterialIcon.tsx
var MaterialIcon = __webpack_require__(17986);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(98240);
;// CONCATENATED MODULE: ./src/designComponents/organisms/DNSearchBar/index.tsx



function DNSearchBar_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n"
    ]);
    DNSearchBar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DNSearchBar_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n\n  border: none;\n  height: 48px;\n  width: 100%;\n  border-radius: 8px;\n\n  @media screen and (-webkit-min-device-pixel-ratio: 0) {\n    font-size: 16px;\n  }\n"
    ]);
    DNSearchBar_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DNSearchBar_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  position: absolute;\n  right: 12px;\n  border: none;\n  top: 50%;\n  transform: translate(0, -50%);\n  background: none;\n}\n"
    ]);
    DNSearchBar_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function DNSearchBar_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 2px;\n  border-radius: 8px;\n\n  ",
        ";\n"
    ]);
    DNSearchBar_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}





var DNSearchBar = function(_param) {
    var onSubmit = _param.onSubmit, onReset = _param.onReset, searchInputRef = _param.searchInputRef, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onSubmit",
        "onReset",
        "searchInputRef"
    ]);
    var inputRef = (0,react.useRef)(null);
    var ref = searchInputRef !== null && searchInputRef !== void 0 ? searchInputRef : inputRef;
    var onClickSubmit = function(e) {
        var ref1;
        e.preventDefault();
        (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.blur();
        onSubmit();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInputWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            onSubmit: onClickSubmit,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInputStyled, (0,_object_spread/* default */.Z)({
                    tabIndex: 0,
                    ref: searchInputRef !== null && searchInputRef !== void 0 ? searchInputRef : inputRef
                }, props)),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconContainer, {
                    children: [
                        !!props.value && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, {
                            type: "reset",
                            onClick: onReset,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                name: "cancel",
                                color: styles_theme/* default.color.gray600 */.Z.color.gray600
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, {
                            type: "submit",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                name: "search",
                                color: styles_theme/* default.color.gray600 */.Z.color.gray600
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var organisms_DNSearchBar = (DNSearchBar);
var SearchInputWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-69d6bebc-0"
})(DNSearchBar_templateObject());
var SearchInputStyled = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-69d6bebc-1"
})(DNSearchBar_templateObject1(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI16SB, ";\n    background: ").concat(theme.color.gray40, ";\n    color: ").concat(theme.color.gray700, ";\n    &::placeholder {\n      color: ").concat(theme.color.gray300, ";\n    }\n    padding: 0 76px 0 16px;\n  ");
});
var IconContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-69d6bebc-2"
})(DNSearchBar_templateObject2());
var IconWrapper = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-69d6bebc-3"
})(DNSearchBar_templateObject3(), function(param) {
    var theme = param.theme;
    return "\n    &: hover {\n      background: ".concat(theme.color.gray30, ";\n    };\n    &: active {\n      background: ").concat(theme.color.gray50, ";\n    }\n  ");
});

// EXTERNAL MODULE: ./src/utils/mobile/RNPlugins.tsx
var RNPlugins = __webpack_require__(10712);
;// CONCATENATED MODULE: ./src/designComponents/molecules/DNSearchHeader/index.tsx



function DNSearchHeader_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  align-items: center;\n  padding: 6px 24px 6px 0;\n\n  ",
        ";\n"
    ]);
    DNSearchHeader_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DNSearchHeader_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 16px;\n  padding: 2px;\n  border-radius: 8px;\n\n  ",
        ";\n"
    ]);
    DNSearchHeader_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var DNSearchHeader = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchBarWrapper, {
        id: "appHeader",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DNSearchHeader_IconWrapper, {
                onClick: RNPlugins/* historyBack */.$i,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                    name: "arrow_back_ios_new"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(organisms_DNSearchBar, (0,_object_spread/* default */.Z)({}, props))
        ]
    });
};
/* harmony default export */ var molecules_DNSearchHeader = (DNSearchHeader);
var SearchBarWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4b7cf748-0"
})(DNSearchHeader_templateObject(), function(param) {
    var theme = param.theme;
    return "\n    height: ".concat(theme.size.appHeader.height, ";\n    background: ").concat(theme.color.white, ";\n  ");
});
var DNSearchHeader_IconWrapper = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-4b7cf748-1"
})(DNSearchHeader_templateObject1(), function(param) {
    var theme = param.theme;
    return "\n    &: hover {\n      background: ".concat(theme.color.gray30, ";\n    };\n    &: active {\n      background: ").concat(theme.color.gray50, ";\n    }\n  ");
});

// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(22710);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ./src/hooks/Cuj/useAppInstallRequiredModal.tsx + 2 modules
var useAppInstallRequiredModal = __webpack_require__(28578);
// EXTERNAL MODULE: ./src/hooks/search/useInfiniteSearchNonF2fDoctors.ts
var useInfiniteSearchNonF2fDoctors = __webpack_require__(48115);
// EXTERNAL MODULE: ./src/services/doctor/DiagnosisCategoryService.ts
var DiagnosisCategoryService = __webpack_require__(33310);
// EXTERNAL MODULE: ./src/types/modal.ts
var types_modal = __webpack_require__(74701);
;// CONCATENATED MODULE: ./src/hooks/search/doctor/useSearchDoctorViewModel.tsx














var useSearchDoctorViewModel = function(param) {
    var homeSearchCategory = param.homeSearchCategory, keyword = param.keyword, tab = param.tab;
    var ref = (0,useModal/* default */.Z)(), showModal = ref.showModal, closeModal = ref.closeModal;
    var ref1 = (0,useAppInstallRequiredModal/* default */.Z)(), showAppInstallModal = ref1.showModal;
    var ref2 = (0,useCustomRouter/* default */.Z)(), moveToPage = ref2.moveToPage, pageName = ref2.pageName;
    var ref3 = (0,useInfiniteSearchNonF2fDoctors/* default */.Z)({
        request: {
            keyword: keyword,
            sortType: gql_schema/* DoctorSortType.Random */.tt.Random,
            page: 1,
            limit: 10,
            doctorType: gql_schema/* DoctorType.Doctor */.J4.Doctor,
            telemedicineEligibleTargetType: gql_schema/* TelemedicineEligibleTargetType.NightAndHolidayOnly */.H7.NightAndHolidayOnly
        }
    }, {
        enabled: IntegratedSearchTabType.Doctor === tab && !!keyword
    }), items = ref3.items, category = ref3.category, hasNextPage = ref3.hasNextPage, isLoading = ref3.isLoading, fetchNextPage = ref3.fetchNextPage;
    var onClickDoctor = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(doctorId) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                (0,logger/* coreLogger */.cl)({
                    eventName: "search_item_click",
                    pageName: pageName,
                    payload: {
                        keyword: keyword,
                        content_id: doctorId,
                        tab: IntegratedSearchTabType.Doctor
                    }
                });
                if ((0,RNPlugins/* isWebView */.vp)()) {
                    (0,RNPlugins/* sendPostMessageToNative */.T0)(RNPlugins/* NATIVE_POST_MESSAGE_TYPE.MOVE_TO_DOCTOR_DETAIL_PAGE_AFTER_DIAGNOSIS_TARGET_CHECK */.nn.MOVE_TO_DOCTOR_DETAIL_PAGE_AFTER_DIAGNOSIS_TARGET_CHECK, (0,_object_spread/* default */.Z)({
                        doctorId: doctorId
                    }, IntegratedSearchTabType.Doctor === tab ? category && {
                        categoryId: Number(category.id),
                        type: category.category === gql_schema/* MedicalCategoryType.Treatment */.Wk.Treatment ? DiagnosisCategoryService/* DepreactedCategoryType.Symptom */.Qy.Symptom : DiagnosisCategoryService/* DepreactedCategoryType.Subject */.Qy.Subject
                    } : homeSearchCategory && {
                        type: homeSearchCategory.category === gql_schema/* MedicalCategoryType.Treatment */.Wk.Treatment ? DiagnosisCategoryService/* DepreactedCategoryType.Symptom */.Qy.Symptom : DiagnosisCategoryService/* DepreactedCategoryType.Subject */.Qy.Subject,
                        categoryId: Number(homeSearchCategory.id)
                    }));
                    return [
                        2
                    ];
                }
                showModal({
                    type: types_modal/* MODAL_TYPE.ALERT */.f.ALERT,
                    props: {
                        title: "비대면 진료는 앱에서 할 수 있어요",
                        message: "닥터나우 앱을 다운로드하고 사용해보세요",
                        buttons: [
                            {
                                type: types_modal/* MODAL_BUTTON_TYPE.DEFAULT */.J.DEFAULT,
                                label: "닫기",
                                onClick: function() {
                                    return closeModal();
                                }
                            },
                            {
                                type: types_modal/* MODAL_BUTTON_TYPE.PRIMARY */.J.PRIMARY,
                                label: "다운로드",
                                onClick: function() {
                                    (0,logger/* coreLogger */.cl)({
                                        eventName: "search_doctor_item_click",
                                        pageName: pageName,
                                        payload: {
                                            content_id: doctorId,
                                            result_section: IntegratedSearchTabType.Doctor,
                                            tab: IntegratedSearchTabType.Doctor
                                        }
                                    });
                                    window.open("https://abr.ge/gtlbg3");
                                    closeModal();
                                }
                            }
                        ],
                        onClickOverlay: closeModal
                    }
                });
                return [
                    2
                ];
            });
        });
        return function onClickDoctor(doctorId) {
            return _ref.apply(this, arguments);
        };
    }();
    var moveToCategoryListScreen = function() {
        if ((0,RNPlugins/* isWebView */.vp)()) {
            (0,RNPlugins/* sendPostMessageToNative */.T0)(RNPlugins/* NATIVE_POST_MESSAGE_TYPE.MOVE_TO_CATEGORY_SELECT */.nn.MOVE_TO_CATEGORY_SELECT);
            return;
        }
        showAppInstallModal({
            title: "비대면 진료는 앱에서 확인할 수 있어요.",
            body: "진료 뿐만 아니라\n약 처방, 의료진 상담까지 가능해요!",
            installButtonText: "지금 설치하기",
            closeButtonText: "닫기"
        });
    };
    var handleClickRequestButton = function() {
        (0,logger/* coreLogger */.cl)({
            eventName: "request_additional_info_click",
            pageName: pageName,
            payload: {
                position: RequestButtonType.BOTTOM,
                keyword: keyword,
                section_name: "integrate_search_doctor"
            }
        });
        moveToPage({
            webLink: "".concat(common/* ROUTES.SEARCH */.Z6.SEARCH(keyword.replaceAll(" ", "+")).REQUEST_INFO.path),
            mobileScreenName: common/* ROUTES.SEARCH */.Z6.SEARCH(keyword.replaceAll(" ", "+")).REQUEST_INFO.appScreenName,
            params: {
                keyword: keyword
            }
        });
    };
    return {
        doctors: items,
        hasNextPage: !!hasNextPage,
        isLoading: isLoading,
        fetchNextPage: fetchNextPage,
        onClickDoctor: onClickDoctor,
        handleClickRequestButton: handleClickRequestButton,
        moveToCategoryListScreen: moveToCategoryListScreen,
        keyword: keyword
    };
};
/* harmony default export */ var doctor_useSearchDoctorViewModel = (useSearchDoctorViewModel);

// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(85244);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useInfiniteQuery.mjs + 1 modules
var useInfiniteQuery = __webpack_require__(59403);
// EXTERNAL MODULE: ./src/hooks/search/search.gql.impl.tsx
var search_gql_impl = __webpack_require__(41872);
;// CONCATENATED MODULE: ./src/hooks/search/hospital/useGetKeywordSearchHospitalInfiniteQuery.ts




var useGetKeywordSearchHospitalInfiniteQuery = function(variables, queryOptions) {
    return (0,useInfiniteQuery/* useInfiniteQuery */.N)([
        "getDiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPage",
        variables
    ], function(param) {
        var pageParam = param.pageParam;
        return search_gql_impl/* useGetDiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPageQuery.fetcher */.PJ.fetcher({
            request: (0,_object_spread/* default */.Z)({}, variables.request, pageParam)
        })();
    }, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, queryOptions), {
        getNextPageParam: function(lastPage) {
            var size = variables.request.size;
            if (lastPage.diseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPage.elements.length < size) {
                return undefined;
            }
            return {
                pivot: lastPage.diseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPage.pivot,
                pivotScore: lastPage.diseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPage.pivotScore
            };
        }
    }));
};
/* harmony default export */ var hospital_useGetKeywordSearchHospitalInfiniteQuery = (useGetKeywordSearchHospitalInfiniteQuery);

// EXTERNAL MODULE: ./src/parsers/search/index.ts
var search = __webpack_require__(3746);
;// CONCATENATED MODULE: ./src/hooks/search/hospital/useGetKeywordSearchHospitalInfinite.ts



var HOSPITAL_SIZE = 50;
var useGetKeywordSearchHospitalInfinite = function(param) {
    var keyword = param.keyword, latitude = param.latitude, longitude = param.longitude, _size = param.size, size = _size === void 0 ? HOSPITAL_SIZE : _size, _enabled = param.enabled, enabled = _enabled === void 0 ? true : _enabled;
    var ref = hospital_useGetKeywordSearchHospitalInfiniteQuery({
        request: {
            keyword: keyword,
            size: size,
            sortType: gql_schema/* HospitalSortType.Distance */.BB.Distance,
            geoPoint: {
                latitude: latitude,
                longitude: longitude
            }
        }
    }, {
        select: function(data) {
            return {
                pages: (0,search/* parseSearchResultHospitalVo */.ZX)(data.pages),
                pageParams: data.pageParams
            };
        },
        enabled: enabled && !!keyword && keyword.length > 0 && !!latitude && !!longitude
    }), hospitalData = ref.data, isHospitalLoading = ref.isLoading, hasHospitalNextPage = ref.hasNextPage, fetchHospitalNextPage = ref.fetchNextPage;
    return {
        hospitalData: hospitalData,
        isHospitalLoading: isHospitalLoading,
        hasHospitalNextPage: hasHospitalNextPage,
        fetchHospitalNextPage: fetchHospitalNextPage
    };
};
/* harmony default export */ var hospital_useGetKeywordSearchHospitalInfinite = (useGetKeywordSearchHospitalInfinite);

;// CONCATENATED MODULE: ./src/hooks/search/hospital/useSearchHospitalViewModel.ts






var useTotalSearchHospitalViewModel = function(param) {
    var keyword = param.keyword, tab = param.tab, latitude = param.latitude, longitude = param.longitude;
    var ref = (0,useCustomRouter/* default */.Z)(), pageName = ref.pageName, moveToPage = ref.moveToPage;
    var ref1 = hospital_useGetKeywordSearchHospitalInfinite({
        keyword: keyword,
        enabled: tab === IntegratedSearchTabType.Hospital,
        latitude: latitude,
        longitude: longitude
    }), hospitalData = ref1.hospitalData, isHospitalLoading = ref1.isHospitalLoading, hasHospitalNextPage = ref1.hasHospitalNextPage, fetchHospitalNextPage = ref1.fetchHospitalNextPage;
    var handleClickRequestButton = function() {
        (0,logger/* coreLogger */.cl)({
            eventName: "request_additional_info_click",
            pageName: pageName,
            payload: {
                position: RequestButtonType.BOTTOM,
                keyword: keyword,
                section_name: "integrate_search_hospital"
            }
        });
        moveToPage({
            webLink: "".concat(common/* ROUTES.SEARCH */.Z6.SEARCH(keyword.replaceAll(" ", "+")).REQUEST_INFO.path),
            mobileScreenName: common/* ROUTES.SEARCH */.Z6.SEARCH(keyword.replaceAll(" ", "+")).REQUEST_INFO.appScreenName,
            params: {
                keyword: keyword
            }
        });
    };
    var onClickMoveNative = function(hospitalPid) {
        if ((0,RNPlugins/* isWebView */.vp)()) {
            (0,RNPlugins/* sendPostMessageToNative */.T0)(RNPlugins/* NATIVE_POST_MESSAGE_TYPE.MOVE_TO_PAGE */.nn.MOVE_TO_PAGE, {
                screenName: common/* ROUTES.HOSPITAL.DETAIL.appScreenName */.Z6.HOSPITAL.DETAIL.appScreenName,
                params: {
                    hospitalPid: hospitalPid
                }
            });
        }
    };
    var onClickLogHospital = function(hospitalPid) {
        (0,logger/* coreLogger */.cl)({
            eventName: "search_item_click",
            pageName: pageName,
            payload: {
                keyword: keyword,
                content_id: hospitalPid,
                tab: IntegratedSearchTabType.Hospital
            }
        });
    };
    return {
        hospitalData: hospitalData,
        isHospitalLoading: isHospitalLoading,
        hasHospitalNextPage: hasHospitalNextPage,
        fetchHospitalNextPage: fetchHospitalNextPage,
        handleClickRequestButton: handleClickRequestButton,
        onClickMoveNative: onClickMoveNative,
        onClickLogHospital: onClickLogHospital
    };
};
/* harmony default export */ var useSearchHospitalViewModel = (useTotalSearchHospitalViewModel);

// EXTERNAL MODULE: ./src/hooks/search/magazine/useGetKeywordSearchMagazineInfinite.ts + 1 modules
var useGetKeywordSearchMagazineInfinite = __webpack_require__(58104);
;// CONCATENATED MODULE: ./src/hooks/search/magazine/useSearchMagazineViewModel.ts





var useSearchMagazineViewModel = function(param) {
    var keyword = param.keyword, tab = param.tab;
    var ref = (0,useCustomRouter/* default */.Z)(), pageName = ref.pageName, moveToPage = ref.moveToPage;
    var ref1 = (0,useGetKeywordSearchMagazineInfinite/* default */.Z)({
        keyword: keyword,
        enabled: tab === IntegratedSearchTabType.Magazine
    }), magazinesData = ref1.magazinesData, isMagazinesLoading = ref1.isMagazinesLoading, hasMagazinesNextPage = ref1.hasMagazinesNextPage, fetchMagazinesNextPage = ref1.fetchMagazinesNextPage;
    var onClickMoveNative = function(magazinePid) {
        moveToPage({
            webLink: "".concat(common/* ROUTES.MAGAZINE.DETAIL.path */.Z6.MAGAZINE.DETAIL.path, "/").concat(magazinePid),
            mobileScreenName: common/* ROUTES.MAGAZINE.DETAIL.appScreenName */.Z6.MAGAZINE.DETAIL.appScreenName,
            params: {
                id: magazinePid
            }
        });
    };
    var onClickLogMagazine = function(magazinePid) {
        (0,logger/* coreLogger */.cl)({
            pageName: pageName,
            eventName: "search_item_click",
            payload: {
                keyword: keyword,
                content_id: magazinePid,
                tab: IntegratedSearchTabType.Magazine
            }
        });
    };
    var handleClickRequestButton = function() {
        (0,logger/* coreLogger */.cl)({
            eventName: "request_additional_info_click",
            pageName: pageName,
            payload: {
                position: RequestButtonType.BOTTOM,
                keyword: keyword,
                section_name: "integrate_search_magazine"
            }
        });
        moveToPage({
            webLink: "".concat(common/* ROUTES.SEARCH */.Z6.SEARCH(keyword.replaceAll(" ", "+")).REQUEST_INFO.path),
            mobileScreenName: common/* ROUTES.SEARCH */.Z6.SEARCH(keyword.replaceAll(" ", "+")).REQUEST_INFO.appScreenName,
            params: {
                keyword: keyword
            }
        });
    };
    return {
        magazinesData: magazinesData,
        isMagazinesLoading: isMagazinesLoading,
        hasMagazinesNextPage: hasMagazinesNextPage,
        fetchMagazinesNextPage: fetchMagazinesNextPage,
        onClickMoveNative: onClickMoveNative,
        onClickLogMagazine: onClickLogMagazine,
        handleClickRequestButton: handleClickRequestButton
    };
};
/* harmony default export */ var magazine_useSearchMagazineViewModel = (useSearchMagazineViewModel);

// EXTERNAL MODULE: ./src/hooks/search/qna/useGetKeywordQuestionCardInfinite.ts + 1 modules
var useGetKeywordQuestionCardInfinite = __webpack_require__(66127);
;// CONCATENATED MODULE: ./src/hooks/search/qna/useSearchQuestionViewModel.ts









var useSearchQuestionViewModel = function(param) {
    var keyword = param.keyword, tab = param.tab;
    var ref = (0,useCustomRouter/* default */.Z)(), moveToPage = ref.moveToPage, pageName = ref.pageName;
    var token = (0,es.useRecoilValue)(auth/* tokenState */.J1);
    var setShowAuthModal = (0,hooks_useAuthModal/* default */.Z)().setShowAuthModal;
    var ref1 = (0,useReportModal/* default */.ZP)(), showReportModal = ref1.showReportModal, onShowReportModal = ref1.onShowReportModal, onCloseReportModal = ref1.onCloseReportModal, reportItems = ref1.reportItems;
    var ref2 = (0,useGetKeywordQuestionCardInfinite/* default */.Z)({
        keyword: keyword,
        enabled: tab === IntegratedSearchTabType.Qna
    }), searchedQnaData = ref2.searchedQnaData, isSearchedQnaLoading = ref2.isSearchedQnaLoading, hasSearchedQnaNextPage = ref2.hasSearchedQnaNextPage, fetchSearchedQnaNextPage = ref2.fetchSearchedQnaNextPage;
    // 질문 클릭 -> 상세페이지 이동
    var onClickQuestion = function(param) {
        var sectionName = param.sectionName, questionId = param.questionId;
        moveToPage({
            webLink: "".concat(common/* ROUTES.QNA.DETAIL.path */.Z6.QNA.DETAIL.path, "/").concat(questionId),
            mobileScreenName: common/* ROUTES.QNA.DETAIL.appScreenName */.Z6.QNA.DETAIL.appScreenName,
            params: {
                questionId: questionId
            }
        });
        (0,logger/* coreLogger */.cl)({
            eventName: "search_item_click",
            pageName: pageName,
            payload: {
                keyword: keyword,
                content_id: questionId,
                tab: IntegratedSearchTabType.Qna,
                sectionName: sectionName !== null && sectionName !== void 0 ? sectionName : ""
            }
        });
    };
    // 질문 신고하기
    var onShowModal = function(e, data) {
        e.stopPropagation();
        if (!token) {
            // 로그인 정보가 없는 경우
            setShowAuthModal(true);
            return;
        }
        onShowReportModal(data);
    };
    var handleClickRequestButton = function() {
        (0,logger/* coreLogger */.cl)({
            eventName: "request_additional_info_click",
            pageName: pageName,
            payload: {
                position: RequestButtonType.BOTTOM,
                keyword: keyword,
                section_name: "integrate_search_qna"
            }
        });
        moveToPage({
            webLink: "".concat(common/* ROUTES.SEARCH */.Z6.SEARCH(keyword.replaceAll(" ", "+")).REQUEST_INFO.path),
            mobileScreenName: common/* ROUTES.SEARCH */.Z6.SEARCH(keyword.replaceAll(" ", "+")).REQUEST_INFO.appScreenName,
            params: {
                keyword: keyword
            }
        });
    };
    return {
        searchedQnaData: searchedQnaData,
        isSearchedQnaLoading: isSearchedQnaLoading,
        hasSearchedQnaNextPage: hasSearchedQnaNextPage,
        fetchSearchedQnaNextPage: fetchSearchedQnaNextPage,
        onClickQuestion: onClickQuestion,
        onShowModal: onShowModal,
        pageName: pageName,
        showReportModal: showReportModal,
        onCloseReportModal: onCloseReportModal,
        reportItems: reportItems,
        handleClickRequestButton: handleClickRequestButton
    };
};
/* harmony default export */ var qna_useSearchQuestionViewModel = (useSearchQuestionViewModel);

// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(22386);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(81541);
// EXTERNAL MODULE: ../../node_modules/lodash/isNaN.js
var lodash_isNaN = __webpack_require__(16951);
var isNaN_default = /*#__PURE__*/__webpack_require__.n(lodash_isNaN);
// EXTERNAL MODULE: ../../node_modules/lodash/toNumber.js
var toNumber = __webpack_require__(7642);
var toNumber_default = /*#__PURE__*/__webpack_require__.n(toNumber);
// EXTERNAL MODULE: ./src/hooks/auth/useSetAuthOnScreenFocus.tsx
var useSetAuthOnScreenFocus = __webpack_require__(95392);
// EXTERNAL MODULE: ./src/hooks/hospital/search/useGetUserAddressByLocation.ts
var useGetUserAddressByLocation = __webpack_require__(77688);
;// CONCATENATED MODULE: ./src/hooks/search/useGetKeywordIntegratedSearchDoctor.ts


var KEYWORD_SEARCH_SIZE = 4;
var useGetKeywordIntegratedSearchDoctor = function(keyword) {
    var ref = (0,search_gql_impl/* useGetDoctorsByKeywordQuery */.Q_)({
        request: {
            keyword: keyword,
            size: KEYWORD_SEARCH_SIZE
        }
    }, {
        select: function(data) {
            return (0,search/* parseKeywordIntegratedDoctorVo */.H2)(data);
        },
        enabled: keyword.length > 0
    }), keywordSearchDoctor = ref.data;
    return {
        keywordSearchDoctor: keywordSearchDoctor
    };
};
/* harmony default export */ var search_useGetKeywordIntegratedSearchDoctor = (useGetKeywordIntegratedSearchDoctor);

;// CONCATENATED MODULE: ./src/hooks/search/useGetKeywordIntegratedSearchHospital.ts



var useGetKeywordIntegratedSearchHospital_KEYWORD_SEARCH_SIZE = 4;
var useGetKeywordIntegratedSearchHospital = function(keyword, latitude, longitude) {
    var ref = (0,search_gql_impl/* useGetDiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPageQuery */.PJ)({
        request: {
            keyword: keyword,
            size: useGetKeywordIntegratedSearchHospital_KEYWORD_SEARCH_SIZE,
            sortType: gql_schema/* HospitalSortType.Distance */.BB.Distance,
            geoPoint: {
                latitude: latitude,
                longitude: longitude
            }
        }
    }, {
        select: search/* parseKeywordIntegratedSearchHospital */.oe,
        enabled: keyword.length > 0
    }), keywordSearchHospital = ref.data;
    return {
        keywordSearchHospital: keywordSearchHospital
    };
};
/* harmony default export */ var search_useGetKeywordIntegratedSearchHospital = (useGetKeywordIntegratedSearchHospital);

;// CONCATENATED MODULE: ./src/hooks/search/useGetPopularKeywordsForDiseaseSymptomSearch.ts


var useGetPopularKeywordsForDiseaseSymptomSearch = function() {
    var ref = (0,search_gql_impl/* useGetPopularKeywordsQuery */.pn)(), data = ref.data, isLoading = ref.isLoading;
    var popularSymptomList = (0,search/* parseGetPopularSymptomsVo */.E4)(data).popularSymptomList;
    return {
        popularSymptomList: popularSymptomList,
        isLoading: isLoading
    };
};
/* harmony default export */ var search_useGetPopularKeywordsForDiseaseSymptomSearch = (useGetPopularKeywordsForDiseaseSymptomSearch);

// EXTERNAL MODULE: ./node_modules/recoil-persist/dist/index.js
var dist = __webpack_require__(6983);
;// CONCATENATED MODULE: ./src/recoil/atoms/search/index.ts


var persistAtom = (0,dist/* recoilPersist */.J)().persistAtom;
var recentHomeSearchKeywordListState = (0,es.atom)({
    key: "recentHomeSearchKeywordListState",
    default: [],
    effects_UNSTABLE: [
        persistAtom
    ]
});
// button을 보지 않기를 원하는 경우
var isPreventStickyButtonOpenState = (0,es.atom)({
    key: "isPreventStickyButtonOpenState",
    default: false,
    effects_UNSTABLE: [
        persistAtom
    ]
});

// EXTERNAL MODULE: ./src/services/hospital/SearchHospitalService.ts
var SearchHospitalService = __webpack_require__(23144);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(95210);
;// CONCATENATED MODULE: ./src/services/search/HomeSearchService.ts




var HomeSearchService = /*#__PURE__*/ function() {
    "use strict";
    function HomeSearchService() {
        (0,_class_call_check/* default */.Z)(this, HomeSearchService);
    }
    HomeSearchService.parseDoctorSearchResult = function parseDoctorSearchResult(data) {
        if (data) {
            return this.doctorSearchResultParser({
                getDoctorsByKeyword: {
                    elements: data.flatMap(function(page) {
                        return page.getDoctorsByKeyword.elements;
                    }),
                    pivot: data[data.length - 1].getDoctorsByKeyword.pivot
                }
            });
        }
        return [];
    };
    HomeSearchService.doctorSearchResultParser = function doctorSearchResultParser(data) {
        return data.getDoctorsByKeyword.elements.map(function(doctor) {
            var ref;
            var _professionalDepartmentName, ref1;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, doctor), {
                doctorId: Number(doctor.id),
                profileUrl: doctor.profileUrl,
                doctorName: doctor.doctorName,
                hospitalName: doctor.hospitalName,
                reviewCount: Number(doctor.reviewCount),
                reviewAverageRating: doctor.reviewAverageRating,
                isAbsent: doctor.isAbsent,
                maxWaitingCount: doctor.maxWaitingCount,
                readyForVideoCall: doctor.readyForVideoCall,
                professionalDepartment: {
                    doctorId: Number(doctor.id),
                    professionalDepartmentId: Number(doctor.professionalDepartment.professionalDepartmentId),
                    professionalDepartmentName: (_professionalDepartmentName = doctor.professionalDepartment.professionalDepartmentName) !== null && _professionalDepartmentName !== void 0 ? _professionalDepartmentName : ""
                },
                diagnosisCount: {
                    doctorId: Number(doctor.id),
                    count: Number((ref1 = (ref = doctor.diagnosisCount) === null || ref === void 0 ? void 0 : ref.count) !== null && ref1 !== void 0 ? ref1 : 0)
                }
            });
        });
    };
    HomeSearchService.getNewKeywordList = function getNewKeywordList(originalKeywordList, keyword) {
        var keywordIdx = originalKeywordList.indexOf(keyword);
        if (keywordIdx !== -1) {
            originalKeywordList.splice(keywordIdx, 1);
        }
        originalKeywordList.unshift(keyword);
        if (originalKeywordList.length > 5) {
            originalKeywordList = originalKeywordList.slice(0, 5);
        }
        return (0,_to_consumable_array/* default */.Z)(originalKeywordList);
    };
    return HomeSearchService;
}();

// EXTERNAL MODULE: ./src/utils/url.ts
var url = __webpack_require__(74735);
;// CONCATENATED MODULE: ./src/hooks/search/useGetKeywordIntegratedSearchMagazine.tsx


var useGetKeywordIntegratedSearchMagazine_KEYWORD_SEARCH_SIZE = 4;
var useGetKeywordIntegratedSearchMagazine = function(keyword) {
    var ref = (0,search_gql_impl/* useGetKeywordSearchMagazineQuery */.FX)({
        request: {
            keyword: keyword,
            size: useGetKeywordIntegratedSearchMagazine_KEYWORD_SEARCH_SIZE
        }
    }, {
        select: search/* parseKeywordIntegratedSearchMagazineVo */.Gq,
        enabled: keyword.length > 0
    }), keywordSearchMagazine = ref.data, isKeywordSearchMagazineLoading = ref.isLoading;
    return {
        keywordSearchMagazine: keywordSearchMagazine,
        isKeywordSearchMagazineLoading: isKeywordSearchMagazineLoading
    };
};
/* harmony default export */ var search_useGetKeywordIntegratedSearchMagazine = (useGetKeywordIntegratedSearchMagazine);

;// CONCATENATED MODULE: ./src/hooks/search/useGetKeywordIntegratedSearchPost.tsx


var useGetKeywordIntegratedSearchPost_KEYWORD_SEARCH_SIZE = 4;
var useGetKeywordIntegratedSearchPost = function(keyword) {
    var ref = (0,search_gql_impl/* useGetKeywordSearchPostQuery */.W6)({
        request: {
            keyword: keyword,
            size: useGetKeywordIntegratedSearchPost_KEYWORD_SEARCH_SIZE
        }
    }, {
        select: search/* parseKeywordIntegratedSearchPostVo */.so,
        enabled: keyword.length > 0
    }), keywordSearchPost = ref.data, isKeywordSearchPostLoading = ref.isLoading;
    return {
        keywordSearchPost: keywordSearchPost,
        isKeywordSearchPostLoading: isKeywordSearchPostLoading
    };
};
/* harmony default export */ var search_useGetKeywordIntegratedSearchPost = (useGetKeywordIntegratedSearchPost);

;// CONCATENATED MODULE: ./src/hooks/search/useGetKeywordIntegratedSearchQna.tsx


var useGetKeywordIntegratedSearchQna_KEYWORD_SEARCH_SIZE = 4;
var useGetKeywordIntegratedSearchQna = function(keyword) {
    var ref = (0,search_gql_impl/* useGetkeywordSearchQnaQuery */.A$)({
        request: {
            keyword: keyword,
            size: useGetKeywordIntegratedSearchQna_KEYWORD_SEARCH_SIZE
        }
    }, {
        select: search/* parseKeywordIntegratedSearchQnaVo */.Vp,
        enabled: keyword.length > 0
    }), keywordSearchQna = ref.data, isKeywordSearchQnaLoading = ref.isLoading;
    return {
        keywordSearchQna: keywordSearchQna,
        isKeywordSearchQnaLoading: isKeywordSearchQnaLoading
    };
};
/* harmony default export */ var search_useGetKeywordIntegratedSearchQna = (useGetKeywordIntegratedSearchQna);

;// CONCATENATED MODULE: ./src/hooks/search/useHomeSearchViewModel.ts































var INITIAL_MODAL_STATE = {
    isOpen: false,
    info: {
        type: undefined,
        props: {
            title: "",
            buttons: []
        }
    }
};
var INTEGRATED_SEARCH_RESULT_TABS = [
    {
        key: 0,
        label: "통합",
        value: IntegratedSearchTabType.All
    },
    {
        key: 1,
        label: "비대면 진료",
        value: IntegratedSearchTabType.Doctor
    },
    {
        key: 2,
        label: "방문 예약",
        value: IntegratedSearchTabType.Hospital
    },
    {
        key: 3,
        label: "실시간 의료상담",
        value: IntegratedSearchTabType.Qna
    },
    {
        key: 4,
        label: "건강 매거진",
        value: IntegratedSearchTabType.Magazine
    }, 
];
var DOCTOR_LIST_LIMIT = 4;
var useHomeSearchViewModel = function(props) {
    (0,useSetAuthOnScreenFocus/* default */.Z)();
    var ref = (0,useCustomRouter/* default */.Z)(), router = ref.router, moveToPage = ref.moveToPage, pageName = ref.pageName;
    var searchParam = props.keyword, entryType = props.entryType;
    var _query = router.query, queryLatitude = _query.latitude, queryLongitude = _query.longitude;
    var initialCoord = (0,react.useMemo)(function() {
        if (!queryLatitude || !queryLongitude) {
            return SearchHospitalService/* SearchHospitalService.initializeUserCoordinate */.h.initializeUserCoordinate();
        }
        var latitude = toNumber_default()(queryLatitude);
        var longitude = toNumber_default()(queryLongitude);
        if (isNaN_default()(latitude) || isNaN_default()(longitude)) {
            return SearchHospitalService/* SearchHospitalService.initializeUserCoordinate */.h.initializeUserCoordinate();
        }
        return {
            latitude: latitude,
            longitude: longitude
        };
    }, [
        queryLatitude,
        queryLongitude
    ]);
    var ref1 = (0,react.useState)(), regionByDepth = ref1[0], setRegionByDepth = ref1[1];
    var ref2 = (0,react.useState)(initialCoord), coordinate = ref2[0], setCoordinate = ref2[1];
    var ref3 = (0,useGetUserAddressByLocation/* default */.Z)(coordinate.latitude, coordinate.longitude), tmp = ref3.data, sigunguDongli = tmp === void 0 ? SearchHospitalService/* SearchHospitalService.initializeUserSigunguDongli */.h.initializeUserSigunguDongli() : tmp, addressRefetch = ref3.refetch;
    var keywordSearchQna = search_useGetKeywordIntegratedSearchQna(searchParam).keywordSearchQna;
    var keywordSearchPost = search_useGetKeywordIntegratedSearchPost(searchParam).keywordSearchPost;
    var keywordSearchMagazine = search_useGetKeywordIntegratedSearchMagazine(searchParam).keywordSearchMagazine;
    var keywordSearchDoctor = search_useGetKeywordIntegratedSearchDoctor(searchParam).keywordSearchDoctor;
    var keywordSearchHospital = search_useGetKeywordIntegratedSearchHospital(searchParam, coordinate.latitude, coordinate.longitude).keywordSearchHospital;
    var ref4 = (0,useInfiniteSearchNonF2fDoctors/* default */.Z)({
        request: {
            keyword: searchParam,
            sortType: gql_schema/* DoctorSortType.Random */.tt.Random,
            page: 1,
            limit: DOCTOR_LIST_LIMIT,
            doctorType: gql_schema/* DoctorType.Doctor */.J4.Doctor,
            telemedicineEligibleTargetType: gql_schema/* TelemedicineEligibleTargetType.NightAndHolidayOnly */.H7.NightAndHolidayOnly
        }
    }, {
        enabled: !!searchParam
    }), items = ref4.items, hasNextPage = ref4.hasNextPage, category = ref4.category;
    var trimmedDoctors = (0,_to_consumable_array/* default */.Z)(items).splice(0, DOCTOR_LIST_LIMIT - 1);
    var ref5 = (0,useModal/* default */.Z)(), closeCurrentModal = ref5.closeModal;
    var showToast = (0,useToast/* default */.Z)().showToast;
    var shouldSnackBarOpen = router.query.shouldSnackBarOpen;
    var ref6 = (0,react.useState)(false), isSnackBarOpen = ref6[0], setIsSnackBarOpen = ref6[1];
    var ref7;
    var ref8 = (0,react.useState)((ref7 = !!searchParam) !== null && ref7 !== void 0 ? ref7 : false), isSearchResultShow = ref8[0], setIsSearchResultShow = ref8[1];
    var ref9 = (0,react.useState)(searchParam), inputValue = ref9[0], setInputValue = ref9[1];
    var ref10 = (0,react.useState)(searchParam), keyword = ref10[0], setKeyword = ref10[1];
    var searchInputRef = (0,react.useRef)(null);
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,es.useRecoilState)(recentHomeSearchKeywordListState), 2), recentKeywordList = ref11[0], setRecentKeywordList = ref11[1];
    var ref12 = (0,react.useState)((0,_object_spread/* default */.Z)({}, INITIAL_MODAL_STATE)), modal = ref12[0], setModal = ref12[1];
    var ref13 = (0,react.useState)(false), geolocationPermissionLoading = ref13[0], setGeolocationPermissionLoading = ref13[1];
    var ref14 = (0,react.useState)([]), recentKeywordViewData = ref14[0], setRecentKeywordViewData = ref14[1];
    var ref15 = (0,react.useState)(searchParam ? false : true), isVisibleRecentKeyword = ref15[0], setIsVisibleRecentKeyword = ref15[1];
    var _tab;
    var ref16 = (0,react.useState)((_tab = router.query.tab) !== null && _tab !== void 0 ? _tab : IntegratedSearchTabType.All), selectedTabValue = ref16[0], setSelectedTabValue = ref16[1];
    var getHeaderAddress = function() {
        var address = "".concat(sigunguDongli.sigungu, " ").concat(sigunguDongli.dongLi);
        if (regionByDepth === null || regionByDepth === void 0 ? void 0 : regionByDepth.siDoName) {
            if (!regionByDepth.siGunGuName && !regionByDepth.legalEupMyeonDongName) {
                address = "".concat(regionByDepth.siDoName);
            } else if (regionByDepth.siGunGuName && !regionByDepth.legalEupMyeonDongName) {
                address = "".concat(regionByDepth.siDoName, " ").concat(regionByDepth.siGunGuName);
            } else if (regionByDepth.siGunGuName && regionByDepth.legalEupMyeonDongName) {
                address = "".concat(regionByDepth.siGunGuName, " ").concat(regionByDepth.legalEupMyeonDongName);
            } else if (!regionByDepth.siGunGuName && regionByDepth.legalEupMyeonDongName) {
                address = "".concat(regionByDepth.siDoName, " ").concat(regionByDepth.legalEupMyeonDongName);
            }
        }
        return address;
    };
    var initRegionFilter = function() {
        setRegionByDepth(undefined);
    };
    var requestGeolocationPermission = (0,react.useCallback)(function() {
        if (!navigator.geolocation) {
            showToast({
                message: "다른 브라우저로 해당 기능을 이용해주세요"
            });
            setCoordinate({
                latitude: initialCoord.latitude,
                longitude: initialCoord.longitude
            });
            return;
        }
        setGeolocationPermissionLoading(true);
        navigator.geolocation.getCurrentPosition(function(param) {
            var coords = param.coords;
            initRegionFilter();
            setGeolocationPermissionLoading(false);
            (0,url/* updateSearchParams */.aM)([
                {
                    key: "latitude",
                    value: coords.latitude
                },
                {
                    key: "longitude",
                    value: coords.longitude
                }, 
            ]);
        }, function() {
            setGeolocationPermissionLoading(false);
            showToast({
                message: "위치 사용을 허용을 해야 내 위치 설정이 가능해요"
            });
        }, {
            enableHighAccuracy: true
        });
    }, [
        initialCoord,
        showToast
    ]);
    var setSearchKeyword = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(newKeyword) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsSearchResultShow(true);
                        setKeyword(newKeyword.trim());
                        return [
                            4,
                            (0,url/* updateSearchParams */.aM)([
                                {
                                    key: "keyword",
                                    value: newKeyword
                                }
                            ])
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function setSearchKeyword(newKeyword) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleInputChange = function(value) {
        setInputValue(value);
    };
    var closeModal = function() {
        closeCurrentModal();
        setModal(INITIAL_MODAL_STATE);
    };
    var handleSubmit = function() {
        var ref;
        var newKeywordList = HomeSearchService.getNewKeywordList((0,_to_consumable_array/* default */.Z)(recentKeywordList), keyword);
        setRecentKeywordList(newKeywordList);
        setIsVisibleRecentKeyword(false);
        (ref = searchInputRef.current) === null || ref === void 0 ? void 0 : ref.blur();
        router.push({
            query: {
                keyword: keyword,
                tab: selectedTabValue
            }
        });
    };
    // 검색 버튼 클릭
    var handleChangeKeyword = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!inputValue.trim()) {
                            setModal({
                                isOpen: true,
                                info: {
                                    type: types_modal/* MODAL_TYPE.ALERT */.f.ALERT,
                                    props: {
                                        title: "검색어를 입력해주세요.",
                                        buttons: [
                                            {
                                                type: types_modal/* MODAL_BUTTON_TYPE.BOLD */.J.BOLD,
                                                label: "확인",
                                                onClick: function() {
                                                    return closeModal();
                                                }
                                            }
                                        ]
                                    }
                                }
                            });
                            return [
                                2
                            ];
                        }
                        if (inputValue.length < 2) {
                            setModal({
                                isOpen: true,
                                info: {
                                    type: types_modal/* MODAL_TYPE.ALERT */.f.ALERT,
                                    props: {
                                        title: "2글자 이상 입력해 주세요.",
                                        message: "더 정확도 높은 결과를 볼 수 있어요.",
                                        buttons: [
                                            {
                                                type: types_modal/* MODAL_BUTTON_TYPE.BOLD */.J.BOLD,
                                                label: "확인",
                                                onClick: function() {
                                                    return closeModal();
                                                }
                                            }
                                        ]
                                    }
                                }
                            });
                            return [
                                2
                            ];
                        }
                        (0,logger/* coreLogger */.cl)({
                            eventName: "click_search",
                            pageName: pageName,
                            payload: {
                                section: "search_bar",
                                keyword: inputValue,
                                entry_point: entryType
                            }
                        });
                        return [
                            4,
                            setSearchKeyword(inputValue)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleChangeKeyword() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleResetSearchKeyword = function(e) {
        var ref;
        e === null || e === void 0 ? void 0 : e.preventDefault();
        setInputValue("");
        (ref = searchInputRef.current) === null || ref === void 0 ? void 0 : ref.blur();
        setIsVisibleRecentKeyword(true);
        setIsSearchResultShow(false);
        (0,url/* deleteQueryString */.OB)("keyword");
    };
    // 최근 검색어 / 자주 찾는 검색어로 검색
    var handleSearchDirectKeyword = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(keyword) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        (0,logger/* coreLogger */.cl)({
                            eventName: "click_search",
                            pageName: pageName,
                            payload: {
                                section: "recent",
                                keyword: keyword,
                                entry_point: entryType
                            }
                        });
                        return [
                            4,
                            setSearchKeyword(keyword)
                        ];
                    case 1:
                        _state.sent();
                        setInputValue(keyword);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSearchDirectKeyword(keyword) {
            return _ref.apply(this, arguments);
        };
    }();
    // 최근 검색어 선택 삭제
    var handleDeleteItemRecentKeyword = function(keyword) {
        var filter = recentKeywordViewData.filter(function(recentKeyword) {
            return keyword !== recentKeyword;
        });
        setRecentKeywordList(filter);
    };
    // 최근 검색어 전체 삭제
    var handleDeleteAllRecentKeyword = function() {
        setRecentKeywordList([]);
    };
    var handleSnackBarClose = function() {
        setIsSnackBarOpen(false);
    };
    var handleClickRequestButton = function(buttonPosition) {
        (0,logger/* coreLogger */.cl)({
            eventName: "request_additional_info_click",
            pageName: pageName,
            payload: {
                position: buttonPosition,
                keyword: keyword
            }
        });
        moveToPage({
            webLink: "".concat(common/* ROUTES.SEARCH */.Z6.SEARCH(keyword.replaceAll(" ", "+"), entryType).REQUEST_INFO.path),
            mobileScreenName: common/* ROUTES.SEARCH */.Z6.SEARCH(keyword.replaceAll(" ", "+"), entryType).REQUEST_INFO.appScreenName,
            params: {
                keyword: keyword
            }
        });
    };
    var handleClickQuestion = function(questionId) {
        (0,logger/* coreLogger */.cl)({
            eventName: "search_item_click",
            pageName: pageName,
            payload: {
                keyword: keyword,
                content_id: questionId,
                tab: IntegratedSearchTabType.All,
                result_section: IntegratedSearchTabType.Qna
            }
        });
        moveToPage({
            webLink: "".concat(common/* ROUTES.QNA.DETAIL.path */.Z6.QNA.DETAIL.path, "/").concat(questionId),
            mobileScreenName: common/* ROUTES.QNA.DETAIL.appScreenName */.Z6.QNA.DETAIL.appScreenName,
            params: {
                questionId: questionId,
                result_section: IntegratedSearchTabType.Qna
            }
        });
    };
    var handleClickDoctor = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(doctor) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (!(0,RNPlugins/* isWebView */.vp)()) {
                    return [
                        2
                    ];
                }
                (0,logger/* coreLogger */.cl)({
                    eventName: "search_item_click",
                    pageName: pageName,
                    payload: {
                        keyword: keyword,
                        content_id: doctor.doctorId,
                        tab: IntegratedSearchTabType.All,
                        result_section: IntegratedSearchTabType.Doctor
                    }
                });
                (0,RNPlugins/* sendPostMessageToNative */.T0)(RNPlugins/* NATIVE_POST_MESSAGE_TYPE.MOVE_TO_PAGE */.nn.MOVE_TO_PAGE, {
                    screenName: common/* APP_SCREEN_NAME.DOCTOR_DETAIL */.x.DOCTOR_DETAIL,
                    params: {
                        doctorId: doctor.doctorId,
                        type: "subject",
                        entry: "search"
                    }
                });
                return [
                    2
                ];
            });
        });
        return function handleClickDoctor(doctor) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClickMagazine = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(magazine) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                (0,logger/* coreLogger */.cl)({
                    eventName: "search_item_click",
                    pageName: pageName,
                    payload: {
                        keyword: keyword,
                        content_id: magazine.magazinePid,
                        tab: IntegratedSearchTabType.All,
                        result_section: IntegratedSearchTabType.Magazine
                    }
                });
                moveToPage({
                    webLink: "".concat(common/* ROUTES.MAGAZINE.DETAIL.path */.Z6.MAGAZINE.DETAIL.path, "/").concat(magazine.magazinePid),
                    mobileScreenName: common/* ROUTES.MAGAZINE.DETAIL.appScreenName */.Z6.MAGAZINE.DETAIL.appScreenName,
                    params: {
                        id: magazine.magazinePid
                    }
                });
                return [
                    2
                ];
            });
        });
        return function handleClickMagazine(magazine) {
            return _ref.apply(this, arguments);
        };
    }();
    var goToAppHospital = function(hospitalPid) {
        if ((0,RNPlugins/* isWebView */.vp)()) {
            (0,logger/* coreLogger */.cl)({
                eventName: "search_item_click",
                pageName: pageName,
                payload: {
                    keyword: keyword,
                    content_id: hospitalPid,
                    tab: IntegratedSearchTabType.All,
                    result_section: IntegratedSearchTabType.Hospital
                }
            });
            (0,RNPlugins/* sendPostMessageToNative */.T0)(RNPlugins/* NATIVE_POST_MESSAGE_TYPE.MOVE_TO_PAGE */.nn.MOVE_TO_PAGE, {
                screenName: common/* ROUTES.HOSPITAL.DETAIL.appScreenName */.Z6.HOSPITAL.DETAIL.appScreenName,
                params: {
                    hospitalPid: hospitalPid
                }
            });
        }
    };
    var handleClickMoreData = (0,react.useCallback)(function(type) {
        return function() {
            (0,logger/* coreLogger */.cl)({
                eventName: "search_item_more_click",
                pageName: pageName,
                payload: {
                    keyword: keyword,
                    result_section: type
                }
            });
            moveToPage({
                webLink: "".concat(common/* ROUTES.COMMON.SEARCH.path */.Z6.COMMON.SEARCH.path, "?").concat(entryType ? "entryType=".concat(entryType) : "", "&keyword=").concat(keyword.replaceAll(" ", "+")),
                mobileScreenName: common/* ROUTES.COMMON.SEARCH.appScreenName */.Z6.COMMON.SEARCH.appScreenName,
                params: {
                    keyword: keyword
                }
            });
        };
    }, [
        keyword
    ]);
    var onChangeTabByMoreData = function(type) {
        (0,logger/* coreLogger */.cl)({
            eventName: "search_item_more_click",
            pageName: pageName,
            payload: {
                keyword: keyword,
                result_section: type
            }
        });
        if ((0,RNPlugins/* isWebView */.vp)() && type === IntegratedSearchTabType.Doctor && category) {
            (0,RNPlugins/* sendPostMessageToNative */.T0)(RNPlugins/* NATIVE_POST_MESSAGE_TYPE.MOVE_TO_DOCTOR_LIST_WITH_TARGET_CHECK */.nn.MOVE_TO_DOCTOR_LIST_WITH_TARGET_CHECK, {
                type: category.category,
                id: category.id
            });
            return;
        }
        setSelectedTabValue(type);
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    var popularSymptomList = search_useGetPopularKeywordsForDiseaseSymptomSearch().popularSymptomList;
    var handleSymptomKeywordClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(keyword) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsSearchResultShow(true);
                        return [
                            4,
                            setSearchKeyword(keyword)
                        ];
                    case 1:
                        _state.sent();
                        setInputValue(keyword);
                        (0,logger/* coreLogger */.cl)({
                            eventName: "click_search",
                            pageName: pageName,
                            payload: {
                                keyword: keyword,
                                section: "popular_symptom",
                                entry_point: entryType
                            }
                        });
                        moveToPage({
                            webLink: "".concat(common/* ROUTES.SEARCH */.Z6.SEARCH(keyword.replaceAll(" ", "+"), entryType).SEARCH_RESULT.path),
                            mobileScreenName: common/* ROUTES.SEARCH */.Z6.SEARCH(keyword.replaceAll(" ", "+"), entryType).SEARCH_RESULT.appScreenName,
                            params: {
                                keyword: keyword
                            }
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSymptomKeywordClick(keyword) {
            return _ref.apply(this, arguments);
        };
    }();
    // 탭 클릭 handler
    var onClickTabItem = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(tab) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        (0,logger/* coreLogger */.cl)({
                            eventName: "integrated_search_tab_click",
                            pageName: pageName,
                            payload: {
                                tab: tab.value
                            }
                        });
                        setSelectedTabValue(tab.value);
                        return [
                            4,
                            (0,url/* updateSearchParams */.aM)([
                                {
                                    key: "tab",
                                    value: tab.value
                                }
                            ])
                        ];
                    case 1:
                        _state.sent();
                        window.scrollTo({
                            top: 0,
                            behavior: "smooth"
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function onClickTabItem(tab) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (!shouldSnackBarOpen) {
            return;
        }
        setIsSnackBarOpen(true);
        router.replace("/search");
    }, []);
    (0,react.useEffect)(function() {
        if (keyword) {
            handleSubmit();
            setIsSearchResultShow(true);
        }
    }, [
        keyword
    ]);
    (0,react.useEffect)(function() {
        if (!router.query.keyword) {
            setKeyword("");
            setIsSearchResultShow(false);
        }
    }, [
        router.asPath,
        router.query.keyword
    ]);
    (0,react.useEffect)(function() {
        setRecentKeywordViewData(recentKeywordList);
    }, [
        recentKeywordList
    ]);
    (0,react.useEffect)(function() {
        var focusInput = function() {
            var ref;
            return searchInputRef === null || searchInputRef === void 0 ? void 0 : (ref = searchInputRef.current) === null || ref === void 0 ? void 0 : ref.focus();
        };
        focusInput();
    }, []);
    (0,react.useEffect)(function() {
        if (queryLatitude && queryLongitude) {
            setCoordinate({
                latitude: toNumber_default()(queryLatitude),
                longitude: toNumber_default()(queryLongitude)
            });
        }
    }, [
        queryLatitude,
        queryLongitude
    ]);
    (0,react.useEffect)(function() {
        addressRefetch();
    }, [
        coordinate
    ]);
    return {
        isVisibleRecentKeyword: isVisibleRecentKeyword,
        handleInputChange: handleInputChange,
        handleSnackBarClose: handleSnackBarClose,
        handleSubmit: handleSubmit,
        handleResetSearchKeyword: handleResetSearchKeyword,
        handleSearchDirectKeyword: handleSearchDirectKeyword,
        handleDeleteItemRecentKeyword: handleDeleteItemRecentKeyword,
        handleDeleteAllRecentKeyword: handleDeleteAllRecentKeyword,
        handleChangeKeyword: handleChangeKeyword,
        searchInputRef: searchInputRef,
        inputValue: inputValue,
        keyword: keyword,
        isSnackBarOpen: isSnackBarOpen,
        recentKeywordViewData: recentKeywordViewData.filter(function(item) {
            return typeof item === "string";
        }),
        setIsVisibleRecentKeyword: setIsVisibleRecentKeyword,
        handleClickRequestButton: handleClickRequestButton,
        modal: modal,
        handleClickQuestion: handleClickQuestion,
        handleClickDoctor: handleClickDoctor,
        handleClickMagazine: handleClickMagazine,
        handleClickMoreData: handleClickMoreData,
        handleSymptomKeywordClick: handleSymptomKeywordClick,
        popularSymptomList: popularSymptomList,
        isSearchResultShow: isSearchResultShow,
        INTEGRATED_SEARCH_RESULT_TABS: INTEGRATED_SEARCH_RESULT_TABS,
        selectedTabValue: selectedTabValue,
        onClickTabItem: onClickTabItem,
        onChangeTabByMoreData: onChangeTabByMoreData,
        keywordSearchQna: keywordSearchQna,
        keywordSearchMagazine: keywordSearchMagazine,
        keywordSearchDoctor: keywordSearchDoctor,
        keywordSearchHospital: keywordSearchHospital,
        goToAppHospital: goToAppHospital,
        getHeaderAddress: getHeaderAddress,
        requestGeolocationPermission: requestGeolocationPermission,
        coordinate: coordinate,
        geolocationPermissionLoading: geolocationPermissionLoading,
        hasNoData: !(keywordSearchQna === null || keywordSearchQna === void 0 ? void 0 : keywordSearchQna.elements.length) && !(keywordSearchPost === null || keywordSearchPost === void 0 ? void 0 : keywordSearchPost.elements.length) && !(keywordSearchMagazine === null || keywordSearchMagazine === void 0 ? void 0 : keywordSearchMagazine.elements.length) && !(keywordSearchHospital === null || keywordSearchHospital === void 0 ? void 0 : keywordSearchHospital.elements.length) && !(keywordSearchDoctor === null || keywordSearchDoctor === void 0 ? void 0 : keywordSearchDoctor.elements.length),
        doctors: trimmedDoctors,
        hasMoreDoctors: !!hasNextPage,
        category: category
    };
};
/* harmony default export */ var search_useHomeSearchViewModel = (useHomeSearchViewModel);

// EXTERNAL MODULE: ./src/hooks/useScreenFocus.tsx
var useScreenFocus = __webpack_require__(50341);
// EXTERNAL MODULE: ./src/types/app.ts
var app = __webpack_require__(9912);
;// CONCATENATED MODULE: ./src/components/templates/mobile/home/HomeSearchTemplate/index.tsx

function HomeSearchTemplate_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: sticky;\n  z-index: ",
        ";\n\n  ",
        ";\n"
    ]);
    HomeSearchTemplate_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


















var HomeSearchTemplate = function(param) {
    var client = param.client, entryType = param.entryType, keyword = param.keyword;
    (0,useScreenFocus/* default */.Z)();
    var showToast = (0,useToast/* default */.Z)().showToast;
    var viewModel = search_useHomeSearchViewModel({
        client: client,
        keyword: keyword,
        entryType: entryType
    });
    var qnaViewModel = qna_useSearchQuestionViewModel({
        keyword: viewModel.keyword,
        tab: viewModel.selectedTabValue
    });
    var magazineViewModel = magazine_useSearchMagazineViewModel({
        keyword: viewModel.keyword,
        tab: viewModel.selectedTabValue
    });
    var doctorViewModel = doctor_useSearchDoctorViewModel({
        homeSearchCategory: viewModel.category,
        keyword: viewModel.keyword,
        tab: viewModel.selectedTabValue
    });
    var hospitalViewModel = useSearchHospitalViewModel({
        keyword: viewModel.keyword,
        tab: viewModel.selectedTabValue,
        latitude: viewModel.coordinate.latitude,
        longitude: viewModel.coordinate.longitude
    });
    (0,react.useEffect)(function() {
        if (!viewModel.isSnackBarOpen) {
            return;
        }
        showToast({
            message: "소중한 의견을 남겨주셔서 감사합니다."
        });
    }, [
        viewModel.isSnackBarOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateLayout/* default.Wrapper */.Z.Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Content */.Z.Content, {
            children: [
                client.clientType === app/* ClientType.WEB */.B.WEB && /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs/* default.Wrapper */.Z.Wrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs/* default */.Z, {
                        visible: true,
                        name: "통합검색",
                        type: "search",
                        path: "".concat(common/* ROUTES.SEARCH */.Z6.SEARCH().HOME.path)
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeSearchTemplate_SearchBarWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(molecules_DNSearchHeader, {
                        placeholder: entryType === "symptom" ? "감기, 코로나, 목이 따가워요" : "증상, 질병, 병원을 검색해보세요",
                        onChange: function(e) {
                            return viewModel.handleInputChange(e.target.value);
                        },
                        value: viewModel.inputValue || "",
                        onSubmit: viewModel.handleChangeKeyword,
                        onReset: viewModel.handleResetSearchKeyword,
                        searchInputRef: viewModel.searchInputRef
                    })
                }),
                !viewModel.isSearchResultShow && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_HomeDiseaseSymptomSearch, {
                    entryType: entryType,
                    popularSymptomList: viewModel.popularSymptomList,
                    handleSymptomKeywordClick: viewModel.handleSymptomKeywordClick,
                    handleDeleteItemRecentKeyword: viewModel.handleDeleteItemRecentKeyword,
                    handleDeleteAllRecentKeyword: viewModel.handleDeleteAllRecentKeyword,
                    handleSearchDirectKeyword: viewModel.handleSearchDirectKeyword,
                    recentKeywordViewData: viewModel.recentKeywordViewData
                }),
                viewModel.isSearchResultShow && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SearchResult, {
                    viewModel: viewModel,
                    qnaViewModel: qnaViewModel,
                    magazineViewModel: magazineViewModel,
                    doctorViewModel: doctorViewModel,
                    isMobileWeb: client.clientType === app/* ClientType.MOBILE_WEB */.B.MOBILE_WEB,
                    hospitalViewModel: hospitalViewModel
                })
            ]
        })
    });
};
/* harmony default export */ var home_HomeSearchTemplate = (HomeSearchTemplate);
var HomeSearchTemplate_SearchBarWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bfc79092-0"
})(HomeSearchTemplate_templateObject(), zIndex/* zIndex.AppHeader */.W.AppHeader, function(param) {
    var theme = param.theme;
    return "\n    top: ".concat(theme.client.clientType === app/* ClientType.MOBILE_WEB */.B.MOBILE_WEB ? theme.size.mobileWebHeader.height : 0, "px;\n  ");
});

;// CONCATENATED MODULE: ./src/pages/search/index.tsx
// PageDescription: 통합검색 페이지





var DEFAULT_IMAGE_HEIGHT = 600;
var DEFAULT_IMAGE_WIDTH = 315;
var EPageType;
(function(EPageType) {
    EPageType[EPageType["SYMPTOM_SEARCH"] = 0] = "SYMPTOM_SEARCH";
    EPageType[EPageType["SEARCH_RESULT"] = 1] = "SEARCH_RESULT";
    EPageType[EPageType["INTEGRATED_SEARCH"] = 2] = "INTEGRATED_SEARCH";
})(EPageType || (EPageType = {}));
var getPageType = function(entryType, keyword) {
    if (entryType === "symptom") {
        return EPageType.SYMPTOM_SEARCH;
    }
    if (keyword) {
        return EPageType.SEARCH_RESULT;
    }
    return EPageType.INTEGRATED_SEARCH;
};
var getSeoContents = function(pageType, keyword) {
    if (pageType === EPageType.SEARCH_RESULT) {
        var _NEXT_PUBLIC_SEARCH_RESULT_OG_IMAGE;
        return {
            title: "".concat(keyword, " 검색결과 - 닥터나우"),
            description: "증상, 질병, 병원, 의료진 Q&A 등 필요한 모든 정보를 확인해 보세요.",
            imageUrl: (_NEXT_PUBLIC_SEARCH_RESULT_OG_IMAGE = "https://doctornow-front-images.s3.ap-northeast-2.amazonaws.com/og-searchresult.png") !== null && _NEXT_PUBLIC_SEARCH_RESULT_OG_IMAGE !== void 0 ? _NEXT_PUBLIC_SEARCH_RESULT_OG_IMAGE : "https://doctornow-front-images.s3.ap-northeast-2.amazonaws.com/og-searchresult.png"
        };
    }
    var _NEXT_PUBLIC_SYMPTOM_SEARCH_OG_IMAGE;
    return {
        title: "증상검색 - 닥터나우",
        description: "증상만 검색해도 내가 알고 싶은 정보를 쉽고 빠르게 찾을 수 있어요.",
        imageUrl: (_NEXT_PUBLIC_SYMPTOM_SEARCH_OG_IMAGE = "https://doctornow-front-images.s3.ap-northeast-2.amazonaws.com/og-symptomsearch.png") !== null && _NEXT_PUBLIC_SYMPTOM_SEARCH_OG_IMAGE !== void 0 ? _NEXT_PUBLIC_SYMPTOM_SEARCH_OG_IMAGE : "https://doctornow-front-images.s3.ap-northeast-2.amazonaws.com/og-symptomsearch.png"
    };
};
var SearchPage = function(props) {
    var entryType = props.entryType, client = props.client, keyword = props.keyword;
    var ref = getSeoContents(getPageType(entryType, keyword), keyword), title = ref.title, description = ref.description, imageUrl = ref.imageUrl;
    var router = (0,next_router.useRouter)();
    var tab = router.query.tab;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: title,
                description: description,
                openGraph: {
                    type: "website",
                    title: title,
                    description: description,
                    locale: "ko-KR",
                    siteName: "닥터나우",
                    images: [
                        {
                            url: imageUrl,
                            width: DEFAULT_IMAGE_HEIGHT,
                            height: DEFAULT_IMAGE_WIDTH,
                            alt: title
                        }, 
                    ],
                    defaultImageHeight: DEFAULT_IMAGE_HEIGHT,
                    defaultImageWidth: DEFAULT_IMAGE_WIDTH
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(home_HomeSearchTemplate, {
                entryType: entryType,
                client: client,
                keyword: keyword
            })
        ]
    });
};
SearchPage.Layout = DefaultLayout/* default */.Z;
var __N_SSP = true;
/* harmony default export */ var pages_search = (SearchPage);


/***/ }),

/***/ 33310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qy": function() { return /* binding */ DepreactedCategoryType; },
/* harmony export */   "ZP": function() { return /* binding */ DiagnosisCategoryService; },
/* harmony export */   "a9": function() { return /* binding */ CategoryType; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95210);

var NonBenefitSymptomId;
(function(NonBenefitSymptomId) {
    NonBenefitSymptomId["Hairloss"] = "9";
    NonBenefitSymptomId["Acne"] = "11";
    NonBenefitSymptomId["Diet"] = "12";
    NonBenefitSymptomId["GongJinDan"] = "109";
    NonBenefitSymptomId["OrientalBeauty"] = "605";
    NonBenefitSymptomId["OtherOrientalTreatments"] = "610";
})(NonBenefitSymptomId || (NonBenefitSymptomId = {}));
var DepreactedCategoryType;
(function(DepreactedCategoryType) {
    DepreactedCategoryType["Symptom"] = "symptom";
    DepreactedCategoryType["Subject"] = "subject";
})(DepreactedCategoryType || (DepreactedCategoryType = {}));
var CategoryType;
(function(CategoryType) {
    CategoryType["Treatment"] = "treatment";
    CategoryType["Department"] = "department";
})(CategoryType || (CategoryType = {}));
var DiagnosisCategoryService = /*#__PURE__*/ function() {
    "use strict";
    function DiagnosisCategoryService() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, DiagnosisCategoryService);
    }
    DiagnosisCategoryService.isNonBenefitCategory = function isNonBenefitCategory(type, categoryId) {
        if (!type || !categoryId) {
            return false;
        }
        switch(type){
            case CategoryType.Treatment:
                {
                    switch(categoryId){
                        case NonBenefitSymptomId.Hairloss:
                        case NonBenefitSymptomId.Acne:
                        case NonBenefitSymptomId.Diet:
                        case NonBenefitSymptomId.GongJinDan:
                        case NonBenefitSymptomId.OrientalBeauty:
                        case NonBenefitSymptomId.OtherOrientalTreatments:
                            return true;
                        default:
                            return false;
                    }
                }
            case CategoryType.Department:
                {
                    return false;
                }
        }
    };
    return DiagnosisCategoryService;
}();
DiagnosisCategoryService.getDiagnosisCategoryType = function(deprecatedType) {
    switch(deprecatedType){
        case DepreactedCategoryType.Subject:
            return CategoryType.Department;
        case DepreactedCategoryType.Symptom:
            return CategoryType.Treatment;
    }
};
DiagnosisCategoryService.getDeprecatedCategoryType = function(categoryType) {
    switch(categoryType){
        case CategoryType.Department:
            return DepreactedCategoryType.Subject;
        case CategoryType.Treatment:
            return DepreactedCategoryType.Symptom;
    }
};



/***/ }),

/***/ 37072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ HeaderType; }
/* harmony export */ });
var HeaderType;
(function(HeaderType) {
    HeaderType["WithMobileHeader"] = "withMobileHeader";
})(HeaderType || (HeaderType = {}));


/***/ }),

/***/ 92563:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function extends_() {
  extends_ = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return extends_.apply(this, arguments);
}

function _extends() {
  return extends_.apply(this, arguments);
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6577,1498,4329,9535,1743,9004,3281,5247,3454,2549,4913,3137,8502,1662,2026,9446,180,5066,9973,9774,2888,179], function() { return __webpack_exec__(68389); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);